var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    height: 144,
    viewBox: "0 0 1366 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 144,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 291,
    transform: "translate(-0.417 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.578 0.161)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.161 -0.162)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.228 -20.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.9,89.588h-4.1l-4.108-4.448-4.111,4.448H579.944l-3.4,3.67-3.414-3.67H568.32v1.837h4.1l4.124,4.447,4.108-4.447h10.634l3.4-3.67,3.4,3.671h4.81Z",
    transform: "translate(-459.451 -52.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.066-104.269v-4.44l4.123-4.448-4.123-4.433v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.439l-4.108,4.434,4.108,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-532.055 141.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.328-43.61h4.113l4.112,4.448,4.108-4.448H716.3l3.4-3.67,3.4,3.67h4.81v-1.852h-4.1l-4.108-4.432-4.108,4.432H704.952l-3.4,3.685-3.4-3.685h-4.826Z",
    transform: "translate(-566.316 63.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.367-6.593v4.44L778.259,2.28l4.108,4.448V18.206l3.41,3.686-3.411,3.671v5.2h1.708v-4.44l4.123-4.432-4.123-4.448V5.966l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-638.921 26.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.883,89.59h-4.1l-4.108-4.447L340.55,89.59H329.931l-3.414,3.67-3.4-3.67h-4.81v1.837h4.1l4.108,4.447,4.124-4.447h10.619l3.415-3.67,3.4,3.67h4.81Z",
    transform: "translate(-245.722 -52.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.054-104.267v-4.44l4.108-4.448-4.108-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.438l-4.108,4.434,4.108,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-318.327 141.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.315-43.608h4.1l4.123,4.447,4.108-4.448h10.619l3.415-3.67,3.4,3.67h4.81V-45.46h-4.1l-4.108-4.432-4.124,4.432H454.939l-3.4,3.685-3.414-3.685h-4.81Z",
    transform: "translate(-352.587 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.355-6.593v4.44L528.247,2.28l4.108,4.448V18.206l3.4,3.686-3.4,3.67v5.2h1.708v-4.44l4.108-4.432-4.108-4.448V5.965l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-425.193 26.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.871,89.591h-4.1l-4.124-4.447-4.108,4.447H79.9l-3.4,3.67-3.4-3.671H68.3v1.837h4.1L76.5,95.876l4.108-4.448H91.247l3.4-3.67,3.414,3.67h4.81Z",
    transform: "translate(-31.994 -52.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.949-104.267v-4.44l4.108-4.448-4.108-4.433v-11.479l-3.4-3.685,3.4-3.67v-5.2h-1.708v4.438l-4.124,4.434,4.124,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-104.506 141.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3-43.608h4.1l4.108,4.448,4.123-4.448h10.619l3.4-3.67,3.414,3.67h4.811V-45.46h-4.1l-4.124-4.432-4.108,4.432H204.925l-3.414,3.686-3.4-3.686H193.3Z",
    transform: "translate(-138.858 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.337-6.592v4.44l-4.109,4.433,4.109,4.448V18.207l3.4,3.686-3.4,3.67v5.2h1.708v-4.44l4.108-4.432-4.108-4.448V5.966l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-211.46 26.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.222,89.591h-4.117l-4.108-4.447-4.108,4.447h-10.634l-3.4,3.671-3.4-3.67h-4.823v1.837h4.114l4.108,4.448,4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.826Z",
    transform: "translate(181.815 -52.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.715-43.608h4.1L-48.5-39.16l4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.826V-45.46h-4.117l-4.108-4.432-4.108,4.432H-45.106l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(74.874 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.237-6.591v4.44L28.113,2.282,32.236,6.73V18.209l3.4,3.686-3.4,3.67v5.2h1.708V26.326l4.108-4.432-4.108-4.448V5.968L30.53,2.282l3.415-3.67v-5.2Z",
    transform: "translate(2.357 26.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.9,359.657h-4.1l-4.108-4.447-4.111,4.447H579.943l-3.4,3.686-3.415-3.686h-4.81v1.852h4.1l4.124,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.45 -283.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.065,165.8v-4.436l4.123-4.437-4.123-4.448V141l-3.4-3.67,3.4-3.685v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-532.054 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.327,226.474h4.113l4.112,4.433,4.108-4.433h10.635l3.4-3.686,3.4,3.686h4.81v-1.852h-4.1l-4.108-4.448-4.108,4.448H704.951l-3.4,3.67-3.4-3.67h-4.825Z",
    transform: "translate(-566.315 -167.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.367,263.582v4.425l-4.108,4.448,4.108,4.437v11.49l3.411,3.671-3.411,3.67v5.2h1.708V296.5l4.123-4.448-4.124-4.448V276.125l-3.4-3.67,3.4-3.685v-5.187Z",
    transform: "translate(-638.921 -204.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.882,359.657h-4.1l-4.108-4.447-4.124,4.447H329.93l-3.414,3.686-3.4-3.686h-4.81v1.853h4.1l4.108,4.433,4.123-4.432h10.619l3.415-3.686,3.4,3.686h4.81Z",
    transform: "translate(-245.721 -283.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.053,165.8v-4.436l4.108-4.437-4.108-4.448V141l-3.4-3.67,3.4-3.686v-5.2h-1.707v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.685-3.4,3.67v5.2Z",
    transform: "translate(-318.326 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.313,226.477h4.1l4.124,4.433,4.108-4.433h10.619l3.415-3.686,3.4,3.686h4.81v-1.852h-4.1l-4.108-4.447-4.124,4.447H454.937l-3.4,3.67-3.414-3.67h-4.81Z",
    transform: "translate(-352.586 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.352,263.582v4.425l-4.108,4.448,4.108,4.437v11.49l3.4,3.671-3.4,3.671v5.2h1.708V296.5l4.108-4.448L534.06,287.6V276.125l-3.4-3.671,3.4-3.685v-5.187Z",
    transform: "translate(-425.191 -204.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,359.659h-4.1l-4.124-4.448-4.108,4.447H79.9l-3.4,3.686-3.4-3.685h-4.81v1.852h4.1l4.108,4.433,4.108-4.433H91.246l3.4-3.686,3.415,3.686h4.81Z",
    transform: "translate(-31.993 -283.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.947,165.8v-4.436l4.108-4.437-4.108-4.448V141l-3.4-3.67,3.4-3.686v-5.2H157.24v4.441l-4.123,4.447,4.124,4.432v11.479l3.4,3.685-3.4,3.671v5.2Z",
    transform: "translate(-104.505 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,226.477h4.1l4.108,4.432,4.124-4.433H216.25l3.4-3.686,3.414,3.686h4.81v-1.852h-4.1l-4.123-4.447-4.108,4.447H204.922l-3.415,3.67-3.4-3.67H193.3Z",
    transform: "translate(-138.854 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.334,263.584v4.425l-4.109,4.448,4.109,4.437v11.49l3.4,3.671-3.4,3.671v5.2h1.708V296.5l4.108-4.448-4.108-4.448V276.127l-3.4-3.67,3.4-3.685v-5.187Z",
    transform: "translate(-211.457 -204.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.224,359.661h-4.116l-4.108-4.447-4.108,4.448h-10.634l-3.4,3.686-3.4-3.686h-4.823v1.851h4.114l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.826Z",
    transform: "translate(181.817 -283.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.715,226.477h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825v-1.852h-4.116l-4.108-4.448-4.108,4.447H-45.106l-3.4,3.671-3.4-3.67h-4.81Z",
    transform: "translate(74.874 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.232,263.584v4.425l-4.124,4.448,4.124,4.437v11.49l3.4,3.67-3.4,3.67v5.2H33.94V296.5l4.108-4.447-4.108-4.447v-11.48l-3.414-3.67,3.415-3.686v-5.187Z",
    transform: "translate(2.361 -204.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.893,629.831h-4.1l-4.108-4.447-4.114,4.447H579.941l-3.4,3.671-3.415-3.671h-4.81v1.837h4.1l4.124,4.448,4.107-4.447h10.635l3.4-3.671,3.4,3.671h4.81Z",
    transform: "translate(-459.448 -514.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.065,435.976v-4.44l4.123-4.448-4.124-4.433V411.162l-3.4-3.67,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-532.054 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.325,496.633h4.113l4.112,4.447,4.108-4.447h10.635l3.4-3.671,3.4,3.671h4.81V494.78h-4.1l-4.108-4.432-4.108,4.432H704.949l-3.4,3.686-3.4-3.685h-4.825Z",
    transform: "translate(-566.314 -398.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.364,533.65v4.44l-4.108,4.433,4.108,4.448v11.479l3.411,3.686-3.411,3.671v5.2h1.707v-4.44l4.124-4.433-4.124-4.448V546.208l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-638.919 -435.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.879,629.831h-4.1l-4.108-4.447-4.124,4.447H329.927l-3.414,3.671-3.4-3.671H318.3v1.838h4.1l4.108,4.448,4.123-4.448h10.619L344.67,628l3.4,3.67h4.81Z",
    transform: "translate(-245.718 -514.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.051,435.976v-4.44l4.108-4.448-4.108-4.433V411.162l-3.4-3.671,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.447v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-318.324 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,496.634h4.1l4.124,4.448,4.108-4.447h10.619l3.415-3.67,3.4,3.67h4.81v-1.852h-4.1l-4.108-4.432-4.123,4.432H454.934l-3.4,3.685-3.415-3.685h-4.81Z",
    transform: "translate(-352.583 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.352,533.65v4.441l-4.108,4.432,4.108,4.448v11.479l3.4,3.686-3.4,3.671v5.2h1.708v-4.441l4.108-4.433-4.108-4.448V546.208l-3.4-3.685,3.4-3.671v-5.2Z",
    transform: "translate(-425.191 -435.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.865,629.833h-4.1l-4.123-4.447-4.108,4.447H79.9L76.5,633.5l-3.4-3.671h-4.81v1.837h4.1l4.108,4.448,4.108-4.448H91.241l3.4-3.67,3.415,3.671h4.811Z",
    transform: "translate(-31.988 -514.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.946,435.977v-4.44l4.108-4.448-4.108-4.433V411.162l-3.4-3.67,3.4-3.671v-5.2h-1.708v4.425l-4.123,4.447,4.124,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-104.504 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,496.635h4.1l4.108,4.448,4.124-4.448h10.619l3.4-3.67,3.415,3.671h4.81v-1.852h-4.1l-4.123-4.432-4.108,4.432H204.92l-3.415,3.686-3.4-3.685H193.3Z",
    transform: "translate(-138.853 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.328,533.653v4.44l-4.11,4.433,4.11,4.448v11.479l3.4,3.686-3.4,3.669v5.2h1.709v-4.439l4.109-4.433-4.108-4.448V546.211l-3.4-3.686,3.4-3.671v-5.2Z",
    transform: "translate(-211.451 -435.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.224,629.833h-4.116l-4.108-4.447-4.108,4.447h-10.635l-3.4,3.672-3.4-3.671h-4.823v1.837h4.114l4.108,4.448,4.108-4.448h10.634l3.4-3.671,3.4,3.67h4.825Z",
    transform: "translate(181.817 -514.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.716,496.634h4.1l4.108,4.448,4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.825v-1.852h-4.116l-4.108-4.432-4.108,4.433H-45.107l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(74.875 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.232,533.653v4.44l-4.124,4.432,4.124,4.448v11.479l3.4,3.686-3.4,3.671v5.2h1.707V566.57l4.108-4.432-4.108-4.448V546.211l-3.415-3.685,3.414-3.67v-5.2Z",
    transform: "translate(2.361 -435.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.891,899.9h-4.1l-4.108-4.448-4.114,4.448H579.939l-3.4,3.67-3.414-3.67h-4.811v1.852h4.1l4.123,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.81Z",
    transform: "translate(-459.446 -744.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.063,706.044V701.6l4.123-4.432-4.123-4.448V681.244l-3.4-3.67,3.4-3.686v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.433v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-532.052 -551.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.322,766.713h4.113l4.112,4.436,4.108-4.434h10.634l3.4-3.683,3.4,3.683H727.9v-1.849h-4.1l-4.108-4.448-4.108,4.448H704.946l-3.4,3.671-3.4-3.671h-4.825Z",
    transform: "translate(-566.311 -629.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.362,803.8v4.428l-4.108,4.448,4.108,4.432v11.494l3.41,3.67-3.41,3.686v5.2h1.707v-4.457l4.123-4.432-4.123-4.448V816.349l-3.4-3.67,3.4-3.686V803.8Z",
    transform: "translate(-638.917 -666.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.877,899.9h-4.1l-4.108-4.448-4.124,4.448H329.925l-3.414,3.67-3.4-3.67H318.3v1.852h4.1l4.108,4.432,4.123-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.716 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.047,706.044V701.6l4.108-4.433-4.108-4.448V681.245l-3.4-3.67,3.4-3.686v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-318.321 -551.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.309,766.714h4.1l4.124,4.434,4.108-4.436h10.619l3.414-3.683,3.4,3.683h4.81v-1.85h-4.1l-4.108-4.448-4.123,4.448H454.933l-3.4,3.671-3.415-3.671h-4.81Z",
    transform: "translate(-352.582 -629.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.349,803.8v4.429l-4.108,4.448,4.108,4.432v11.495l3.4,3.671-3.4,3.686v5.2h1.708v-4.456l4.109-4.432-4.108-4.448V816.35l-3.4-3.671,3.4-3.686V803.8Z",
    transform: "translate(-425.188 -666.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.865,899.905h-4.1l-4.124-4.447-4.108,4.447H79.9l-3.4,3.67-3.4-3.67h-4.81v1.852h4.1L76.5,906.19l4.108-4.433H91.241l3.4-3.685,3.415,3.685h4.811Z",
    transform: "translate(-31.988 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.946,706.048v-4.44l4.108-4.433-4.108-4.448V681.248l-3.4-3.671,3.4-3.685v-5.2h-1.707v4.44l-4.123,4.447,4.123,4.432v11.479l3.4,3.686-3.4,3.671v5.2Z",
    transform: "translate(-104.504 -551.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.293,766.718h4.1l4.108,4.434,4.124-4.434h10.619l3.4-3.683,3.414,3.683h4.811v-1.849h-4.1l-4.124-4.448-4.108,4.447h-10.62l-3.414,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-138.851 -629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.327,803.812v4.427l-4.11,4.448,4.11,4.432v11.495l3.4,3.67-3.4,3.685v5.2h1.708v-4.456l4.108-4.432-4.108-4.448V816.357l-3.4-3.67,3.4-3.685v-5.189Z",
    transform: "translate(-211.451 -666.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.231,899.9h-4.116l-4.108-4.448-4.108,4.448H-170.2l-3.4,3.671-3.4-3.67h-4.824v1.853h4.115l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.823 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.719,766.719h4.1l4.108,4.435,4.108-4.435h10.634l3.4-3.684,3.4,3.683h4.825v-1.85h-4.117l-4.108-4.447-4.108,4.447H-45.11l-3.4,3.671-3.4-3.67h-4.81Z",
    transform: "translate(74.877 -629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.23,803.812v4.427l-4.124,4.448,4.123,4.432v11.494l3.4,3.67-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.448V816.358l-3.415-3.671L33.937,809v-5.189Z",
    transform: "translate(2.363 -666.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.888,1169.981h-4.1l-4.108-4.464-4.113,4.464h-10.63l-3.4,3.654-3.414-3.654h-4.811v1.851h4.1l4.123,4.432,4.108-4.431h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.443 -975.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.061,976.216V971.76l4.123-4.433L659.06,962.9V951.417l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.433v11.48l3.4,3.684-3.4,3.686v5.2Z",
    transform: "translate(-532.05 -782.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.321,1036.77h4.111l4.114,4.463,4.108-4.463h10.635l3.4-3.656,3.4,3.654H727.9v-1.82h-4.1l-4.108-4.463-4.108,4.463H704.945l-3.4,3.656-3.4-3.655h-4.826Z",
    transform: "translate(-566.31 -860.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.36,1073.782v4.457l-4.108,4.433,4.108,4.433v11.505l3.41,3.659-3.41,3.686v5.2h1.708v-4.425l4.124-4.463-4.124-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-638.915 -897.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.875,1169.988h-4.1l-4.109-4.463-4.123,4.463H329.923l-3.414,3.654-3.4-3.654H318.3v1.852h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.686,3.4,3.686h4.81Z",
    transform: "translate(-245.715 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.047,976.221v-4.457l4.108-4.433-4.108-4.432V951.422l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.2Z",
    transform: "translate(-318.321 -782.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.309,1036.773h4.1l4.124,4.464,4.108-4.464h10.619l3.414-3.655,3.4,3.655h4.81v-1.821h-4.1l-4.108-4.463-4.124,4.463H454.933l-3.4,3.654-3.414-3.654h-4.81Z",
    transform: "translate(-352.582 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.349,1073.789v4.456l-4.108,4.431,4.108,4.432v11.506l3.4,3.659-3.4,3.686v5.2h1.708v-4.425l4.108-4.463-4.108-4.432v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-425.188 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.863,1169.989h-4.1l-4.123-4.463-4.108,4.463H79.9l-3.4,3.654-3.4-3.654h-4.81v1.852h4.1l4.108,4.432,4.108-4.432H91.239l3.4-3.686,3.415,3.686h4.81Z",
    transform: "translate(-31.987 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.941,976.222v-4.456l4.108-4.433-4.108-4.432V951.421l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.123,4.447,4.124,4.433v11.479l3.4,3.685-3.4,3.686v5.2Z",
    transform: "translate(-104.499 -782.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,1036.773h4.1l4.108,4.464,4.123-4.464h10.619l3.4-3.655,3.414,3.655h4.811v-1.821h-4.1l-4.123-4.463-4.107,4.463h-10.62l-3.414,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-138.848 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.31,1073.789v4.456l-4.112,4.432,4.112,4.433v11.508l3.4,3.657-3.4,3.685v5.2h1.708v-4.425l4.108-4.463-4.108-4.433v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-211.434 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.234,1169.989h-4.116l-4.108-4.463-4.108,4.463H-170.2l-3.4,3.655-3.4-3.654h-4.823v1.851h4.115l4.108,4.432,4.108-4.431h10.634l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.826 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.721,1036.773h4.1l4.108,4.463,4.108-4.463h10.634l3.4-3.655,3.4,3.655h4.824v-1.821h-4.116l-4.108-4.463-4.108,4.463H-45.112l-3.4,3.656-3.4-3.656h-4.81Z",
    transform: "translate(74.879 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.227,1073.789v4.456l-4.124,4.432,4.124,4.433v11.508l3.4,3.657-3.4,3.685v5.2h1.708v-4.425l4.108-4.463-4.108-4.432v-11.479l-3.415-3.686,3.415-3.685v-5.2Z",
    transform: "translate(2.365 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.887,1440.236h-4.1l-4.108-4.432-4.113,4.432h-10.63l-3.4,3.685-3.414-3.685h-4.81v1.852h4.1l4.123,4.432,4.108-4.432h10.631l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.443 -1206.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.059,1246.38v-4.425l4.123-4.463-4.123-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2H657.35v4.424l-4.108,4.432,4.108,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-532.048 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.32,1307.051h4.111l4.114,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81V1305.2h-4.1l-4.108-4.433-4.109,4.433H704.943l-3.4,3.685-3.4-3.685H693.32Z",
    transform: "translate(-566.309 -1091.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.357,1344.068v4.425l-4.108,4.432,4.108,4.464v11.479l3.409,3.655-3.41,3.686v5.2h1.708v-4.426l4.124-4.463-4.124-4.433v-11.478l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-638.913 -1128.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.872,1440.236h-4.1l-4.108-4.432-4.124,4.432H329.92l-3.414,3.686-3.4-3.685H318.3v1.853h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.712 -1206.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.043,1246.381v-4.426l4.108-4.464-4.108-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2h-1.707v4.425l-4.108,4.433,4.108,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-318.317 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.306,1307.052h4.1l4.124,4.432,4.108-4.432h10.619l3.415-3.685,3.4,3.685h4.81V1305.2h-4.1l-4.108-4.433-4.124,4.433H454.93l-3.4,3.686-3.414-3.685h-4.81Z",
    transform: "translate(-352.58 -1091.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.342,1344.068v4.426l-4.108,4.432,4.108,4.464v11.479l3.4,3.655-3.4,3.686v5.2h1.708v-4.426l4.108-4.463-4.108-4.432v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-425.182 -1128.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,1440.24h-4.1l-4.123-4.432-4.108,4.432H79.892l-3.4,3.685-3.4-3.685H68.284v1.851h4.1l4.108,4.432,4.108-4.432H91.236l3.4-3.686,3.414,3.686h4.81Z",
    transform: "translate(-31.984 -1206.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,1246.381v-4.426l4.108-4.464-4.108-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2h-1.708v4.426l-4.123,4.432,4.123,4.463v11.479l3.4,3.654-3.4,3.686v5.2Z",
    transform: "translate(-104.499 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,1307.058h4.1l4.108,4.432,4.124-4.433h10.619l3.4-3.686,3.415,3.686h4.81v-1.851h-4.1l-4.123-4.432-4.108,4.432h-10.62l-3.415,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-138.848 -1091.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1344.073v4.425l-4.113,4.433,4.113,4.463v11.479l3.4,3.656-3.4,3.684v5.2h1.709v-4.425l4.109-4.462-4.108-4.433v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-211.425 -1128.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.235,1440.241h-4.116l-4.108-4.433-4.108,4.432H-170.2l-3.4,3.685-3.4-3.685h-4.823v1.852h4.115l4.108,4.432,4.108-4.432h10.635l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.826 -1206.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.724,1307.056h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825V1305.2h-4.116l-4.108-4.432-4.108,4.433H-45.115l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(74.882 -1091.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.227,1344.073v4.425l-4.123,4.432,4.124,4.463v11.479l3.4,3.655-3.4,3.685v5.2h1.708v-4.425l4.107-4.462-4.108-4.432v-11.479l-3.414-3.686,3.414-3.655v-5.2Z",
    transform: "translate(2.365 -1128.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.884,1710.3h-4.1l-4.109-4.433-4.113,4.433h-10.63l-3.4,3.685-3.415-3.685h-4.811v1.852h4.1l4.123,4.431,4.108-4.432h10.626l3.409-3.686,3.4,3.685h4.81Z",
    transform: "translate(-459.44 -1437.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.055,1516.452v-4.426l4.123-4.432-4.123-4.463v-11.479l-3.4-3.685,3.4-3.656v-5.2h-1.708v4.424l-4.108,4.433,4.108,4.462v11.48l3.4,3.685-3.4,3.654v5.2Z",
    transform: "translate(-532.045 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.317,1577.122h4.112l4.113,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.81v-1.851h-4.1l-4.108-4.433-4.108,4.433H704.941l-3.4,3.685-3.4-3.685h-4.826Z",
    transform: "translate(-566.307 -1322.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.353,1614.138v4.425l-4.108,4.463,4.109,4.433v11.479l3.409,3.685-3.41,3.655v5.2h1.708v-4.425l4.123-4.432-4.123-4.464v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-638.909 -1359.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.872,1710.307h-4.1l-4.109-4.432-4.123,4.433H329.92l-3.415,3.685-3.4-3.685H318.3v1.852h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.712 -1437.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04,1516.452v-4.425l4.108-4.433-4.108-4.463v-11.479l-3.4-3.685,3.4-3.656v-5.2h-1.708v4.424l-4.108,4.433,4.108,4.463v11.478l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-318.315 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.306,1577.124h4.1l4.124,4.433,4.109-4.433h10.619l3.414-3.686,3.4,3.686h4.81v-1.851h-4.1l-4.108-4.432-4.123,4.432H454.93l-3.4,3.685-3.414-3.685h-4.81Z",
    transform: "translate(-352.58 -1322.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.34,1614.141v4.425l-4.108,4.463,4.108,4.432v11.479l3.4,3.686-3.4,3.655v5.2h1.708v-4.425l4.108-4.432-4.108-4.464v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-425.18 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.857,1710.309h-4.1l-4.123-4.433-4.107,4.432H79.889l-3.4,3.685-3.4-3.685h-4.81v1.852h4.1l4.108,4.432,4.108-4.432H91.233l3.4-3.686,3.414,3.686h4.81Z",
    transform: "translate(-31.982 -1437.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,1516.452v-4.425l4.108-4.433-4.108-4.463v-11.479l-3.4-3.685,3.4-3.655v-5.2h-1.707v4.425l-4.123,4.432,4.123,4.462v11.48l3.4,3.685-3.4,3.655v5.2Z",
    transform: "translate(-104.499 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.288,1577.124h4.1l4.108,4.433,4.123-4.433H216.24l3.4-3.685,3.415,3.685h4.81v-1.852h-4.1l-4.124-4.432-4.108,4.432h-10.62l-3.414,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-138.846 -1322.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1614.141v4.425l-4.113,4.463,4.113,4.433v11.479l3.4,3.686-3.4,3.655v5.2h1.709v-4.425l4.108-4.432-4.108-4.463v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-211.425 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.238,1710.31h-4.116l-4.108-4.432-4.109,4.433H-170.2l-3.4,3.686-3.4-3.686h-4.824v1.852h4.115l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.826Z",
    transform: "translate(181.829 -1437.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.724,1577.128h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825v-1.852h-4.117l-4.108-4.432-4.108,4.432H-45.115l-3.4,3.686-3.4-3.685h-4.81Z",
    transform: "translate(74.882 -1322.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.224,1614.141v4.426l-4.123,4.463,4.123,4.432v11.48l3.4,3.685-3.4,3.655v5.2h1.708v-4.426l4.108-4.432-4.108-4.463v-11.479l-3.414-3.655,3.414-3.685v-5.2Z",
    transform: "translate(2.367 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.88,1980.372h-4.1l-4.108-4.433-4.113,4.433h-10.63l-3.4,3.685-3.414-3.685H568.3v1.851h4.1l4.123,4.463,4.107-4.462h10.626l3.408-3.655,3.4,3.655h4.81Z",
    transform: "translate(-459.437 -1668.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.053,1786.518v-4.426l4.122-4.432-4.122-4.463v-11.479l-3.4-3.654,3.4-3.686v-5.2h-1.708v4.425l-4.108,4.463,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-532.043 -1474.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.315,1847.19h4.112l4.113,4.432,4.108-4.433h10.634l3.4-3.664,3.4,3.664h4.81v-1.851h-4.1l-4.108-4.432-4.108,4.432H704.939l-3.4,3.686-3.4-3.686h-4.826Z",
    transform: "translate(-566.305 -1553.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.348,1884.2v4.425l-4.109,4.463,4.108,4.433V1909l3.409,3.685-3.41,3.686v5.2h1.709v-4.457l4.124-4.433-4.124-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-638.904 -1590.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.868,1980.379h-4.1l-4.108-4.432-4.123,4.432h-10.62l-3.414,3.685-3.4-3.685h-4.81v1.852h4.1l4.108,4.462,4.123-4.463h10.62l3.414-3.654,3.4,3.654h4.81Z",
    transform: "translate(-245.709 -1668.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04,1786.52v-4.426l4.108-4.432-4.108-4.463V1761.72l-3.4-3.655,3.4-3.686v-5.2h-1.707v4.425l-4.108,4.463,4.108,4.432v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-318.315 -1474.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3,1847.195h4.1l4.123,4.433,4.108-4.433h10.62l3.415-3.664,3.4,3.664h4.81v-1.853h-4.1l-4.108-4.432-4.123,4.432H454.925l-3.4,3.685-3.414-3.685H443.3Z",
    transform: "translate(-352.575 -1553.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.34,1884.211v4.425l-4.107,4.462,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.48l-3.4-3.685,3.4-3.685v-5.2Z",
    transform: "translate(-425.18 -1590.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.856,1980.38h-4.1l-4.123-4.432-4.107,4.432H79.889l-3.4,3.685-3.4-3.685H68.28v1.852h4.1l4.108,4.463,4.109-4.463H91.232l3.4-3.654,3.414,3.654h4.811Z",
    transform: "translate(-31.981 -1668.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.936,1786.525V1782.1l4.109-4.433-4.108-4.462v-11.479l-3.4-3.656,3.4-3.685v-5.2h-1.708v4.425l-4.123,4.462,4.124,4.432v11.48l3.4,3.686-3.4,3.686v5.172Z",
    transform: "translate(-104.495 -1474.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.286,1847.2h4.1l4.108,4.433,4.123-4.433h10.619l3.4-3.665,3.415,3.665h4.81v-1.851h-4.1l-4.124-4.432-4.108,4.432H204.91l-3.414,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-138.845 -1553.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1884.214v4.425l-4.113,4.462,4.113,4.433v11.48l3.4,3.685-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.479l-3.4-3.685,3.4-3.685v-5.2Z",
    transform: "translate(-211.422 -1590.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.247,1980.375h-4.116l-4.108-4.433-4.108,4.433h-10.634l-3.4,3.686-3.4-3.685h-4.825l0,1.851h4.114l4.108,4.463,4.108-4.463h10.634l3.4-3.656,3.4,3.655h4.825Z",
    transform: "translate(181.838 -1668.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.728,1847.195h4.1l4.108,4.433,4.109-4.434h10.634l3.4-3.66,3.4,3.66h4.825v-1.851h-4.116l-4.108-4.432-4.108,4.432H-45.12l-3.4,3.686-3.4-3.686h-4.811Z",
    transform: "translate(74.885 -1553.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,1884.211v4.425L28.1,1893.1l4.124,4.432v11.479l3.4,3.686-3.4,3.685v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.479l-3.415-3.686,3.414-3.685v-5.2Z",
    transform: "translate(2.371 -1590.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.015,89.581h-4.086l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.67-3.4-3.67h-4.811v1.836h4.086l4.124,4.447,4.123-4.447h10.619l3.4-3.67,3.4,3.67h4.811Z",
    transform: "translate(-887.001 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.724v4.437l-4.093,4.436,4.093,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-959.606 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461-43.616h4.117l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086l-4.123-4.432-4.093,4.433h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-993.866 63.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.487-6.6v4.441L1278.4,2.274l4.092,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.724v-4.44l4.123-4.433-4.123-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1066.473 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,89.581h-4.113l-4.124-4.448-4.092,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.837h4.117l4.093,4.448,4.123-4.447h10.619l3.4-3.67,3.4,3.67h4.838Z",
    transform: "translate(-1100.729 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.214-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.724v4.437l-4.092,4.436,4.093,4.448v11.479l3.43,3.67-3.43,3.686v5.2Z",
    transform: "translate(-1173.335 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473-43.615h4.117l4.093,4.448,4.124-4.447h10.619l3.4-3.67,3.4,3.67h4.841v-1.852h-4.117l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.594 63.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525-6.6v4.441l-4.12,4.432,4.12,4.448,0,11.479,3.4,3.686-3.4,3.67,0,5.2h1.694v-4.44l4.124-4.432-4.124-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1280.2 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.07,89.581h-4.117l-4.123-4.448-4.093,4.448h-10.649l-3.4,3.67-3.4-3.67h-4.81v1.837h4.117l4.093,4.448,4.123-4.447h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1314.457 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.227-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.692v4.437l-4.124,4.436,4.124,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-1387.063 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.488-43.617h4.116l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.431,3.67h4.809v-1.852h-4.116l-4.124-4.432-4.092,4.432h-10.619l-3.43,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-1421.324 63.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541-6.6v4.44l-4.124,4.433,4.124,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.693v-4.44l4.124-4.433-4.123-4.447V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1493.928 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,89.581h-4.117l-4.124-4.447-4.093,4.448H1830.13l-3.431,3.671-3.4-3.671h-4.811v1.837h4.116l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1528.185 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.238-104.274v-4.441l4.124-4.448-4.124-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.693v4.437l-4.123,4.436,4.123,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-1600.791 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5-43.618h4.117l4.093,4.448,4.123-4.447h10.619l3.427-3.67,3.4,3.67h4.81V-45.47h-4.117l-4.1-4.432-4.12,4.432h-10.619l-3.429,3.686-3.4-3.686H1943.5Z",
    transform: "translate(-1635.052 63.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.015,359.649h-4.086l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.81V361.5h4.086l4.124,4.433,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.811Z",
    transform: "translate(-887.001 -283.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,165.792v-4.437l4.123-4.435-4.123-4.448V140.992l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.441l-4.093,4.448,4.093,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-959.604 -89.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,226.466h4.116l4.094,4.432,4.123-4.432h10.62l3.4-3.686,3.4,3.685h4.81v-1.852h-4.085l-4.123-4.447-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-993.866 -167.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,263.57V268l-4.093,4.448,4.093,4.435V288.37l3.4,3.67-3.4,3.67v5.2h1.724v-4.425l4.124-4.447-4.124-4.448V276.113l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-1066.467 -204.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,359.647h-4.113l-4.124-4.448-4.093,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.811V361.5h4.116l4.092,4.432,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.729 -283.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.214,165.792v-4.438l4.123-4.435-4.123-4.448V140.992l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.44l-4.092,4.447,4.092,4.433v11.479l3.43,3.686-3.43,3.67v5.2Z",
    transform: "translate(-1173.335 -89.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,226.462h4.117l4.093,4.432,4.124-4.432h10.619l3.4-3.686,3.4,3.685h4.841V224.61h-4.117l-4.123-4.448-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1207.594 -167.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,263.575V268l-4.12,4.448,4.12,4.435v11.491l3.4,3.67-3.4,3.67,0,5.2h1.694v-4.425l4.124-4.447-4.124-4.448V276.118l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-1280.2 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.07,359.647h-4.117l-4.123-4.448-4.093,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.81V361.5h4.117l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.429,3.686h4.811Z",
    transform: "translate(-1314.457 -283.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,165.794v-4.438l4.123-4.435-4.123-4.448V140.994l-3.4-3.67,3.4-3.686v-5.2h-1.692v4.44l-4.123,4.448,4.124,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-1387.06 -89.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.488,226.462h4.116l4.093,4.432,4.123-4.432h10.62l3.4-3.685,3.431,3.686h4.809V224.61h-4.117l-4.123-4.448-4.092,4.448h-10.619l-3.43,3.67-3.4-3.671h-4.809Z",
    transform: "translate(-1421.324 -167.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,263.575V268l-4.123,4.448,4.123,4.435v11.492l3.4,3.67-3.4,3.67v5.2h1.692v-4.425l4.124-4.447-4.124-4.448V276.118l-3.4-3.671,3.4-3.686v-5.187Z",
    transform: "translate(-1493.928 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,359.649h-4.117l-4.124-4.448-4.093,4.448H1830.13l-3.431,3.685-3.4-3.685h-4.811V361.5h4.117l4.092,4.433,4.124-4.432h10.619l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.185 -283.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,165.794v-4.437l4.124-4.435-4.124-4.448V140.994l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.123,4.433v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-1600.788 -89.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,226.466h4.117l4.092,4.432,4.124-4.432h10.619l3.427-3.686,3.4,3.686h4.811v-1.852h-4.117l-4.1-4.448-4.121,4.447h-10.619l-3.429,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1635.05 -167.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.013,629.819h-4.086l-4.123-4.447-4.094,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.838h4.086l4.123,4.448,4.124-4.448H1091.4l3.4-3.67,3.4,3.67h4.811Z",
    transform: "translate(-886.999 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,435.963v-4.44l4.123-4.448-4.123-4.432V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.724v4.425l-4.093,4.448,4.093,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,496.622h4.116l4.094,4.448,4.123-4.448h10.62l3.4-3.67,3.4,3.67h4.809v-1.852h-4.087l-4.123-4.432-4.092,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-993.866 -398.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,533.639v4.44l-4.093,4.432,4.093,4.448v11.479l3.4,3.686-3.4,3.67V571h1.723v-4.441l4.124-4.432-4.124-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1066.467 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,629.819h-4.113l-4.124-4.447-4.092,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.838h4.117l4.092,4.447,4.123-4.448h10.619l3.4-3.67,3.4,3.67h4.838Z",
    transform: "translate(-1100.729 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,435.963v-4.44l4.123-4.448-4.123-4.432V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.724v4.425l-4.093,4.448,4.092,4.448v11.478l3.43,3.671-3.43,3.685v5.2Z",
    transform: "translate(-1173.332 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,496.62h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.4,3.67h4.84v-1.852h-4.116l-4.123-4.432-4.094,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.594 -398.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,533.639v4.44l-4.12,4.432,4.12,4.448v11.479l3.4,3.686-3.4,3.67V571h1.7v-4.441l4.124-4.432-4.124-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1280.2 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,629.819h-4.117l-4.123-4.447-4.093,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.837h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.429,3.67h4.811Z",
    transform: "translate(-1314.454 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,435.963v-4.44l4.123-4.448-4.123-4.433V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.447v11.48l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,496.62h4.117l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.431,3.67h4.809v-1.852h-4.116l-4.124-4.433-4.092,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1421.322 -398.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,533.639v4.44l-4.124,4.432,4.124,4.448v11.479l3.4,3.686-3.4,3.67V571h1.692v-4.44l4.124-4.432-4.123-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1493.928 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,629.819h-4.117l-4.124-4.446-4.093,4.447H1830.13l-3.431,3.671-3.4-3.671h-4.811v1.838h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1528.185 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.238,435.962v-4.439l4.124-4.448-4.124-4.432V411.15l-3.4-3.671,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-1600.791 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,496.622h4.117l4.094,4.448,4.123-4.448h10.619l3.427-3.67,3.4,3.67h4.811v-1.852h-4.117l-4.1-4.432-4.121,4.432h-10.619l-3.429,3.686-3.4-3.686H1943.5Z",
    transform: "translate(-1635.05 -398.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.013,899.887h-4.087l-4.123-4.448-4.094,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.852h4.086l4.123,4.433,4.124-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -744.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,706.029v-4.44l4.123-4.432-4.123-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.44l-4.093,4.448,4.093,4.432V693.47l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-959.604 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,766.7h4.116l4.094,4.438,4.123-4.438h10.619l3.4-3.68,3.4,3.68h4.81v-1.847h-4.086l-4.123-4.448-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-993.866 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,803.774v4.43l-4.093,4.448,4.093,4.432v11.495l3.4,3.67-3.4,3.687v5.2h1.723v-4.456l4.124-4.432L1284.2,827.8V816.322l-3.4-3.67,3.4-3.685v-5.192Z",
    transform: "translate(-1066.467 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,899.888h-4.113l-4.124-4.448-4.092,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.852h4.116l4.093,4.433,4.123-4.433h10.62l3.4-3.685,3.4,3.685h4.837Z",
    transform: "translate(-1100.726 -744.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,706.029v-4.441l4.123-4.432-4.124-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.723v4.44l-4.092,4.448,4.092,4.432v11.479l3.431,3.686-3.431,3.67v5.2Z",
    transform: "translate(-1173.332 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,766.7h4.117l4.092,4.438,4.124-4.437h10.619l3.4-3.68,3.4,3.68h4.84v-1.848h-4.116l-4.123-4.448-4.094,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1207.594 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,803.774v4.43l-4.12,4.448,4.12,4.433v11.495l3.4,3.67-3.4,3.686v5.2h1.7v-4.456l4.124-4.433-4.124-4.447V816.323l-3.4-3.671,3.4-3.685v-5.192Z",
    transform: "translate(-1280.2 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,899.886h-4.117l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.671-3.4-3.67h-4.81v1.852h4.117l4.093,4.432,4.123-4.433h10.618l3.4-3.686,3.429,3.686h4.811Z",
    transform: "translate(-1314.454 -744.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,706.029v-4.441l4.123-4.432-4.123-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.124,4.433v11.479l3.4,3.685-3.4,3.67v5.2Z",
    transform: "translate(-1387.06 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,766.7h4.117l4.092,4.437,4.123-4.437h10.619l3.4-3.68,3.431,3.68h4.809v-1.846h-4.117l-4.123-4.448-4.093,4.448h-10.619l-3.43,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1421.322 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,803.774v4.43l-4.123,4.448,4.123,4.432v11.495l3.4,3.67-3.4,3.686v5.2h1.693v-4.456l4.124-4.433-4.124-4.447V816.322l-3.4-3.67,3.4-3.685v-5.192Z",
    transform: "translate(-1493.928 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,899.886h-4.117l-4.124-4.448-4.093,4.448h-10.618l-3.431,3.67-3.4-3.67h-4.81v1.852h4.117l4.092,4.433,4.124-4.433h10.619l3.4-3.686,3.43,3.686h4.81Z",
    transform: "translate(-1528.183 -744.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,706.029v-4.441l4.124-4.432-4.124-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.123,4.432v11.479l3.4,3.685-3.4,3.671v5.2Z",
    transform: "translate(-1600.788 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,766.7h4.117l4.094,4.438,4.123-4.437h10.618l3.428-3.68,3.4,3.68h4.811v-1.846h-4.117l-4.1-4.448-4.121,4.448h-10.619l-3.43,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1635.05 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1169.97h-4.085l-4.123-4.463-4.094,4.463h-10.649l-3.4,3.655-3.4-3.655h-4.81v1.853h4.086l4.124,4.433,4.122-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,976.2v-4.455l4.123-4.432-4.123-4.432V951.4l-3.4-3.687,3.4-3.67v-5.2h-1.723v4.425l-4.093,4.448,4.093,4.432V963.63l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -782.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,1036.752h4.116l4.094,4.462,4.124-4.462h10.62l3.4-3.656,3.4,3.656h4.81v-1.822h-4.086l-4.123-4.464-4.092,4.464h-10.651l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-993.866 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,1073.775v4.455l-4.093,4.432,4.093,4.433v11.5l3.4,3.66-3.4,3.685v5.2h1.723v-4.425l4.123-4.463-4.123-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1066.467 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1169.971h-4.114l-4.124-4.463-4.092,4.463h-10.651l-3.4,3.655-3.4-3.655h-4.81v1.851h4.117l4.092,4.433,4.124-4.433h10.62l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.726 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,976.2v-4.455l4.123-4.433-4.124-4.432V951.4l-3.4-3.686,3.4-3.671v-5.2h-1.723v4.426l-4.093,4.448,4.093,4.432v11.479l3.43,3.686-3.43,3.686v5.2Z",
    transform: "translate(-1173.332 -782.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,1036.752h4.117l4.092,4.462,4.124-4.462h10.619l3.4-3.656,3.4,3.656h4.841v-1.821h-4.116l-4.123-4.464-4.093,4.464h-10.65l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1207.594 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1073.775v4.455l-4.12,4.432,4.12,4.433v11.5l3.4,3.667-3.4,3.685v5.2h1.7v-4.425l4.124-4.463-4.124-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1280.196 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,1169.967h-4.117l-4.124-4.464-4.093,4.464h-10.65l-3.4,3.655-3.4-3.655h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.685,3.429,3.685h4.811Z",
    transform: "translate(-1314.454 -975.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,976.2v-4.455l4.123-4.433-4.123-4.432V951.4l-3.4-3.686,3.4-3.671v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.433v11.479l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -782.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1036.752h4.116l4.093,4.462,4.123-4.462h10.619l3.4-3.656,3.43,3.656h4.81v-1.821h-4.117l-4.124-4.464-4.092,4.463h-10.62l-3.429,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1421.322 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,1073.775v4.455l-4.123,4.432,4.123,4.433v11.5l3.4,3.66-3.4,3.685v5.2h1.692v-4.425l4.124-4.463-4.124-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1493.928 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1169.97h-4.117l-4.124-4.463-4.093,4.463h-10.618l-3.431,3.655-3.4-3.655h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.62l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.183 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,976.2v-4.456l4.124-4.432-4.124-4.432V951.4l-3.4-3.687,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.447,4.123,4.433V963.63l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-1600.788 -782.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,1036.752h4.116l4.093,4.463,4.124-4.463h10.618l3.428-3.656,3.4,3.656h4.811v-1.821h-4.116l-4.1-4.464-4.121,4.464h-10.619l-3.43,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1635.05 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1440.214h-4.086l-4.123-4.432-4.094,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.086l4.123,4.433,4.124-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1246.358v-4.425l4.123-4.463-4.123-4.432v-11.479l-3.4-3.686,3.4-3.659v-5.2h-1.723v4.425l-4.093,4.432,4.093,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,1307.03h4.116l4.094,4.432,4.123-4.432h10.619l3.4-3.686,3.4,3.686h4.81v-1.852h-4.086l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-993.866 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.48,1344.051v4.425l-4.093,4.432,4.093,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.723v-4.426l4.123-4.462-4.124-4.434v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-1066.467 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1440.214h-4.114l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.685-3.4-3.685h-4.81v1.852h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.684,3.4,3.684h4.833Z",
    transform: "translate(-1100.726 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1246.357v-4.425l4.123-4.463-4.124-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.463v11.479l3.43,3.655-3.43,3.686v5.2Z",
    transform: "translate(-1173.332 -1012.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1307.03h4.118l4.092,4.432,4.124-4.432h10.619l3.4-3.686,3.4,3.686h4.841v-1.852h-4.116l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.589 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1344.051v4.425l-4.12,4.432,4.12,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.7v-4.426l4.124-4.462-4.124-4.434v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-1280.196 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,1440.214h-4.117l-4.124-4.432-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.433,4.124-4.433h10.618l3.4-3.685,3.43,3.685h4.811Z",
    transform: "translate(-1314.454 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,1246.359v-4.425l4.123-4.463-4.124-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.693v4.425l-4.123,4.432,4.123,4.464v11.478l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1307.03h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.43,3.686h4.81v-1.852h-4.116l-4.124-4.433-4.092,4.433h-10.62l-3.429,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1421.322 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,1344.051v4.425l-4.123,4.432,4.123,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.692v-4.426l4.123-4.463-4.123-4.432v-11.479l-3.4-3.686,3.4-3.655v-5.2Z",
    transform: "translate(-1493.928 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1440.219h-4.117l-4.123-4.432-4.093,4.432h-10.618l-3.431,3.686-3.4-3.687h-4.81v1.851h4.117l4.092,4.433,4.123-4.433h10.62l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.183 -1206.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,1246.359v-4.425l4.124-4.463-4.123-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.693v4.425l-4.123,4.432,4.123,4.464v11.478l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-1600.788 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.493,1307.03h4.117l4.093,4.432,4.124-4.432h10.619l3.428-3.685,3.4,3.685h4.81v-1.852h-4.117l-4.095-4.433-4.121,4.433h-10.619l-3.43,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1635.046 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1710.284h-4.086l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.685-3.4-3.685h-4.81v1.852h4.086l4.124,4.433,4.122-4.432H1091.4l3.4-3.684,3.4,3.684h4.81Z",
    transform: "translate(-886.999 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1516.424V1512l4.123-4.432-4.123-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.462v11.479l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-959.604 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.456,1577.1h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.811v-1.851h-4.086l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.809Z",
    transform: "translate(-993.861 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.478,1614.119v4.425l-4.093,4.462,4.093,4.433v11.48l3.4,3.685-3.4,3.655v5.2h1.724v-4.424l4.124-4.433-4.124-4.463v-11.479l-3.4-3.654,3.4-3.686v-5.2Z",
    transform: "translate(-1066.465 -1359.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.046,1710.284h-4.108l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.726 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1516.425V1512l4.124-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.462v11.479l3.43,3.686-3.43,3.655v5.2Z",
    transform: "translate(-1173.332 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1577.1h4.117l4.092,4.432,4.124-4.432h10.619l3.4-3.685,3.4,3.685h4.841v-1.851h-4.116l-4.124-4.433-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-1207.589 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1614.116v4.425L1528.4,1623l4.12,4.433v11.48l3.4,3.685-3.4,3.655v5.2h1.7v-4.425l4.124-4.432-4.123-4.463v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-1280.196 -1359.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.063,1710.285h-4.117l-4.124-4.432-4.093,4.432h-10.649l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.432,4.124-4.432h10.618l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1314.451 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.223,1516.425V1512l4.123-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.693v4.425l-4.123,4.433,4.123,4.463v11.479l3.4,3.685-3.4,3.655v5.2Z",
    transform: "translate(-1387.06 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.48,1577.1h4.117l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.43,3.686h4.81v-1.852h-4.117l-4.123-4.432-4.093,4.432h-10.62l-3.429,3.685-3.4-3.686h-4.81Z",
    transform: "translate(-1421.318 -1322.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,1614.116v4.426l-4.123,4.463,4.123,4.432v11.48l3.4,3.685-3.4,3.655v5.2h1.692v-4.425l4.123-4.433-4.123-4.463v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-1493.928 -1359.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1710.284h-4.118l-4.124-4.432-4.092,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.433,4.123-4.432h10.62l3.4-3.684,3.43,3.684h4.811Z",
    transform: "translate(-1528.183 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,1516.425V1512l4.124-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.692v4.425l-4.123,4.433,4.123,4.463v11.479l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-1600.788 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.494,1577.1h4.116l4.093,4.432,4.124-4.432h10.619l3.428-3.685,3.4,3.685h4.81v-1.851h-4.117l-4.095-4.433-4.122,4.433h-10.618l-3.43,3.685-3.4-3.685h-4.811Z",
    transform: "translate(-1635.046 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1980.35h-4.086l-4.123-4.432-4.093,4.432h-10.649l-3.4,3.685-3.4-3.685h-4.81v1.852h4.086l4.123,4.464,4.124-4.464H1091.4l3.4-3.654,3.4,3.654h4.81Z",
    transform: "translate(-886.999 -1668.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1786.49v-4.425l4.123-4.433-4.123-4.462v-11.48l-3.4-3.656,3.4-3.685v-5.2h-1.723v4.425l-4.092,4.462,4.093,4.433v11.479l3.4,3.685-3.4,3.686v5.171Z",
    transform: "translate(-959.604 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.456,1847.165h4.116l4.093,4.433,4.123-4.433h10.619l3.4-3.683,3.4,3.683h4.811v-1.852h-4.085l-4.123-4.432-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-993.861 -1553.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.48,1884.182v4.425l-4.093,4.462,4.093,4.432v11.48l3.4,3.686-3.4,3.685v5.2h1.723V1917.1l4.123-4.432-4.123-4.433v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-1066.467 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1980.352h-4.114l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.092,4.464,4.123-4.464h10.619l3.4-3.654,3.4,3.654h4.838Z",
    transform: "translate(-1100.726 -1668.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1786.49v-4.425l4.124-4.433-4.123-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.724v4.425l-4.092,4.463,4.092,4.433v11.479l3.43,3.686-3.43,3.685v5.172Z",
    transform: "translate(-1173.332 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1847.166h4.118l4.092,4.432,4.124-4.433h10.619l3.4-3.683,3.4,3.683h4.841v-1.852h-4.116l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-1207.589 -1553.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1884.182v4.425l-4.12,4.463,4.12,4.432v11.48l3.4,3.685-3.4,3.685v5.2h1.7V1917.1l4.124-4.432-4.124-4.433v-11.478l-3.4-3.687,3.4-3.685v-5.2Z",
    transform: "translate(-1280.196 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.063,1980.346h-4.117l-4.123-4.433-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.464,4.124-4.463h10.618l3.4-3.655,3.43,3.655h4.81Z",
    transform: "translate(-1314.451 -1668.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,1786.49v-4.425l4.123-4.433-4.124-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.692v4.425l-4.123,4.463,4.123,4.433v11.479l3.4,3.685-3.4,3.686v5.171Z",
    transform: "translate(-1387.06 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1847.162h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.683,3.43,3.683h4.81v-1.852h-4.117l-4.123-4.433-4.092,4.432h-10.62l-3.429,3.685-3.4-3.685h-4.809Z",
    transform: "translate(-1421.322 -1553.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.535,1884.182v4.425l-4.123,4.462,4.123,4.432v11.48l3.4,3.685-3.4,3.686v5.2h1.692V1917.1l4.123-4.432-4.123-4.433v-11.478l-3.4-3.687,3.4-3.686v-5.2Z",
    transform: "translate(-1493.923 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1980.35h-4.118l-4.123-4.432-4.093,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.464,4.123-4.464h10.619l3.4-3.654,3.431,3.655h4.809Z",
    transform: "translate(-1528.183 -1668.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.23,1786.49v-4.425l4.124-4.433-4.124-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.692v4.425l-4.124,4.463,4.124,4.433v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-1600.784 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.49,1847.168h4.117l4.093,4.433,4.124-4.432h10.619l3.428-3.683,3.4,3.683h4.81v-1.852h-4.117l-4.095-4.432-4.121,4.433H1955.13L1951.7,1849l-3.4-3.685h-4.81Z",
    transform: "translate(-1635.044 -1553.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,89.585h-4.086L844.7,85.138,840.6,89.585H829.962l-3.4,3.671-3.4-3.671h-4.825v1.837h4.117l4.108,4.448,4.108-4.448h10.635l3.4-3.67,3.4,3.67h4.81Z",
    transform: "translate(-673.184 -52.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1-104.271v-4.44l4.108-4.448-4.108-4.432v-11.479l-3.415-3.686,3.415-3.67v-5.2h-1.723v4.438l-4.108,4.434,4.108,4.448v11.479l3.415,3.67-3.415,3.686v5.2Z",
    transform: "translate(-745.786 141.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449-43.615h4.1l4.108,4.448,4.124-4.448H966.4l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086L969.8-49.9l-4.124,4.432H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 63.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.474-6.6v4.441l-4.093,4.432,4.092,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.723v-4.44l4.093-4.432-4.093-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-852.744 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,359.65h-4.086L844.7,355.2,840.6,359.65H829.962l-3.4,3.685-3.4-3.685h-4.826V361.5h4.116l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -283.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,165.795v-4.437l4.108-4.435-4.108-4.448V141l-3.415-3.67,3.415-3.686v-5.2h-1.723v4.44l-4.108,4.448,4.108,4.433v11.479l3.414,3.686-3.415,3.67v5.2Z",
    transform: "translate(-745.786 -89.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,226.467h4.1l4.108,4.432,4.124-4.432H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.086l-4.123-4.448-4.124,4.448H955.058l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-780.137 -167.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.475,263.575V268l-4.092,4.448,4.092,4.435v11.492l3.4,3.67-3.4,3.67v5.2h1.723v-4.425l4.093-4.448L1034.2,287.6V276.118l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-852.745 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,629.823h-4.086l-4.124-4.447-4.108,4.447H829.962l-3.4,3.671-3.4-3.671h-4.825v1.838h4.117l4.108,4.448,4.108-4.448h10.635l3.4-3.67,3.4,3.67h4.81Z",
    transform: "translate(-673.184 -514.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,435.968v-4.44l4.108-4.447-4.108-4.433V411.155l-3.415-3.67,3.415-3.67v-5.2h-1.723v4.425l-4.108,4.448,4.108,4.448v11.479l3.415,3.671-3.414,3.685v5.2Z",
    transform: "translate(-745.786 -320.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,496.625h4.1l4.108,4.448,4.124-4.448H966.4l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086l-4.123-4.432-4.124,4.432H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 -398.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.475,533.643v4.44l-4.092,4.433,4.092,4.448v11.479l3.4,3.686-3.4,3.67V571h1.723v-4.44l4.093-4.432-4.093-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-852.745 -435.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,899.891h-4.086l-4.124-4.448-4.108,4.448H829.962l-3.4,3.67-3.4-3.67h-4.826v1.852h4.117l4.108,4.433,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -744.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,706.033v-4.441l4.108-4.432-4.108-4.448V681.233l-3.415-3.67,3.415-3.686v-5.2h-1.723v4.44l-4.108,4.448L907.376,682v11.479l3.414,3.686-3.415,3.67v5.2Z",
    transform: "translate(-745.788 -551.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,766.7l4.1,0,4.108,4.437,4.124-4.437H966.4l3.4-3.681,3.4,3.681h4.81v-1.846h-4.086l-4.123-4.448-4.124,4.448H955.058l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-780.137 -629.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.474,803.781v4.43l-4.092,4.448,4.093,4.432v11.494l3.4,3.671-3.4,3.686v5.2h1.723v-4.456l4.093-4.432-4.093-4.448V816.329l-3.4-3.67,3.4-3.686v-5.19Z",
    transform: "translate(-852.744 -666.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1169.972h-4.086l-4.124-4.463-4.108,4.463H829.962l-3.4,3.655-3.4-3.655h-4.826v1.853h4.117l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,976.209v-4.456l4.108-4.433-4.108-4.432V951.409l-3.415-3.686,3.415-3.67v-5.2h-1.724v4.425l-4.108,4.448,4.108,4.432v11.479l3.415,3.686-3.414,3.686v5.2Z",
    transform: "translate(-745.786 -782.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.452,1036.763h4.1l4.108,4.463,4.124-4.464H966.4l3.4-3.655,3.4,3.655h4.81v-1.821h-4.086l-4.123-4.463-4.124,4.463H955.06l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-780.14 -860.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1073.782v4.455l-4.092,4.432,4.092,4.433v11.506l3.4,3.658-3.4,3.685v5.2h1.723v-4.425l4.093-4.463-4.093-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-852.744 -897.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1440.22h-4.086l-4.124-4.433-4.108,4.433H829.962l-3.4,3.685-3.4-3.686h-4.826v1.852h4.117l4.108,4.432,4.108-4.432h10.635l3.4-3.686,3.4,3.686,4.81,0Z",
    transform: "translate(-673.184 -1206.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1246.366v-4.424l4.109-4.464-4.108-4.432v-11.479l-3.415-3.685,3.415-3.658v-5.2h-1.723v4.425l-4.108,4.432,4.108,4.463v11.479l3.414,3.655-3.414,3.685v5.2Z",
    transform: "translate(-745.786 -1013.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,1307.037h4.1l4.108,4.432,4.124-4.433H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.085l-4.123-4.433-4.124,4.433H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 -1091.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1344.058v4.424l-4.093,4.432,4.093,4.464v11.478l3.4,3.655-3.4,3.685v5.2h1.724v-4.424l4.093-4.463-4.093-4.433V1356.6l-3.4-3.685,3.4-3.655v-5.2Z",
    transform: "translate(-852.744 -1128.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1710.286h-4.086l-4.124-4.433-4.108,4.431H829.962l-3.4,3.686-3.4-3.686h-4.826v1.852h4.117l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686,4.81,0Z",
    transform: "translate(-673.184 -1437.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1516.435v-4.424l4.108-4.433-4.108-4.463v-11.481l-3.414-3.684,3.414-3.655v-5.2h-1.722v4.425l-4.108,4.432,4.109,4.464v11.479l3.414,3.685-3.414,3.655v5.2Z",
    transform: "translate(-745.788 -1243.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,1577.1h4.1l4.107,4.432,4.124-4.433H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.085l-4.123-4.432-4.124,4.432H955.057l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-780.137 -1322.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1614.119v4.425l-4.092,4.463,4.092,4.433v11.479l3.4,3.685-3.4,3.655v5.2h1.724v-4.425l4.093-4.431-4.093-4.464v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-852.744 -1359.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1980.352h-4.086l-4.124-4.432-4.108,4.432H829.962l-3.4,3.686-3.4-3.686h-4.826v1.851h4.117l4.108,4.464,4.108-4.464h10.635l3.4-3.655,3.4,3.655h4.81Z",
    transform: "translate(-673.184 -1668.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1786.5v-4.425l4.108-4.433-4.108-4.464V1761.7l-3.414-3.655,3.414-3.685v-5.2h-1.723v4.424l-4.108,4.463,4.108,4.433v11.479l3.415,3.687-3.414,3.686v5.171Z",
    transform: "translate(-745.786 -1474.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.444,1847.169h4.1l4.107,4.432,4.124-4.432H966.4l3.4-3.684,3.4,3.683H978v-1.852H973.92l-4.123-4.433-4.124,4.433H955.054l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-780.133 -1553.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.469,1884.189v4.424l-4.093,4.463,4.093,4.433v11.479l3.4,3.685-3.4,3.686v5.2h1.723v-4.456l4.093-4.432-4.093-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-852.739 -1590.184)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291.578 0.161)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.161 -0.162)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.228 -20.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.9,89.588h-4.1l-4.108-4.448-4.111,4.448H579.944l-3.4,3.67-3.414-3.67H568.32v1.837h4.1l4.124,4.447,4.108-4.447h10.634l3.4-3.67,3.4,3.671h4.81Z",
    transform: "translate(-459.451 -52.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.066-104.269v-4.44l4.123-4.448-4.123-4.433v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.439l-4.108,4.434,4.108,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-532.055 141.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.328-43.61h4.113l4.112,4.448,4.108-4.448H716.3l3.4-3.67,3.4,3.67h4.81v-1.852h-4.1l-4.108-4.432-4.108,4.432H704.952l-3.4,3.685-3.4-3.685h-4.826Z",
    transform: "translate(-566.316 63.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.367-6.593v4.44L778.259,2.28l4.108,4.448V18.206l3.41,3.686-3.411,3.671v5.2h1.708v-4.44l4.123-4.432-4.123-4.448V5.966l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-638.921 26.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.883,89.59h-4.1l-4.108-4.447L340.55,89.59H329.931l-3.414,3.67-3.4-3.67h-4.81v1.837h4.1l4.108,4.447,4.124-4.447h10.619l3.415-3.67,3.4,3.67h4.81Z",
    transform: "translate(-245.722 -52.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.054-104.267v-4.44l4.108-4.448-4.108-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.438l-4.108,4.434,4.108,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-318.327 141.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.315-43.608h4.1l4.123,4.447,4.108-4.448h10.619l3.415-3.67,3.4,3.67h4.81V-45.46h-4.1l-4.108-4.432-4.124,4.432H454.939l-3.4,3.685-3.414-3.685h-4.81Z",
    transform: "translate(-352.587 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.355-6.593v4.44L528.247,2.28l4.108,4.448V18.206l3.4,3.686-3.4,3.67v5.2h1.708v-4.44l4.108-4.432-4.108-4.448V5.965l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-425.193 26.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.871,89.591h-4.1l-4.124-4.447-4.108,4.447H79.9l-3.4,3.67-3.4-3.671H68.3v1.837h4.1L76.5,95.876l4.108-4.448H91.247l3.4-3.67,3.414,3.67h4.81Z",
    transform: "translate(-31.994 -52.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.949-104.267v-4.44l4.108-4.448-4.108-4.433v-11.479l-3.4-3.685,3.4-3.67v-5.2h-1.708v4.438l-4.124,4.434,4.124,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-104.506 141.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3-43.608h4.1l4.108,4.448,4.123-4.448h10.619l3.4-3.67,3.414,3.67h4.811V-45.46h-4.1l-4.124-4.432-4.108,4.432H204.925l-3.414,3.686-3.4-3.686H193.3Z",
    transform: "translate(-138.858 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.337-6.592v4.44l-4.109,4.433,4.109,4.448V18.207l3.4,3.686-3.4,3.67v5.2h1.708v-4.44l4.108-4.432-4.108-4.448V5.966l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-211.46 26.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.222,89.591h-4.117l-4.108-4.447-4.108,4.447h-10.634l-3.4,3.671-3.4-3.67h-4.823v1.837h4.114l4.108,4.448,4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.826Z",
    transform: "translate(181.815 -52.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.715-43.608h4.1L-48.5-39.16l4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.826V-45.46h-4.117l-4.108-4.432-4.108,4.432H-45.106l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(74.874 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.237-6.591v4.44L28.113,2.282,32.236,6.73V18.209l3.4,3.686-3.4,3.67v5.2h1.708V26.326l4.108-4.432-4.108-4.448V5.968L30.53,2.282l3.415-3.67v-5.2Z",
    transform: "translate(2.357 26.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.9,359.657h-4.1l-4.108-4.447-4.111,4.447H579.943l-3.4,3.686-3.415-3.686h-4.81v1.852h4.1l4.124,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.45 -283.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.065,165.8v-4.436l4.123-4.437-4.123-4.448V141l-3.4-3.67,3.4-3.685v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-532.054 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.327,226.474h4.113l4.112,4.433,4.108-4.433h10.635l3.4-3.686,3.4,3.686h4.81v-1.852h-4.1l-4.108-4.448-4.108,4.448H704.951l-3.4,3.67-3.4-3.67h-4.825Z",
    transform: "translate(-566.315 -167.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.367,263.582v4.425l-4.108,4.448,4.108,4.437v11.49l3.411,3.671-3.411,3.67v5.2h1.708V296.5l4.123-4.448-4.124-4.448V276.125l-3.4-3.67,3.4-3.685v-5.187Z",
    transform: "translate(-638.921 -204.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.882,359.657h-4.1l-4.108-4.447-4.124,4.447H329.93l-3.414,3.686-3.4-3.686h-4.81v1.853h4.1l4.108,4.433,4.123-4.432h10.619l3.415-3.686,3.4,3.686h4.81Z",
    transform: "translate(-245.721 -283.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.053,165.8v-4.436l4.108-4.437-4.108-4.448V141l-3.4-3.67,3.4-3.686v-5.2h-1.707v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.685-3.4,3.67v5.2Z",
    transform: "translate(-318.326 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.313,226.477h4.1l4.124,4.433,4.108-4.433h10.619l3.415-3.686,3.4,3.686h4.81v-1.852h-4.1l-4.108-4.447-4.124,4.447H454.937l-3.4,3.67-3.414-3.67h-4.81Z",
    transform: "translate(-352.586 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.352,263.582v4.425l-4.108,4.448,4.108,4.437v11.49l3.4,3.671-3.4,3.671v5.2h1.708V296.5l4.108-4.448L534.06,287.6V276.125l-3.4-3.671,3.4-3.685v-5.187Z",
    transform: "translate(-425.191 -204.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,359.659h-4.1l-4.124-4.448-4.108,4.447H79.9l-3.4,3.686-3.4-3.685h-4.81v1.852h4.1l4.108,4.433,4.108-4.433H91.246l3.4-3.686,3.415,3.686h4.81Z",
    transform: "translate(-31.993 -283.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.947,165.8v-4.436l4.108-4.437-4.108-4.448V141l-3.4-3.67,3.4-3.686v-5.2H157.24v4.441l-4.123,4.447,4.124,4.432v11.479l3.4,3.685-3.4,3.671v5.2Z",
    transform: "translate(-104.505 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,226.477h4.1l4.108,4.432,4.124-4.433H216.25l3.4-3.686,3.414,3.686h4.81v-1.852h-4.1l-4.123-4.447-4.108,4.447H204.922l-3.415,3.67-3.4-3.67H193.3Z",
    transform: "translate(-138.854 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.334,263.584v4.425l-4.109,4.448,4.109,4.437v11.49l3.4,3.671-3.4,3.671v5.2h1.708V296.5l4.108-4.448-4.108-4.448V276.127l-3.4-3.67,3.4-3.685v-5.187Z",
    transform: "translate(-211.457 -204.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.224,359.661h-4.116l-4.108-4.447-4.108,4.448h-10.634l-3.4,3.686-3.4-3.686h-4.823v1.851h4.114l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.826Z",
    transform: "translate(181.817 -283.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.715,226.477h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825v-1.852h-4.116l-4.108-4.448-4.108,4.447H-45.106l-3.4,3.671-3.4-3.67h-4.81Z",
    transform: "translate(74.874 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.232,263.584v4.425l-4.124,4.448,4.124,4.437v11.49l3.4,3.67-3.4,3.67v5.2H33.94V296.5l4.108-4.447-4.108-4.447v-11.48l-3.414-3.67,3.415-3.686v-5.187Z",
    transform: "translate(2.361 -204.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.893,629.831h-4.1l-4.108-4.447-4.114,4.447H579.941l-3.4,3.671-3.415-3.671h-4.81v1.837h4.1l4.124,4.448,4.107-4.447h10.635l3.4-3.671,3.4,3.671h4.81Z",
    transform: "translate(-459.448 -514.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.065,435.976v-4.44l4.123-4.448-4.124-4.433V411.162l-3.4-3.67,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-532.054 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.325,496.633h4.113l4.112,4.447,4.108-4.447h10.635l3.4-3.671,3.4,3.671h4.81V494.78h-4.1l-4.108-4.432-4.108,4.432H704.949l-3.4,3.686-3.4-3.685h-4.825Z",
    transform: "translate(-566.314 -398.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.364,533.65v4.44l-4.108,4.433,4.108,4.448v11.479l3.411,3.686-3.411,3.671v5.2h1.707v-4.44l4.124-4.433-4.124-4.448V546.208l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-638.919 -435.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.879,629.831h-4.1l-4.108-4.447-4.124,4.447H329.927l-3.414,3.671-3.4-3.671H318.3v1.838h4.1l4.108,4.448,4.123-4.448h10.619L344.67,628l3.4,3.67h4.81Z",
    transform: "translate(-245.718 -514.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.051,435.976v-4.44l4.108-4.448-4.108-4.433V411.162l-3.4-3.671,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.447v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-318.324 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,496.634h4.1l4.124,4.448,4.108-4.447h10.619l3.415-3.67,3.4,3.67h4.81v-1.852h-4.1l-4.108-4.432-4.123,4.432H454.934l-3.4,3.685-3.415-3.685h-4.81Z",
    transform: "translate(-352.583 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.352,533.65v4.441l-4.108,4.432,4.108,4.448v11.479l3.4,3.686-3.4,3.671v5.2h1.708v-4.441l4.108-4.433-4.108-4.448V546.208l-3.4-3.685,3.4-3.671v-5.2Z",
    transform: "translate(-425.191 -435.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.865,629.833h-4.1l-4.123-4.447-4.108,4.447H79.9L76.5,633.5l-3.4-3.671h-4.81v1.837h4.1l4.108,4.448,4.108-4.448H91.241l3.4-3.67,3.415,3.671h4.811Z",
    transform: "translate(-31.988 -514.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.946,435.977v-4.44l4.108-4.448-4.108-4.433V411.162l-3.4-3.67,3.4-3.671v-5.2h-1.708v4.425l-4.123,4.447,4.124,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-104.504 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,496.635h4.1l4.108,4.448,4.124-4.448h10.619l3.4-3.67,3.415,3.671h4.81v-1.852h-4.1l-4.123-4.432-4.108,4.432H204.92l-3.415,3.686-3.4-3.685H193.3Z",
    transform: "translate(-138.853 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.328,533.653v4.44l-4.11,4.433,4.11,4.448v11.479l3.4,3.686-3.4,3.669v5.2h1.709v-4.439l4.109-4.433-4.108-4.448V546.211l-3.4-3.686,3.4-3.671v-5.2Z",
    transform: "translate(-211.451 -435.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.224,629.833h-4.116l-4.108-4.447-4.108,4.447h-10.635l-3.4,3.672-3.4-3.671h-4.823v1.837h4.114l4.108,4.448,4.108-4.448h10.634l3.4-3.671,3.4,3.67h4.825Z",
    transform: "translate(181.817 -514.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.716,496.634h4.1l4.108,4.448,4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.825v-1.852h-4.116l-4.108-4.432-4.108,4.433H-45.107l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(74.875 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.232,533.653v4.44l-4.124,4.432,4.124,4.448v11.479l3.4,3.686-3.4,3.671v5.2h1.707V566.57l4.108-4.432-4.108-4.448V546.211l-3.415-3.685,3.414-3.67v-5.2Z",
    transform: "translate(2.361 -435.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.891,899.9h-4.1l-4.108-4.448-4.114,4.448H579.939l-3.4,3.67-3.414-3.67h-4.811v1.852h4.1l4.123,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.81Z",
    transform: "translate(-459.446 -744.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.063,706.044V701.6l4.123-4.432-4.123-4.448V681.244l-3.4-3.67,3.4-3.686v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.433v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-532.052 -551.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.322,766.713h4.113l4.112,4.436,4.108-4.434h10.634l3.4-3.683,3.4,3.683H727.9v-1.849h-4.1l-4.108-4.448-4.108,4.448H704.946l-3.4,3.671-3.4-3.671h-4.825Z",
    transform: "translate(-566.311 -629.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.362,803.8v4.428l-4.108,4.448,4.108,4.432v11.494l3.41,3.67-3.41,3.686v5.2h1.707v-4.457l4.123-4.432-4.123-4.448V816.349l-3.4-3.67,3.4-3.686V803.8Z",
    transform: "translate(-638.917 -666.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.877,899.9h-4.1l-4.108-4.448-4.124,4.448H329.925l-3.414,3.67-3.4-3.67H318.3v1.852h4.1l4.108,4.432,4.123-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.716 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.047,706.044V701.6l4.108-4.433-4.108-4.448V681.245l-3.4-3.67,3.4-3.686v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-318.321 -551.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.309,766.714h4.1l4.124,4.434,4.108-4.436h10.619l3.414-3.683,3.4,3.683h4.81v-1.85h-4.1l-4.108-4.448-4.123,4.448H454.933l-3.4,3.671-3.415-3.671h-4.81Z",
    transform: "translate(-352.582 -629.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.349,803.8v4.429l-4.108,4.448,4.108,4.432v11.495l3.4,3.671-3.4,3.686v5.2h1.708v-4.456l4.109-4.432-4.108-4.448V816.35l-3.4-3.671,3.4-3.686V803.8Z",
    transform: "translate(-425.188 -666.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.865,899.905h-4.1l-4.124-4.447-4.108,4.447H79.9l-3.4,3.67-3.4-3.67h-4.81v1.852h4.1L76.5,906.19l4.108-4.433H91.241l3.4-3.685,3.415,3.685h4.811Z",
    transform: "translate(-31.988 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.946,706.048v-4.44l4.108-4.433-4.108-4.448V681.248l-3.4-3.671,3.4-3.685v-5.2h-1.707v4.44l-4.123,4.447,4.123,4.432v11.479l3.4,3.686-3.4,3.671v5.2Z",
    transform: "translate(-104.504 -551.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.293,766.718h4.1l4.108,4.434,4.124-4.434h10.619l3.4-3.683,3.414,3.683h4.811v-1.849h-4.1l-4.124-4.448-4.108,4.447h-10.62l-3.414,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-138.851 -629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.327,803.812v4.427l-4.11,4.448,4.11,4.432v11.495l3.4,3.67-3.4,3.685v5.2h1.708v-4.456l4.108-4.432-4.108-4.448V816.357l-3.4-3.67,3.4-3.685v-5.189Z",
    transform: "translate(-211.451 -666.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.231,899.9h-4.116l-4.108-4.448-4.108,4.448H-170.2l-3.4,3.671-3.4-3.67h-4.824v1.853h4.115l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.823 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.719,766.719h4.1l4.108,4.435,4.108-4.435h10.634l3.4-3.684,3.4,3.683h4.825v-1.85h-4.117l-4.108-4.447-4.108,4.447H-45.11l-3.4,3.671-3.4-3.67h-4.81Z",
    transform: "translate(74.877 -629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.23,803.812v4.427l-4.124,4.448,4.123,4.432v11.494l3.4,3.67-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.448V816.358l-3.415-3.671L33.937,809v-5.189Z",
    transform: "translate(2.363 -666.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.888,1169.981h-4.1l-4.108-4.464-4.113,4.464h-10.63l-3.4,3.654-3.414-3.654h-4.811v1.851h4.1l4.123,4.432,4.108-4.431h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.443 -975.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.061,976.216V971.76l4.123-4.433L659.06,962.9V951.417l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.433v11.48l3.4,3.684-3.4,3.686v5.2Z",
    transform: "translate(-532.05 -782.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.321,1036.77h4.111l4.114,4.463,4.108-4.463h10.635l3.4-3.656,3.4,3.654H727.9v-1.82h-4.1l-4.108-4.463-4.108,4.463H704.945l-3.4,3.656-3.4-3.655h-4.826Z",
    transform: "translate(-566.31 -860.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.36,1073.782v4.457l-4.108,4.433,4.108,4.433v11.505l3.41,3.659-3.41,3.686v5.2h1.708v-4.425l4.124-4.463-4.124-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-638.915 -897.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.875,1169.988h-4.1l-4.109-4.463-4.123,4.463H329.923l-3.414,3.654-3.4-3.654H318.3v1.852h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.686,3.4,3.686h4.81Z",
    transform: "translate(-245.715 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.047,976.221v-4.457l4.108-4.433-4.108-4.432V951.422l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.2Z",
    transform: "translate(-318.321 -782.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.309,1036.773h4.1l4.124,4.464,4.108-4.464h10.619l3.414-3.655,3.4,3.655h4.81v-1.821h-4.1l-4.108-4.463-4.124,4.463H454.933l-3.4,3.654-3.414-3.654h-4.81Z",
    transform: "translate(-352.582 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.349,1073.789v4.456l-4.108,4.431,4.108,4.432v11.506l3.4,3.659-3.4,3.686v5.2h1.708v-4.425l4.108-4.463-4.108-4.432v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-425.188 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.863,1169.989h-4.1l-4.123-4.463-4.108,4.463H79.9l-3.4,3.654-3.4-3.654h-4.81v1.852h4.1l4.108,4.432,4.108-4.432H91.239l3.4-3.686,3.415,3.686h4.81Z",
    transform: "translate(-31.987 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.941,976.222v-4.456l4.108-4.433-4.108-4.432V951.421l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.123,4.447,4.124,4.433v11.479l3.4,3.685-3.4,3.686v5.2Z",
    transform: "translate(-104.499 -782.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,1036.773h4.1l4.108,4.464,4.123-4.464h10.619l3.4-3.655,3.414,3.655h4.811v-1.821h-4.1l-4.123-4.463-4.107,4.463h-10.62l-3.414,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-138.848 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.31,1073.789v4.456l-4.112,4.432,4.112,4.433v11.508l3.4,3.657-3.4,3.685v5.2h1.708v-4.425l4.108-4.463-4.108-4.433v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-211.434 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.234,1169.989h-4.116l-4.108-4.463-4.108,4.463H-170.2l-3.4,3.655-3.4-3.654h-4.823v1.851h4.115l4.108,4.432,4.108-4.431h10.634l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.826 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.721,1036.773h4.1l4.108,4.463,4.108-4.463h10.634l3.4-3.655,3.4,3.655h4.824v-1.821h-4.116l-4.108-4.463-4.108,4.463H-45.112l-3.4,3.656-3.4-3.656h-4.81Z",
    transform: "translate(74.879 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.227,1073.789v4.456l-4.124,4.432,4.124,4.433v11.508l3.4,3.657-3.4,3.685v5.2h1.708v-4.425l4.108-4.463-4.108-4.432v-11.479l-3.415-3.686,3.415-3.685v-5.2Z",
    transform: "translate(2.365 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.887,1440.236h-4.1l-4.108-4.432-4.113,4.432h-10.63l-3.4,3.685-3.414-3.685h-4.81v1.852h4.1l4.123,4.432,4.108-4.432h10.631l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.443 -1206.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.059,1246.38v-4.425l4.123-4.463-4.123-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2H657.35v4.424l-4.108,4.432,4.108,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-532.048 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.32,1307.051h4.111l4.114,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81V1305.2h-4.1l-4.108-4.433-4.109,4.433H704.943l-3.4,3.685-3.4-3.685H693.32Z",
    transform: "translate(-566.309 -1091.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.357,1344.068v4.425l-4.108,4.432,4.108,4.464v11.479l3.409,3.655-3.41,3.686v5.2h1.708v-4.426l4.124-4.463-4.124-4.433v-11.478l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-638.913 -1128.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.872,1440.236h-4.1l-4.108-4.432-4.124,4.432H329.92l-3.414,3.686-3.4-3.685H318.3v1.853h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.712 -1206.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.043,1246.381v-4.426l4.108-4.464-4.108-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2h-1.707v4.425l-4.108,4.433,4.108,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-318.317 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.306,1307.052h4.1l4.124,4.432,4.108-4.432h10.619l3.415-3.685,3.4,3.685h4.81V1305.2h-4.1l-4.108-4.433-4.124,4.433H454.93l-3.4,3.686-3.414-3.685h-4.81Z",
    transform: "translate(-352.58 -1091.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.342,1344.068v4.426l-4.108,4.432,4.108,4.464v11.479l3.4,3.655-3.4,3.686v5.2h1.708v-4.426l4.108-4.463-4.108-4.432v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-425.182 -1128.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,1440.24h-4.1l-4.123-4.432-4.108,4.432H79.892l-3.4,3.685-3.4-3.685H68.284v1.851h4.1l4.108,4.432,4.108-4.432H91.236l3.4-3.686,3.414,3.686h4.81Z",
    transform: "translate(-31.984 -1206.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,1246.381v-4.426l4.108-4.464-4.108-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2h-1.708v4.426l-4.123,4.432,4.123,4.463v11.479l3.4,3.654-3.4,3.686v5.2Z",
    transform: "translate(-104.499 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,1307.058h4.1l4.108,4.432,4.124-4.433h10.619l3.4-3.686,3.415,3.686h4.81v-1.851h-4.1l-4.123-4.432-4.108,4.432h-10.62l-3.415,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-138.848 -1091.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1344.073v4.425l-4.113,4.433,4.113,4.463v11.479l3.4,3.656-3.4,3.684v5.2h1.709v-4.425l4.109-4.462-4.108-4.433v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-211.425 -1128.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.235,1440.241h-4.116l-4.108-4.433-4.108,4.432H-170.2l-3.4,3.685-3.4-3.685h-4.823v1.852h4.115l4.108,4.432,4.108-4.432h10.635l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.826 -1206.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.724,1307.056h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825V1305.2h-4.116l-4.108-4.432-4.108,4.433H-45.115l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(74.882 -1091.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.227,1344.073v4.425l-4.123,4.432,4.124,4.463v11.479l3.4,3.655-3.4,3.685v5.2h1.708v-4.425l4.107-4.462-4.108-4.432v-11.479l-3.414-3.686,3.414-3.655v-5.2Z",
    transform: "translate(2.365 -1128.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.884,1710.3h-4.1l-4.109-4.433-4.113,4.433h-10.63l-3.4,3.685-3.415-3.685h-4.811v1.852h4.1l4.123,4.431,4.108-4.432h10.626l3.409-3.686,3.4,3.685h4.81Z",
    transform: "translate(-459.44 -1437.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.055,1516.452v-4.426l4.123-4.432-4.123-4.463v-11.479l-3.4-3.685,3.4-3.656v-5.2h-1.708v4.424l-4.108,4.433,4.108,4.462v11.48l3.4,3.685-3.4,3.654v5.2Z",
    transform: "translate(-532.045 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.317,1577.122h4.112l4.113,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.81v-1.851h-4.1l-4.108-4.433-4.108,4.433H704.941l-3.4,3.685-3.4-3.685h-4.826Z",
    transform: "translate(-566.307 -1322.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.353,1614.138v4.425l-4.108,4.463,4.109,4.433v11.479l3.409,3.685-3.41,3.655v5.2h1.708v-4.425l4.123-4.432-4.123-4.464v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-638.909 -1359.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.872,1710.307h-4.1l-4.109-4.432-4.123,4.433H329.92l-3.415,3.685-3.4-3.685H318.3v1.852h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.712 -1437.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04,1516.452v-4.425l4.108-4.433-4.108-4.463v-11.479l-3.4-3.685,3.4-3.656v-5.2h-1.708v4.424l-4.108,4.433,4.108,4.463v11.478l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-318.315 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.306,1577.124h4.1l4.124,4.433,4.109-4.433h10.619l3.414-3.686,3.4,3.686h4.81v-1.851h-4.1l-4.108-4.432-4.123,4.432H454.93l-3.4,3.685-3.414-3.685h-4.81Z",
    transform: "translate(-352.58 -1322.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.34,1614.141v4.425l-4.108,4.463,4.108,4.432v11.479l3.4,3.686-3.4,3.655v5.2h1.708v-4.425l4.108-4.432-4.108-4.464v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-425.18 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.857,1710.309h-4.1l-4.123-4.433-4.107,4.432H79.889l-3.4,3.685-3.4-3.685h-4.81v1.852h4.1l4.108,4.432,4.108-4.432H91.233l3.4-3.686,3.414,3.686h4.81Z",
    transform: "translate(-31.982 -1437.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,1516.452v-4.425l4.108-4.433-4.108-4.463v-11.479l-3.4-3.685,3.4-3.655v-5.2h-1.707v4.425l-4.123,4.432,4.123,4.462v11.48l3.4,3.685-3.4,3.655v5.2Z",
    transform: "translate(-104.499 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.288,1577.124h4.1l4.108,4.433,4.123-4.433H216.24l3.4-3.685,3.415,3.685h4.81v-1.852h-4.1l-4.124-4.432-4.108,4.432h-10.62l-3.414,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-138.846 -1322.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1614.141v4.425l-4.113,4.463,4.113,4.433v11.479l3.4,3.686-3.4,3.655v5.2h1.709v-4.425l4.108-4.432-4.108-4.463v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-211.425 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.238,1710.31h-4.116l-4.108-4.432-4.109,4.433H-170.2l-3.4,3.686-3.4-3.686h-4.824v1.852h4.115l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.826Z",
    transform: "translate(181.829 -1437.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.724,1577.128h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825v-1.852h-4.117l-4.108-4.432-4.108,4.432H-45.115l-3.4,3.686-3.4-3.685h-4.81Z",
    transform: "translate(74.882 -1322.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.224,1614.141v4.426l-4.123,4.463,4.123,4.432v11.48l3.4,3.685-3.4,3.655v5.2h1.708v-4.426l4.108-4.432-4.108-4.463v-11.479l-3.414-3.655,3.414-3.685v-5.2Z",
    transform: "translate(2.367 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.88,1980.372h-4.1l-4.108-4.433-4.113,4.433h-10.63l-3.4,3.685-3.414-3.685H568.3v1.851h4.1l4.123,4.463,4.107-4.462h10.626l3.408-3.655,3.4,3.655h4.81Z",
    transform: "translate(-459.437 -1668.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.053,1786.518v-4.426l4.122-4.432-4.122-4.463v-11.479l-3.4-3.654,3.4-3.686v-5.2h-1.708v4.425l-4.108,4.463,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-532.043 -1474.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.315,1847.19h4.112l4.113,4.432,4.108-4.433h10.634l3.4-3.664,3.4,3.664h4.81v-1.851h-4.1l-4.108-4.432-4.108,4.432H704.939l-3.4,3.686-3.4-3.686h-4.826Z",
    transform: "translate(-566.305 -1553.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.348,1884.2v4.425l-4.109,4.463,4.108,4.433V1909l3.409,3.685-3.41,3.686v5.2h1.709v-4.457l4.124-4.433-4.124-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-638.904 -1590.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.868,1980.379h-4.1l-4.108-4.432-4.123,4.432h-10.62l-3.414,3.685-3.4-3.685h-4.81v1.852h4.1l4.108,4.462,4.123-4.463h10.62l3.414-3.654,3.4,3.654h4.81Z",
    transform: "translate(-245.709 -1668.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04,1786.52v-4.426l4.108-4.432-4.108-4.463V1761.72l-3.4-3.655,3.4-3.686v-5.2h-1.707v4.425l-4.108,4.463,4.108,4.432v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-318.315 -1474.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3,1847.195h4.1l4.123,4.433,4.108-4.433h10.62l3.415-3.664,3.4,3.664h4.81v-1.853h-4.1l-4.108-4.432-4.123,4.432H454.925l-3.4,3.685-3.414-3.685H443.3Z",
    transform: "translate(-352.575 -1553.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.34,1884.211v4.425l-4.107,4.462,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.48l-3.4-3.685,3.4-3.685v-5.2Z",
    transform: "translate(-425.18 -1590.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.856,1980.38h-4.1l-4.123-4.432-4.107,4.432H79.889l-3.4,3.685-3.4-3.685H68.28v1.852h4.1l4.108,4.463,4.109-4.463H91.232l3.4-3.654,3.414,3.654h4.811Z",
    transform: "translate(-31.981 -1668.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.936,1786.525V1782.1l4.109-4.433-4.108-4.462v-11.479l-3.4-3.656,3.4-3.685v-5.2h-1.708v4.425l-4.123,4.462,4.124,4.432v11.48l3.4,3.686-3.4,3.686v5.172Z",
    transform: "translate(-104.495 -1474.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.286,1847.2h4.1l4.108,4.433,4.123-4.433h10.619l3.4-3.665,3.415,3.665h4.81v-1.851h-4.1l-4.124-4.432-4.108,4.432H204.91l-3.414,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-138.845 -1553.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1884.214v4.425l-4.113,4.462,4.113,4.433v11.48l3.4,3.685-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.479l-3.4-3.685,3.4-3.685v-5.2Z",
    transform: "translate(-211.422 -1590.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.247,1980.375h-4.116l-4.108-4.433-4.108,4.433h-10.634l-3.4,3.686-3.4-3.685h-4.825l0,1.851h4.114l4.108,4.463,4.108-4.463h10.634l3.4-3.656,3.4,3.655h4.825Z",
    transform: "translate(181.838 -1668.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.728,1847.195h4.1l4.108,4.433,4.109-4.434h10.634l3.4-3.66,3.4,3.66h4.825v-1.851h-4.116l-4.108-4.432-4.108,4.432H-45.12l-3.4,3.686-3.4-3.686h-4.811Z",
    transform: "translate(74.885 -1553.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,1884.211v4.425L28.1,1893.1l4.124,4.432v11.479l3.4,3.686-3.4,3.685v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.479l-3.415-3.686,3.414-3.685v-5.2Z",
    transform: "translate(2.371 -1590.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.015,89.581h-4.086l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.67-3.4-3.67h-4.811v1.836h4.086l4.124,4.447,4.123-4.447h10.619l3.4-3.67,3.4,3.67h4.811Z",
    transform: "translate(-887.001 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.724v4.437l-4.093,4.436,4.093,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-959.606 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461-43.616h4.117l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086l-4.123-4.432-4.093,4.433h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-993.866 63.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.487-6.6v4.441L1278.4,2.274l4.092,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.724v-4.44l4.123-4.433-4.123-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1066.473 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,89.581h-4.113l-4.124-4.448-4.092,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.837h4.117l4.093,4.448,4.123-4.447h10.619l3.4-3.67,3.4,3.67h4.838Z",
    transform: "translate(-1100.729 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.214-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.724v4.437l-4.092,4.436,4.093,4.448v11.479l3.43,3.67-3.43,3.686v5.2Z",
    transform: "translate(-1173.335 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473-43.615h4.117l4.093,4.448,4.124-4.447h10.619l3.4-3.67,3.4,3.67h4.841v-1.852h-4.117l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.594 63.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525-6.6v4.441l-4.12,4.432,4.12,4.448,0,11.479,3.4,3.686-3.4,3.67,0,5.2h1.694v-4.44l4.124-4.432-4.124-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1280.2 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.07,89.581h-4.117l-4.123-4.448-4.093,4.448h-10.649l-3.4,3.67-3.4-3.67h-4.81v1.837h4.117l4.093,4.448,4.123-4.447h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1314.457 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.227-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.692v4.437l-4.124,4.436,4.124,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-1387.063 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.488-43.617h4.116l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.431,3.67h4.809v-1.852h-4.116l-4.124-4.432-4.092,4.432h-10.619l-3.43,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-1421.324 63.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541-6.6v4.44l-4.124,4.433,4.124,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.693v-4.44l4.124-4.433-4.123-4.447V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1493.928 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,89.581h-4.117l-4.124-4.447-4.093,4.448H1830.13l-3.431,3.671-3.4-3.671h-4.811v1.837h4.116l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1528.185 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.238-104.274v-4.441l4.124-4.448-4.124-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.693v4.437l-4.123,4.436,4.123,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-1600.791 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5-43.618h4.117l4.093,4.448,4.123-4.447h10.619l3.427-3.67,3.4,3.67h4.81V-45.47h-4.117l-4.1-4.432-4.12,4.432h-10.619l-3.429,3.686-3.4-3.686H1943.5Z",
    transform: "translate(-1635.052 63.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.015,359.649h-4.086l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.81V361.5h4.086l4.124,4.433,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.811Z",
    transform: "translate(-887.001 -283.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,165.792v-4.437l4.123-4.435-4.123-4.448V140.992l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.441l-4.093,4.448,4.093,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-959.604 -89.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,226.466h4.116l4.094,4.432,4.123-4.432h10.62l3.4-3.686,3.4,3.685h4.81v-1.852h-4.085l-4.123-4.447-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-993.866 -167.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,263.57V268l-4.093,4.448,4.093,4.435V288.37l3.4,3.67-3.4,3.67v5.2h1.724v-4.425l4.124-4.447-4.124-4.448V276.113l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-1066.467 -204.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,359.647h-4.113l-4.124-4.448-4.093,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.811V361.5h4.116l4.092,4.432,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.729 -283.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.214,165.792v-4.438l4.123-4.435-4.123-4.448V140.992l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.44l-4.092,4.447,4.092,4.433v11.479l3.43,3.686-3.43,3.67v5.2Z",
    transform: "translate(-1173.335 -89.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,226.462h4.117l4.093,4.432,4.124-4.432h10.619l3.4-3.686,3.4,3.685h4.841V224.61h-4.117l-4.123-4.448-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1207.594 -167.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,263.575V268l-4.12,4.448,4.12,4.435v11.491l3.4,3.67-3.4,3.67,0,5.2h1.694v-4.425l4.124-4.447-4.124-4.448V276.118l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-1280.2 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.07,359.647h-4.117l-4.123-4.448-4.093,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.81V361.5h4.117l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.429,3.686h4.811Z",
    transform: "translate(-1314.457 -283.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,165.794v-4.438l4.123-4.435-4.123-4.448V140.994l-3.4-3.67,3.4-3.686v-5.2h-1.692v4.44l-4.123,4.448,4.124,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-1387.06 -89.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.488,226.462h4.116l4.093,4.432,4.123-4.432h10.62l3.4-3.685,3.431,3.686h4.809V224.61h-4.117l-4.123-4.448-4.092,4.448h-10.619l-3.43,3.67-3.4-3.671h-4.809Z",
    transform: "translate(-1421.324 -167.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,263.575V268l-4.123,4.448,4.123,4.435v11.492l3.4,3.67-3.4,3.67v5.2h1.692v-4.425l4.124-4.447-4.124-4.448V276.118l-3.4-3.671,3.4-3.686v-5.187Z",
    transform: "translate(-1493.928 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,359.649h-4.117l-4.124-4.448-4.093,4.448H1830.13l-3.431,3.685-3.4-3.685h-4.811V361.5h4.117l4.092,4.433,4.124-4.432h10.619l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.185 -283.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,165.794v-4.437l4.124-4.435-4.124-4.448V140.994l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.123,4.433v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-1600.788 -89.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,226.466h4.117l4.092,4.432,4.124-4.432h10.619l3.427-3.686,3.4,3.686h4.811v-1.852h-4.117l-4.1-4.448-4.121,4.447h-10.619l-3.429,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1635.05 -167.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.013,629.819h-4.086l-4.123-4.447-4.094,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.838h4.086l4.123,4.448,4.124-4.448H1091.4l3.4-3.67,3.4,3.67h4.811Z",
    transform: "translate(-886.999 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,435.963v-4.44l4.123-4.448-4.123-4.432V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.724v4.425l-4.093,4.448,4.093,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,496.622h4.116l4.094,4.448,4.123-4.448h10.62l3.4-3.67,3.4,3.67h4.809v-1.852h-4.087l-4.123-4.432-4.092,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-993.866 -398.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,533.639v4.44l-4.093,4.432,4.093,4.448v11.479l3.4,3.686-3.4,3.67V571h1.723v-4.441l4.124-4.432-4.124-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1066.467 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,629.819h-4.113l-4.124-4.447-4.092,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.838h4.117l4.092,4.447,4.123-4.448h10.619l3.4-3.67,3.4,3.67h4.838Z",
    transform: "translate(-1100.729 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,435.963v-4.44l4.123-4.448-4.123-4.432V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.724v4.425l-4.093,4.448,4.092,4.448v11.478l3.43,3.671-3.43,3.685v5.2Z",
    transform: "translate(-1173.332 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,496.62h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.4,3.67h4.84v-1.852h-4.116l-4.123-4.432-4.094,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.594 -398.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,533.639v4.44l-4.12,4.432,4.12,4.448v11.479l3.4,3.686-3.4,3.67V571h1.7v-4.441l4.124-4.432-4.124-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1280.2 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,629.819h-4.117l-4.123-4.447-4.093,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.837h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.429,3.67h4.811Z",
    transform: "translate(-1314.454 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,435.963v-4.44l4.123-4.448-4.123-4.433V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.447v11.48l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,496.62h4.117l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.431,3.67h4.809v-1.852h-4.116l-4.124-4.433-4.092,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1421.322 -398.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,533.639v4.44l-4.124,4.432,4.124,4.448v11.479l3.4,3.686-3.4,3.67V571h1.692v-4.44l4.124-4.432-4.123-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1493.928 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,629.819h-4.117l-4.124-4.446-4.093,4.447H1830.13l-3.431,3.671-3.4-3.671h-4.811v1.838h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1528.185 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.238,435.962v-4.439l4.124-4.448-4.124-4.432V411.15l-3.4-3.671,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-1600.791 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,496.622h4.117l4.094,4.448,4.123-4.448h10.619l3.427-3.67,3.4,3.67h4.811v-1.852h-4.117l-4.1-4.432-4.121,4.432h-10.619l-3.429,3.686-3.4-3.686H1943.5Z",
    transform: "translate(-1635.05 -398.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.013,899.887h-4.087l-4.123-4.448-4.094,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.852h4.086l4.123,4.433,4.124-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -744.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,706.029v-4.44l4.123-4.432-4.123-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.44l-4.093,4.448,4.093,4.432V693.47l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-959.604 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,766.7h4.116l4.094,4.438,4.123-4.438h10.619l3.4-3.68,3.4,3.68h4.81v-1.847h-4.086l-4.123-4.448-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-993.866 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,803.774v4.43l-4.093,4.448,4.093,4.432v11.495l3.4,3.67-3.4,3.687v5.2h1.723v-4.456l4.124-4.432L1284.2,827.8V816.322l-3.4-3.67,3.4-3.685v-5.192Z",
    transform: "translate(-1066.467 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,899.888h-4.113l-4.124-4.448-4.092,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.852h4.116l4.093,4.433,4.123-4.433h10.62l3.4-3.685,3.4,3.685h4.837Z",
    transform: "translate(-1100.726 -744.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,706.029v-4.441l4.123-4.432-4.124-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.723v4.44l-4.092,4.448,4.092,4.432v11.479l3.431,3.686-3.431,3.67v5.2Z",
    transform: "translate(-1173.332 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,766.7h4.117l4.092,4.438,4.124-4.437h10.619l3.4-3.68,3.4,3.68h4.84v-1.848h-4.116l-4.123-4.448-4.094,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1207.594 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,803.774v4.43l-4.12,4.448,4.12,4.433v11.495l3.4,3.67-3.4,3.686v5.2h1.7v-4.456l4.124-4.433-4.124-4.447V816.323l-3.4-3.671,3.4-3.685v-5.192Z",
    transform: "translate(-1280.2 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,899.886h-4.117l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.671-3.4-3.67h-4.81v1.852h4.117l4.093,4.432,4.123-4.433h10.618l3.4-3.686,3.429,3.686h4.811Z",
    transform: "translate(-1314.454 -744.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,706.029v-4.441l4.123-4.432-4.123-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.124,4.433v11.479l3.4,3.685-3.4,3.67v5.2Z",
    transform: "translate(-1387.06 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,766.7h4.117l4.092,4.437,4.123-4.437h10.619l3.4-3.68,3.431,3.68h4.809v-1.846h-4.117l-4.123-4.448-4.093,4.448h-10.619l-3.43,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1421.322 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,803.774v4.43l-4.123,4.448,4.123,4.432v11.495l3.4,3.67-3.4,3.686v5.2h1.693v-4.456l4.124-4.433-4.124-4.447V816.322l-3.4-3.67,3.4-3.685v-5.192Z",
    transform: "translate(-1493.928 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,899.886h-4.117l-4.124-4.448-4.093,4.448h-10.618l-3.431,3.67-3.4-3.67h-4.81v1.852h4.117l4.092,4.433,4.124-4.433h10.619l3.4-3.686,3.43,3.686h4.81Z",
    transform: "translate(-1528.183 -744.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,706.029v-4.441l4.124-4.432-4.124-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.123,4.432v11.479l3.4,3.685-3.4,3.671v5.2Z",
    transform: "translate(-1600.788 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,766.7h4.117l4.094,4.438,4.123-4.437h10.618l3.428-3.68,3.4,3.68h4.811v-1.846h-4.117l-4.1-4.448-4.121,4.448h-10.619l-3.43,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1635.05 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1169.97h-4.085l-4.123-4.463-4.094,4.463h-10.649l-3.4,3.655-3.4-3.655h-4.81v1.853h4.086l4.124,4.433,4.122-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,976.2v-4.455l4.123-4.432-4.123-4.432V951.4l-3.4-3.687,3.4-3.67v-5.2h-1.723v4.425l-4.093,4.448,4.093,4.432V963.63l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -782.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,1036.752h4.116l4.094,4.462,4.124-4.462h10.62l3.4-3.656,3.4,3.656h4.81v-1.822h-4.086l-4.123-4.464-4.092,4.464h-10.651l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-993.866 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,1073.775v4.455l-4.093,4.432,4.093,4.433v11.5l3.4,3.66-3.4,3.685v5.2h1.723v-4.425l4.123-4.463-4.123-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1066.467 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1169.971h-4.114l-4.124-4.463-4.092,4.463h-10.651l-3.4,3.655-3.4-3.655h-4.81v1.851h4.117l4.092,4.433,4.124-4.433h10.62l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.726 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,976.2v-4.455l4.123-4.433-4.124-4.432V951.4l-3.4-3.686,3.4-3.671v-5.2h-1.723v4.426l-4.093,4.448,4.093,4.432v11.479l3.43,3.686-3.43,3.686v5.2Z",
    transform: "translate(-1173.332 -782.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,1036.752h4.117l4.092,4.462,4.124-4.462h10.619l3.4-3.656,3.4,3.656h4.841v-1.821h-4.116l-4.123-4.464-4.093,4.464h-10.65l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1207.594 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1073.775v4.455l-4.12,4.432,4.12,4.433v11.5l3.4,3.667-3.4,3.685v5.2h1.7v-4.425l4.124-4.463-4.124-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1280.196 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,1169.967h-4.117l-4.124-4.464-4.093,4.464h-10.65l-3.4,3.655-3.4-3.655h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.685,3.429,3.685h4.811Z",
    transform: "translate(-1314.454 -975.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,976.2v-4.455l4.123-4.433-4.123-4.432V951.4l-3.4-3.686,3.4-3.671v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.433v11.479l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -782.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1036.752h4.116l4.093,4.462,4.123-4.462h10.619l3.4-3.656,3.43,3.656h4.81v-1.821h-4.117l-4.124-4.464-4.092,4.463h-10.62l-3.429,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1421.322 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,1073.775v4.455l-4.123,4.432,4.123,4.433v11.5l3.4,3.66-3.4,3.685v5.2h1.692v-4.425l4.124-4.463-4.124-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1493.928 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1169.97h-4.117l-4.124-4.463-4.093,4.463h-10.618l-3.431,3.655-3.4-3.655h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.62l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.183 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,976.2v-4.456l4.124-4.432-4.124-4.432V951.4l-3.4-3.687,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.447,4.123,4.433V963.63l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-1600.788 -782.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,1036.752h4.116l4.093,4.463,4.124-4.463h10.618l3.428-3.656,3.4,3.656h4.811v-1.821h-4.116l-4.1-4.464-4.121,4.464h-10.619l-3.43,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1635.05 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1440.214h-4.086l-4.123-4.432-4.094,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.086l4.123,4.433,4.124-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1246.358v-4.425l4.123-4.463-4.123-4.432v-11.479l-3.4-3.686,3.4-3.659v-5.2h-1.723v4.425l-4.093,4.432,4.093,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,1307.03h4.116l4.094,4.432,4.123-4.432h10.619l3.4-3.686,3.4,3.686h4.81v-1.852h-4.086l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-993.866 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.48,1344.051v4.425l-4.093,4.432,4.093,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.723v-4.426l4.123-4.462-4.124-4.434v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-1066.467 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1440.214h-4.114l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.685-3.4-3.685h-4.81v1.852h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.684,3.4,3.684h4.833Z",
    transform: "translate(-1100.726 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1246.357v-4.425l4.123-4.463-4.124-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.463v11.479l3.43,3.655-3.43,3.686v5.2Z",
    transform: "translate(-1173.332 -1012.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1307.03h4.118l4.092,4.432,4.124-4.432h10.619l3.4-3.686,3.4,3.686h4.841v-1.852h-4.116l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.589 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1344.051v4.425l-4.12,4.432,4.12,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.7v-4.426l4.124-4.462-4.124-4.434v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-1280.196 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,1440.214h-4.117l-4.124-4.432-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.433,4.124-4.433h10.618l3.4-3.685,3.43,3.685h4.811Z",
    transform: "translate(-1314.454 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,1246.359v-4.425l4.123-4.463-4.124-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.693v4.425l-4.123,4.432,4.123,4.464v11.478l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1307.03h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.43,3.686h4.81v-1.852h-4.116l-4.124-4.433-4.092,4.433h-10.62l-3.429,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1421.322 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,1344.051v4.425l-4.123,4.432,4.123,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.692v-4.426l4.123-4.463-4.123-4.432v-11.479l-3.4-3.686,3.4-3.655v-5.2Z",
    transform: "translate(-1493.928 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1440.219h-4.117l-4.123-4.432-4.093,4.432h-10.618l-3.431,3.686-3.4-3.687h-4.81v1.851h4.117l4.092,4.433,4.123-4.433h10.62l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.183 -1206.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,1246.359v-4.425l4.124-4.463-4.123-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.693v4.425l-4.123,4.432,4.123,4.464v11.478l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-1600.788 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.493,1307.03h4.117l4.093,4.432,4.124-4.432h10.619l3.428-3.685,3.4,3.685h4.81v-1.852h-4.117l-4.095-4.433-4.121,4.433h-10.619l-3.43,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1635.046 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1710.284h-4.086l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.685-3.4-3.685h-4.81v1.852h4.086l4.124,4.433,4.122-4.432H1091.4l3.4-3.684,3.4,3.684h4.81Z",
    transform: "translate(-886.999 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1516.424V1512l4.123-4.432-4.123-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.462v11.479l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-959.604 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.456,1577.1h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.811v-1.851h-4.086l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.809Z",
    transform: "translate(-993.861 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.478,1614.119v4.425l-4.093,4.462,4.093,4.433v11.48l3.4,3.685-3.4,3.655v5.2h1.724v-4.424l4.124-4.433-4.124-4.463v-11.479l-3.4-3.654,3.4-3.686v-5.2Z",
    transform: "translate(-1066.465 -1359.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.046,1710.284h-4.108l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.726 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1516.425V1512l4.124-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.462v11.479l3.43,3.686-3.43,3.655v5.2Z",
    transform: "translate(-1173.332 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1577.1h4.117l4.092,4.432,4.124-4.432h10.619l3.4-3.685,3.4,3.685h4.841v-1.851h-4.116l-4.124-4.433-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-1207.589 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1614.116v4.425L1528.4,1623l4.12,4.433v11.48l3.4,3.685-3.4,3.655v5.2h1.7v-4.425l4.124-4.432-4.123-4.463v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-1280.196 -1359.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.063,1710.285h-4.117l-4.124-4.432-4.093,4.432h-10.649l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.432,4.124-4.432h10.618l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1314.451 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.223,1516.425V1512l4.123-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.693v4.425l-4.123,4.433,4.123,4.463v11.479l3.4,3.685-3.4,3.655v5.2Z",
    transform: "translate(-1387.06 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.48,1577.1h4.117l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.43,3.686h4.81v-1.852h-4.117l-4.123-4.432-4.093,4.432h-10.62l-3.429,3.685-3.4-3.686h-4.81Z",
    transform: "translate(-1421.318 -1322.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,1614.116v4.426l-4.123,4.463,4.123,4.432v11.48l3.4,3.685-3.4,3.655v5.2h1.692v-4.425l4.123-4.433-4.123-4.463v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-1493.928 -1359.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1710.284h-4.118l-4.124-4.432-4.092,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.433,4.123-4.432h10.62l3.4-3.684,3.43,3.684h4.811Z",
    transform: "translate(-1528.183 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,1516.425V1512l4.124-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.692v4.425l-4.123,4.433,4.123,4.463v11.479l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-1600.788 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.494,1577.1h4.116l4.093,4.432,4.124-4.432h10.619l3.428-3.685,3.4,3.685h4.81v-1.851h-4.117l-4.095-4.433-4.122,4.433h-10.618l-3.43,3.685-3.4-3.685h-4.811Z",
    transform: "translate(-1635.046 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1980.35h-4.086l-4.123-4.432-4.093,4.432h-10.649l-3.4,3.685-3.4-3.685h-4.81v1.852h4.086l4.123,4.464,4.124-4.464H1091.4l3.4-3.654,3.4,3.654h4.81Z",
    transform: "translate(-886.999 -1668.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1786.49v-4.425l4.123-4.433-4.123-4.462v-11.48l-3.4-3.656,3.4-3.685v-5.2h-1.723v4.425l-4.092,4.462,4.093,4.433v11.479l3.4,3.685-3.4,3.686v5.171Z",
    transform: "translate(-959.604 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.456,1847.165h4.116l4.093,4.433,4.123-4.433h10.619l3.4-3.683,3.4,3.683h4.811v-1.852h-4.085l-4.123-4.432-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-993.861 -1553.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.48,1884.182v4.425l-4.093,4.462,4.093,4.432v11.48l3.4,3.686-3.4,3.685v5.2h1.723V1917.1l4.123-4.432-4.123-4.433v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-1066.467 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1980.352h-4.114l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.092,4.464,4.123-4.464h10.619l3.4-3.654,3.4,3.654h4.838Z",
    transform: "translate(-1100.726 -1668.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1786.49v-4.425l4.124-4.433-4.123-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.724v4.425l-4.092,4.463,4.092,4.433v11.479l3.43,3.686-3.43,3.685v5.172Z",
    transform: "translate(-1173.332 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1847.166h4.118l4.092,4.432,4.124-4.433h10.619l3.4-3.683,3.4,3.683h4.841v-1.852h-4.116l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-1207.589 -1553.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1884.182v4.425l-4.12,4.463,4.12,4.432v11.48l3.4,3.685-3.4,3.685v5.2h1.7V1917.1l4.124-4.432-4.124-4.433v-11.478l-3.4-3.687,3.4-3.685v-5.2Z",
    transform: "translate(-1280.196 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.063,1980.346h-4.117l-4.123-4.433-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.464,4.124-4.463h10.618l3.4-3.655,3.43,3.655h4.81Z",
    transform: "translate(-1314.451 -1668.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,1786.49v-4.425l4.123-4.433-4.124-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.692v4.425l-4.123,4.463,4.123,4.433v11.479l3.4,3.685-3.4,3.686v5.171Z",
    transform: "translate(-1387.06 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1847.162h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.683,3.43,3.683h4.81v-1.852h-4.117l-4.123-4.433-4.092,4.432h-10.62l-3.429,3.685-3.4-3.685h-4.809Z",
    transform: "translate(-1421.322 -1553.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.535,1884.182v4.425l-4.123,4.462,4.123,4.432v11.48l3.4,3.685-3.4,3.686v5.2h1.692V1917.1l4.123-4.432-4.123-4.433v-11.478l-3.4-3.687,3.4-3.686v-5.2Z",
    transform: "translate(-1493.923 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1980.35h-4.118l-4.123-4.432-4.093,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.464,4.123-4.464h10.619l3.4-3.654,3.431,3.655h4.809Z",
    transform: "translate(-1528.183 -1668.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.23,1786.49v-4.425l4.124-4.433-4.124-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.692v4.425l-4.124,4.463,4.124,4.433v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-1600.784 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.49,1847.168h4.117l4.093,4.433,4.124-4.432h10.619l3.428-3.683,3.4,3.683h4.81v-1.852h-4.117l-4.095-4.432-4.121,4.433H1955.13L1951.7,1849l-3.4-3.685h-4.81Z",
    transform: "translate(-1635.044 -1553.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,89.585h-4.086L844.7,85.138,840.6,89.585H829.962l-3.4,3.671-3.4-3.671h-4.825v1.837h4.117l4.108,4.448,4.108-4.448h10.635l3.4-3.67,3.4,3.67h4.81Z",
    transform: "translate(-673.184 -52.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1-104.271v-4.44l4.108-4.448-4.108-4.432v-11.479l-3.415-3.686,3.415-3.67v-5.2h-1.723v4.438l-4.108,4.434,4.108,4.448v11.479l3.415,3.67-3.415,3.686v5.2Z",
    transform: "translate(-745.786 141.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449-43.615h4.1l4.108,4.448,4.124-4.448H966.4l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086L969.8-49.9l-4.124,4.432H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 63.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.474-6.6v4.441l-4.093,4.432,4.092,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.723v-4.44l4.093-4.432-4.093-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-852.744 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,359.65h-4.086L844.7,355.2,840.6,359.65H829.962l-3.4,3.685-3.4-3.685h-4.826V361.5h4.116l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -283.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,165.795v-4.437l4.108-4.435-4.108-4.448V141l-3.415-3.67,3.415-3.686v-5.2h-1.723v4.44l-4.108,4.448,4.108,4.433v11.479l3.414,3.686-3.415,3.67v5.2Z",
    transform: "translate(-745.786 -89.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,226.467h4.1l4.108,4.432,4.124-4.432H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.086l-4.123-4.448-4.124,4.448H955.058l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-780.137 -167.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.475,263.575V268l-4.092,4.448,4.092,4.435v11.492l3.4,3.67-3.4,3.67v5.2h1.723v-4.425l4.093-4.448L1034.2,287.6V276.118l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-852.745 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,629.823h-4.086l-4.124-4.447-4.108,4.447H829.962l-3.4,3.671-3.4-3.671h-4.825v1.838h4.117l4.108,4.448,4.108-4.448h10.635l3.4-3.67,3.4,3.67h4.81Z",
    transform: "translate(-673.184 -514.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,435.968v-4.44l4.108-4.447-4.108-4.433V411.155l-3.415-3.67,3.415-3.67v-5.2h-1.723v4.425l-4.108,4.448,4.108,4.448v11.479l3.415,3.671-3.414,3.685v5.2Z",
    transform: "translate(-745.786 -320.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,496.625h4.1l4.108,4.448,4.124-4.448H966.4l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086l-4.123-4.432-4.124,4.432H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 -398.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.475,533.643v4.44l-4.092,4.433,4.092,4.448v11.479l3.4,3.686-3.4,3.67V571h1.723v-4.44l4.093-4.432-4.093-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-852.745 -435.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,899.891h-4.086l-4.124-4.448-4.108,4.448H829.962l-3.4,3.67-3.4-3.67h-4.826v1.852h4.117l4.108,4.433,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -744.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,706.033v-4.441l4.108-4.432-4.108-4.448V681.233l-3.415-3.67,3.415-3.686v-5.2h-1.723v4.44l-4.108,4.448L907.376,682v11.479l3.414,3.686-3.415,3.67v5.2Z",
    transform: "translate(-745.788 -551.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,766.7l4.1,0,4.108,4.437,4.124-4.437H966.4l3.4-3.681,3.4,3.681h4.81v-1.846h-4.086l-4.123-4.448-4.124,4.448H955.058l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-780.137 -629.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.474,803.781v4.43l-4.092,4.448,4.093,4.432v11.494l3.4,3.671-3.4,3.686v5.2h1.723v-4.456l4.093-4.432-4.093-4.448V816.329l-3.4-3.67,3.4-3.686v-5.19Z",
    transform: "translate(-852.744 -666.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1169.972h-4.086l-4.124-4.463-4.108,4.463H829.962l-3.4,3.655-3.4-3.655h-4.826v1.853h4.117l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,976.209v-4.456l4.108-4.433-4.108-4.432V951.409l-3.415-3.686,3.415-3.67v-5.2h-1.724v4.425l-4.108,4.448,4.108,4.432v11.479l3.415,3.686-3.414,3.686v5.2Z",
    transform: "translate(-745.786 -782.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.452,1036.763h4.1l4.108,4.463,4.124-4.464H966.4l3.4-3.655,3.4,3.655h4.81v-1.821h-4.086l-4.123-4.463-4.124,4.463H955.06l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-780.14 -860.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1073.782v4.455l-4.092,4.432,4.092,4.433v11.506l3.4,3.658-3.4,3.685v5.2h1.723v-4.425l4.093-4.463-4.093-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-852.744 -897.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1440.22h-4.086l-4.124-4.433-4.108,4.433H829.962l-3.4,3.685-3.4-3.686h-4.826v1.852h4.117l4.108,4.432,4.108-4.432h10.635l3.4-3.686,3.4,3.686,4.81,0Z",
    transform: "translate(-673.184 -1206.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1246.366v-4.424l4.109-4.464-4.108-4.432v-11.479l-3.415-3.685,3.415-3.658v-5.2h-1.723v4.425l-4.108,4.432,4.108,4.463v11.479l3.414,3.655-3.414,3.685v5.2Z",
    transform: "translate(-745.786 -1013.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,1307.037h4.1l4.108,4.432,4.124-4.433H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.085l-4.123-4.433-4.124,4.433H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 -1091.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1344.058v4.424l-4.093,4.432,4.093,4.464v11.478l3.4,3.655-3.4,3.685v5.2h1.724v-4.424l4.093-4.463-4.093-4.433V1356.6l-3.4-3.685,3.4-3.655v-5.2Z",
    transform: "translate(-852.744 -1128.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1710.286h-4.086l-4.124-4.433-4.108,4.431H829.962l-3.4,3.686-3.4-3.686h-4.826v1.852h4.117l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686,4.81,0Z",
    transform: "translate(-673.184 -1437.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1516.435v-4.424l4.108-4.433-4.108-4.463v-11.481l-3.414-3.684,3.414-3.655v-5.2h-1.722v4.425l-4.108,4.432,4.109,4.464v11.479l3.414,3.685-3.414,3.655v5.2Z",
    transform: "translate(-745.788 -1243.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,1577.1h4.1l4.107,4.432,4.124-4.433H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.085l-4.123-4.432-4.124,4.432H955.057l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-780.137 -1322.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1614.119v4.425l-4.092,4.463,4.092,4.433v11.479l3.4,3.685-3.4,3.655v5.2h1.724v-4.425l4.093-4.431-4.093-4.464v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-852.744 -1359.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1980.352h-4.086l-4.124-4.432-4.108,4.432H829.962l-3.4,3.686-3.4-3.686h-4.826v1.851h4.117l4.108,4.464,4.108-4.464h10.635l3.4-3.655,3.4,3.655h4.81Z",
    transform: "translate(-673.184 -1668.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1786.5v-4.425l4.108-4.433-4.108-4.464V1761.7l-3.414-3.655,3.414-3.685v-5.2h-1.723v4.424l-4.108,4.463,4.108,4.433v11.479l3.415,3.687-3.414,3.686v5.171Z",
    transform: "translate(-745.786 -1474.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.444,1847.169h4.1l4.107,4.432,4.124-4.432H966.4l3.4-3.684,3.4,3.683H978v-1.852H973.92l-4.123-4.433-4.124,4.433H955.054l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-780.133 -1553.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.469,1884.189v4.424l-4.093,4.463,4.093,4.433v11.479l3.4,3.685-3.4,3.686v5.2h1.723v-4.456l4.093-4.432-4.093-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-852.739 -1590.184)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.578 0.161)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.161 -0.162)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.228 -20.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.9,89.588h-4.1l-4.108-4.448-4.111,4.448H579.944l-3.4,3.67-3.414-3.67H568.32v1.837h4.1l4.124,4.447,4.108-4.447h10.634l3.4-3.67,3.4,3.671h4.81Z",
    transform: "translate(-459.451 -52.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.066-104.269v-4.44l4.123-4.448-4.123-4.433v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.439l-4.108,4.434,4.108,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-532.055 141.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.328-43.61h4.113l4.112,4.448,4.108-4.448H716.3l3.4-3.67,3.4,3.67h4.81v-1.852h-4.1l-4.108-4.432-4.108,4.432H704.952l-3.4,3.685-3.4-3.685h-4.826Z",
    transform: "translate(-566.316 63.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.367-6.593v4.44L778.259,2.28l4.108,4.448V18.206l3.41,3.686-3.411,3.671v5.2h1.708v-4.44l4.123-4.432-4.123-4.448V5.966l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-638.921 26.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.883,89.59h-4.1l-4.108-4.447L340.55,89.59H329.931l-3.414,3.67-3.4-3.67h-4.81v1.837h4.1l4.108,4.447,4.124-4.447h10.619l3.415-3.67,3.4,3.67h4.81Z",
    transform: "translate(-245.722 -52.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.054-104.267v-4.44l4.108-4.448-4.108-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.438l-4.108,4.434,4.108,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-318.327 141.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.315-43.608h4.1l4.123,4.447,4.108-4.448h10.619l3.415-3.67,3.4,3.67h4.81V-45.46h-4.1l-4.108-4.432-4.124,4.432H454.939l-3.4,3.685-3.414-3.685h-4.81Z",
    transform: "translate(-352.587 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.355-6.593v4.44L528.247,2.28l4.108,4.448V18.206l3.4,3.686-3.4,3.67v5.2h1.708v-4.44l4.108-4.432-4.108-4.448V5.965l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-425.193 26.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.871,89.591h-4.1l-4.124-4.447-4.108,4.447H79.9l-3.4,3.67-3.4-3.671H68.3v1.837h4.1L76.5,95.876l4.108-4.448H91.247l3.4-3.67,3.414,3.67h4.81Z",
    transform: "translate(-31.994 -52.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.949-104.267v-4.44l4.108-4.448-4.108-4.433v-11.479l-3.4-3.685,3.4-3.67v-5.2h-1.708v4.438l-4.124,4.434,4.124,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-104.506 141.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3-43.608h4.1l4.108,4.448,4.123-4.448h10.619l3.4-3.67,3.414,3.67h4.811V-45.46h-4.1l-4.124-4.432-4.108,4.432H204.925l-3.414,3.686-3.4-3.686H193.3Z",
    transform: "translate(-138.858 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.337-6.592v4.44l-4.109,4.433,4.109,4.448V18.207l3.4,3.686-3.4,3.67v5.2h1.708v-4.44l4.108-4.432-4.108-4.448V5.966l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-211.46 26.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.222,89.591h-4.117l-4.108-4.447-4.108,4.447h-10.634l-3.4,3.671-3.4-3.67h-4.823v1.837h4.114l4.108,4.448,4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.826Z",
    transform: "translate(181.815 -52.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.715-43.608h4.1L-48.5-39.16l4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.826V-45.46h-4.117l-4.108-4.432-4.108,4.432H-45.106l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(74.874 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.237-6.591v4.44L28.113,2.282,32.236,6.73V18.209l3.4,3.686-3.4,3.67v5.2h1.708V26.326l4.108-4.432-4.108-4.448V5.968L30.53,2.282l3.415-3.67v-5.2Z",
    transform: "translate(2.357 26.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.9,359.657h-4.1l-4.108-4.447-4.111,4.447H579.943l-3.4,3.686-3.415-3.686h-4.81v1.852h4.1l4.124,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.45 -283.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.065,165.8v-4.436l4.123-4.437-4.123-4.448V141l-3.4-3.67,3.4-3.685v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-532.054 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.327,226.474h4.113l4.112,4.433,4.108-4.433h10.635l3.4-3.686,3.4,3.686h4.81v-1.852h-4.1l-4.108-4.448-4.108,4.448H704.951l-3.4,3.67-3.4-3.67h-4.825Z",
    transform: "translate(-566.315 -167.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.367,263.582v4.425l-4.108,4.448,4.108,4.437v11.49l3.411,3.671-3.411,3.67v5.2h1.708V296.5l4.123-4.448-4.124-4.448V276.125l-3.4-3.67,3.4-3.685v-5.187Z",
    transform: "translate(-638.921 -204.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.882,359.657h-4.1l-4.108-4.447-4.124,4.447H329.93l-3.414,3.686-3.4-3.686h-4.81v1.853h4.1l4.108,4.433,4.123-4.432h10.619l3.415-3.686,3.4,3.686h4.81Z",
    transform: "translate(-245.721 -283.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.053,165.8v-4.436l4.108-4.437-4.108-4.448V141l-3.4-3.67,3.4-3.686v-5.2h-1.707v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.685-3.4,3.67v5.2Z",
    transform: "translate(-318.326 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.313,226.477h4.1l4.124,4.433,4.108-4.433h10.619l3.415-3.686,3.4,3.686h4.81v-1.852h-4.1l-4.108-4.447-4.124,4.447H454.937l-3.4,3.67-3.414-3.67h-4.81Z",
    transform: "translate(-352.586 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.352,263.582v4.425l-4.108,4.448,4.108,4.437v11.49l3.4,3.671-3.4,3.671v5.2h1.708V296.5l4.108-4.448L534.06,287.6V276.125l-3.4-3.671,3.4-3.685v-5.187Z",
    transform: "translate(-425.191 -204.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,359.659h-4.1l-4.124-4.448-4.108,4.447H79.9l-3.4,3.686-3.4-3.685h-4.81v1.852h4.1l4.108,4.433,4.108-4.433H91.246l3.4-3.686,3.415,3.686h4.81Z",
    transform: "translate(-31.993 -283.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.947,165.8v-4.436l4.108-4.437-4.108-4.448V141l-3.4-3.67,3.4-3.686v-5.2H157.24v4.441l-4.123,4.447,4.124,4.432v11.479l3.4,3.685-3.4,3.671v5.2Z",
    transform: "translate(-104.505 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,226.477h4.1l4.108,4.432,4.124-4.433H216.25l3.4-3.686,3.414,3.686h4.81v-1.852h-4.1l-4.123-4.447-4.108,4.447H204.922l-3.415,3.67-3.4-3.67H193.3Z",
    transform: "translate(-138.854 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.334,263.584v4.425l-4.109,4.448,4.109,4.437v11.49l3.4,3.671-3.4,3.671v5.2h1.708V296.5l4.108-4.448-4.108-4.448V276.127l-3.4-3.67,3.4-3.685v-5.187Z",
    transform: "translate(-211.457 -204.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.224,359.661h-4.116l-4.108-4.447-4.108,4.448h-10.634l-3.4,3.686-3.4-3.686h-4.823v1.851h4.114l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.826Z",
    transform: "translate(181.817 -283.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.715,226.477h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825v-1.852h-4.116l-4.108-4.448-4.108,4.447H-45.106l-3.4,3.671-3.4-3.67h-4.81Z",
    transform: "translate(74.874 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.232,263.584v4.425l-4.124,4.448,4.124,4.437v11.49l3.4,3.67-3.4,3.67v5.2H33.94V296.5l4.108-4.447-4.108-4.447v-11.48l-3.414-3.67,3.415-3.686v-5.187Z",
    transform: "translate(2.361 -204.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.893,629.831h-4.1l-4.108-4.447-4.114,4.447H579.941l-3.4,3.671-3.415-3.671h-4.81v1.837h4.1l4.124,4.448,4.107-4.447h10.635l3.4-3.671,3.4,3.671h4.81Z",
    transform: "translate(-459.448 -514.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.065,435.976v-4.44l4.123-4.448-4.124-4.433V411.162l-3.4-3.67,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-532.054 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.325,496.633h4.113l4.112,4.447,4.108-4.447h10.635l3.4-3.671,3.4,3.671h4.81V494.78h-4.1l-4.108-4.432-4.108,4.432H704.949l-3.4,3.686-3.4-3.685h-4.825Z",
    transform: "translate(-566.314 -398.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.364,533.65v4.44l-4.108,4.433,4.108,4.448v11.479l3.411,3.686-3.411,3.671v5.2h1.707v-4.44l4.124-4.433-4.124-4.448V546.208l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-638.919 -435.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.879,629.831h-4.1l-4.108-4.447-4.124,4.447H329.927l-3.414,3.671-3.4-3.671H318.3v1.838h4.1l4.108,4.448,4.123-4.448h10.619L344.67,628l3.4,3.67h4.81Z",
    transform: "translate(-245.718 -514.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.051,435.976v-4.44l4.108-4.448-4.108-4.433V411.162l-3.4-3.671,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.447v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-318.324 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,496.634h4.1l4.124,4.448,4.108-4.447h10.619l3.415-3.67,3.4,3.67h4.81v-1.852h-4.1l-4.108-4.432-4.123,4.432H454.934l-3.4,3.685-3.415-3.685h-4.81Z",
    transform: "translate(-352.583 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.352,533.65v4.441l-4.108,4.432,4.108,4.448v11.479l3.4,3.686-3.4,3.671v5.2h1.708v-4.441l4.108-4.433-4.108-4.448V546.208l-3.4-3.685,3.4-3.671v-5.2Z",
    transform: "translate(-425.191 -435.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.865,629.833h-4.1l-4.123-4.447-4.108,4.447H79.9L76.5,633.5l-3.4-3.671h-4.81v1.837h4.1l4.108,4.448,4.108-4.448H91.241l3.4-3.67,3.415,3.671h4.811Z",
    transform: "translate(-31.988 -514.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.946,435.977v-4.44l4.108-4.448-4.108-4.433V411.162l-3.4-3.67,3.4-3.671v-5.2h-1.708v4.425l-4.123,4.447,4.124,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-104.504 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,496.635h4.1l4.108,4.448,4.124-4.448h10.619l3.4-3.67,3.415,3.671h4.81v-1.852h-4.1l-4.123-4.432-4.108,4.432H204.92l-3.415,3.686-3.4-3.685H193.3Z",
    transform: "translate(-138.853 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.328,533.653v4.44l-4.11,4.433,4.11,4.448v11.479l3.4,3.686-3.4,3.669v5.2h1.709v-4.439l4.109-4.433-4.108-4.448V546.211l-3.4-3.686,3.4-3.671v-5.2Z",
    transform: "translate(-211.451 -435.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.224,629.833h-4.116l-4.108-4.447-4.108,4.447h-10.635l-3.4,3.672-3.4-3.671h-4.823v1.837h4.114l4.108,4.448,4.108-4.448h10.634l3.4-3.671,3.4,3.67h4.825Z",
    transform: "translate(181.817 -514.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.716,496.634h4.1l4.108,4.448,4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.825v-1.852h-4.116l-4.108-4.432-4.108,4.433H-45.107l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(74.875 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.232,533.653v4.44l-4.124,4.432,4.124,4.448v11.479l3.4,3.686-3.4,3.671v5.2h1.707V566.57l4.108-4.432-4.108-4.448V546.211l-3.415-3.685,3.414-3.67v-5.2Z",
    transform: "translate(2.361 -435.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.891,899.9h-4.1l-4.108-4.448-4.114,4.448H579.939l-3.4,3.67-3.414-3.67h-4.811v1.852h4.1l4.123,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.81Z",
    transform: "translate(-459.446 -744.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.063,706.044V701.6l4.123-4.432-4.123-4.448V681.244l-3.4-3.67,3.4-3.686v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.433v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-532.052 -551.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.322,766.713h4.113l4.112,4.436,4.108-4.434h10.634l3.4-3.683,3.4,3.683H727.9v-1.849h-4.1l-4.108-4.448-4.108,4.448H704.946l-3.4,3.671-3.4-3.671h-4.825Z",
    transform: "translate(-566.311 -629.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.362,803.8v4.428l-4.108,4.448,4.108,4.432v11.494l3.41,3.67-3.41,3.686v5.2h1.707v-4.457l4.123-4.432-4.123-4.448V816.349l-3.4-3.67,3.4-3.686V803.8Z",
    transform: "translate(-638.917 -666.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.877,899.9h-4.1l-4.108-4.448-4.124,4.448H329.925l-3.414,3.67-3.4-3.67H318.3v1.852h4.1l4.108,4.432,4.123-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.716 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.047,706.044V701.6l4.108-4.433-4.108-4.448V681.245l-3.4-3.67,3.4-3.686v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-318.321 -551.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.309,766.714h4.1l4.124,4.434,4.108-4.436h10.619l3.414-3.683,3.4,3.683h4.81v-1.85h-4.1l-4.108-4.448-4.123,4.448H454.933l-3.4,3.671-3.415-3.671h-4.81Z",
    transform: "translate(-352.582 -629.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.349,803.8v4.429l-4.108,4.448,4.108,4.432v11.495l3.4,3.671-3.4,3.686v5.2h1.708v-4.456l4.109-4.432-4.108-4.448V816.35l-3.4-3.671,3.4-3.686V803.8Z",
    transform: "translate(-425.188 -666.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.865,899.905h-4.1l-4.124-4.447-4.108,4.447H79.9l-3.4,3.67-3.4-3.67h-4.81v1.852h4.1L76.5,906.19l4.108-4.433H91.241l3.4-3.685,3.415,3.685h4.811Z",
    transform: "translate(-31.988 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.946,706.048v-4.44l4.108-4.433-4.108-4.448V681.248l-3.4-3.671,3.4-3.685v-5.2h-1.707v4.44l-4.123,4.447,4.123,4.432v11.479l3.4,3.686-3.4,3.671v5.2Z",
    transform: "translate(-104.504 -551.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.293,766.718h4.1l4.108,4.434,4.124-4.434h10.619l3.4-3.683,3.414,3.683h4.811v-1.849h-4.1l-4.124-4.448-4.108,4.447h-10.62l-3.414,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-138.851 -629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.327,803.812v4.427l-4.11,4.448,4.11,4.432v11.495l3.4,3.67-3.4,3.685v5.2h1.708v-4.456l4.108-4.432-4.108-4.448V816.357l-3.4-3.67,3.4-3.685v-5.189Z",
    transform: "translate(-211.451 -666.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.231,899.9h-4.116l-4.108-4.448-4.108,4.448H-170.2l-3.4,3.671-3.4-3.67h-4.824v1.853h4.115l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.823 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.719,766.719h4.1l4.108,4.435,4.108-4.435h10.634l3.4-3.684,3.4,3.683h4.825v-1.85h-4.117l-4.108-4.447-4.108,4.447H-45.11l-3.4,3.671-3.4-3.67h-4.81Z",
    transform: "translate(74.877 -629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.23,803.812v4.427l-4.124,4.448,4.123,4.432v11.494l3.4,3.67-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.448V816.358l-3.415-3.671L33.937,809v-5.189Z",
    transform: "translate(2.363 -666.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.888,1169.981h-4.1l-4.108-4.464-4.113,4.464h-10.63l-3.4,3.654-3.414-3.654h-4.811v1.851h4.1l4.123,4.432,4.108-4.431h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.443 -975.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.061,976.216V971.76l4.123-4.433L659.06,962.9V951.417l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.433v11.48l3.4,3.684-3.4,3.686v5.2Z",
    transform: "translate(-532.05 -782.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.321,1036.77h4.111l4.114,4.463,4.108-4.463h10.635l3.4-3.656,3.4,3.654H727.9v-1.82h-4.1l-4.108-4.463-4.108,4.463H704.945l-3.4,3.656-3.4-3.655h-4.826Z",
    transform: "translate(-566.31 -860.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.36,1073.782v4.457l-4.108,4.433,4.108,4.433v11.505l3.41,3.659-3.41,3.686v5.2h1.708v-4.425l4.124-4.463-4.124-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-638.915 -897.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.875,1169.988h-4.1l-4.109-4.463-4.123,4.463H329.923l-3.414,3.654-3.4-3.654H318.3v1.852h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.686,3.4,3.686h4.81Z",
    transform: "translate(-245.715 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.047,976.221v-4.457l4.108-4.433-4.108-4.432V951.422l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.2Z",
    transform: "translate(-318.321 -782.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.309,1036.773h4.1l4.124,4.464,4.108-4.464h10.619l3.414-3.655,3.4,3.655h4.81v-1.821h-4.1l-4.108-4.463-4.124,4.463H454.933l-3.4,3.654-3.414-3.654h-4.81Z",
    transform: "translate(-352.582 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.349,1073.789v4.456l-4.108,4.431,4.108,4.432v11.506l3.4,3.659-3.4,3.686v5.2h1.708v-4.425l4.108-4.463-4.108-4.432v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-425.188 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.863,1169.989h-4.1l-4.123-4.463-4.108,4.463H79.9l-3.4,3.654-3.4-3.654h-4.81v1.852h4.1l4.108,4.432,4.108-4.432H91.239l3.4-3.686,3.415,3.686h4.81Z",
    transform: "translate(-31.987 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.941,976.222v-4.456l4.108-4.433-4.108-4.432V951.421l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.123,4.447,4.124,4.433v11.479l3.4,3.685-3.4,3.686v5.2Z",
    transform: "translate(-104.499 -782.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,1036.773h4.1l4.108,4.464,4.123-4.464h10.619l3.4-3.655,3.414,3.655h4.811v-1.821h-4.1l-4.123-4.463-4.107,4.463h-10.62l-3.414,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-138.848 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.31,1073.789v4.456l-4.112,4.432,4.112,4.433v11.508l3.4,3.657-3.4,3.685v5.2h1.708v-4.425l4.108-4.463-4.108-4.433v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-211.434 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.234,1169.989h-4.116l-4.108-4.463-4.108,4.463H-170.2l-3.4,3.655-3.4-3.654h-4.823v1.851h4.115l4.108,4.432,4.108-4.431h10.634l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.826 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.721,1036.773h4.1l4.108,4.463,4.108-4.463h10.634l3.4-3.655,3.4,3.655h4.824v-1.821h-4.116l-4.108-4.463-4.108,4.463H-45.112l-3.4,3.656-3.4-3.656h-4.81Z",
    transform: "translate(74.879 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.227,1073.789v4.456l-4.124,4.432,4.124,4.433v11.508l3.4,3.657-3.4,3.685v5.2h1.708v-4.425l4.108-4.463-4.108-4.432v-11.479l-3.415-3.686,3.415-3.685v-5.2Z",
    transform: "translate(2.365 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.887,1440.236h-4.1l-4.108-4.432-4.113,4.432h-10.63l-3.4,3.685-3.414-3.685h-4.81v1.852h4.1l4.123,4.432,4.108-4.432h10.631l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.443 -1206.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.059,1246.38v-4.425l4.123-4.463-4.123-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2H657.35v4.424l-4.108,4.432,4.108,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-532.048 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.32,1307.051h4.111l4.114,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81V1305.2h-4.1l-4.108-4.433-4.109,4.433H704.943l-3.4,3.685-3.4-3.685H693.32Z",
    transform: "translate(-566.309 -1091.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.357,1344.068v4.425l-4.108,4.432,4.108,4.464v11.479l3.409,3.655-3.41,3.686v5.2h1.708v-4.426l4.124-4.463-4.124-4.433v-11.478l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-638.913 -1128.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.872,1440.236h-4.1l-4.108-4.432-4.124,4.432H329.92l-3.414,3.686-3.4-3.685H318.3v1.853h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.712 -1206.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.043,1246.381v-4.426l4.108-4.464-4.108-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2h-1.707v4.425l-4.108,4.433,4.108,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-318.317 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.306,1307.052h4.1l4.124,4.432,4.108-4.432h10.619l3.415-3.685,3.4,3.685h4.81V1305.2h-4.1l-4.108-4.433-4.124,4.433H454.93l-3.4,3.686-3.414-3.685h-4.81Z",
    transform: "translate(-352.58 -1091.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.342,1344.068v4.426l-4.108,4.432,4.108,4.464v11.479l3.4,3.655-3.4,3.686v5.2h1.708v-4.426l4.108-4.463-4.108-4.432v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-425.182 -1128.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,1440.24h-4.1l-4.123-4.432-4.108,4.432H79.892l-3.4,3.685-3.4-3.685H68.284v1.851h4.1l4.108,4.432,4.108-4.432H91.236l3.4-3.686,3.414,3.686h4.81Z",
    transform: "translate(-31.984 -1206.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,1246.381v-4.426l4.108-4.464-4.108-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2h-1.708v4.426l-4.123,4.432,4.123,4.463v11.479l3.4,3.654-3.4,3.686v5.2Z",
    transform: "translate(-104.499 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,1307.058h4.1l4.108,4.432,4.124-4.433h10.619l3.4-3.686,3.415,3.686h4.81v-1.851h-4.1l-4.123-4.432-4.108,4.432h-10.62l-3.415,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-138.848 -1091.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1344.073v4.425l-4.113,4.433,4.113,4.463v11.479l3.4,3.656-3.4,3.684v5.2h1.709v-4.425l4.109-4.462-4.108-4.433v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-211.425 -1128.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.235,1440.241h-4.116l-4.108-4.433-4.108,4.432H-170.2l-3.4,3.685-3.4-3.685h-4.823v1.852h4.115l4.108,4.432,4.108-4.432h10.635l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.826 -1206.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.724,1307.056h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825V1305.2h-4.116l-4.108-4.432-4.108,4.433H-45.115l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(74.882 -1091.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.227,1344.073v4.425l-4.123,4.432,4.124,4.463v11.479l3.4,3.655-3.4,3.685v5.2h1.708v-4.425l4.107-4.462-4.108-4.432v-11.479l-3.414-3.686,3.414-3.655v-5.2Z",
    transform: "translate(2.365 -1128.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.884,1710.3h-4.1l-4.109-4.433-4.113,4.433h-10.63l-3.4,3.685-3.415-3.685h-4.811v1.852h4.1l4.123,4.431,4.108-4.432h10.626l3.409-3.686,3.4,3.685h4.81Z",
    transform: "translate(-459.44 -1437.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.055,1516.452v-4.426l4.123-4.432-4.123-4.463v-11.479l-3.4-3.685,3.4-3.656v-5.2h-1.708v4.424l-4.108,4.433,4.108,4.462v11.48l3.4,3.685-3.4,3.654v5.2Z",
    transform: "translate(-532.045 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.317,1577.122h4.112l4.113,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.81v-1.851h-4.1l-4.108-4.433-4.108,4.433H704.941l-3.4,3.685-3.4-3.685h-4.826Z",
    transform: "translate(-566.307 -1322.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.353,1614.138v4.425l-4.108,4.463,4.109,4.433v11.479l3.409,3.685-3.41,3.655v5.2h1.708v-4.425l4.123-4.432-4.123-4.464v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-638.909 -1359.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.872,1710.307h-4.1l-4.109-4.432-4.123,4.433H329.92l-3.415,3.685-3.4-3.685H318.3v1.852h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.712 -1437.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04,1516.452v-4.425l4.108-4.433-4.108-4.463v-11.479l-3.4-3.685,3.4-3.656v-5.2h-1.708v4.424l-4.108,4.433,4.108,4.463v11.478l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-318.315 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.306,1577.124h4.1l4.124,4.433,4.109-4.433h10.619l3.414-3.686,3.4,3.686h4.81v-1.851h-4.1l-4.108-4.432-4.123,4.432H454.93l-3.4,3.685-3.414-3.685h-4.81Z",
    transform: "translate(-352.58 -1322.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.34,1614.141v4.425l-4.108,4.463,4.108,4.432v11.479l3.4,3.686-3.4,3.655v5.2h1.708v-4.425l4.108-4.432-4.108-4.464v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-425.18 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.857,1710.309h-4.1l-4.123-4.433-4.107,4.432H79.889l-3.4,3.685-3.4-3.685h-4.81v1.852h4.1l4.108,4.432,4.108-4.432H91.233l3.4-3.686,3.414,3.686h4.81Z",
    transform: "translate(-31.982 -1437.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,1516.452v-4.425l4.108-4.433-4.108-4.463v-11.479l-3.4-3.685,3.4-3.655v-5.2h-1.707v4.425l-4.123,4.432,4.123,4.462v11.48l3.4,3.685-3.4,3.655v5.2Z",
    transform: "translate(-104.499 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.288,1577.124h4.1l4.108,4.433,4.123-4.433H216.24l3.4-3.685,3.415,3.685h4.81v-1.852h-4.1l-4.124-4.432-4.108,4.432h-10.62l-3.414,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-138.846 -1322.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1614.141v4.425l-4.113,4.463,4.113,4.433v11.479l3.4,3.686-3.4,3.655v5.2h1.709v-4.425l4.108-4.432-4.108-4.463v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-211.425 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.238,1710.31h-4.116l-4.108-4.432-4.109,4.433H-170.2l-3.4,3.686-3.4-3.686h-4.824v1.852h4.115l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.826Z",
    transform: "translate(181.829 -1437.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.724,1577.128h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825v-1.852h-4.117l-4.108-4.432-4.108,4.432H-45.115l-3.4,3.686-3.4-3.685h-4.81Z",
    transform: "translate(74.882 -1322.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.224,1614.141v4.426l-4.123,4.463,4.123,4.432v11.48l3.4,3.685-3.4,3.655v5.2h1.708v-4.426l4.108-4.432-4.108-4.463v-11.479l-3.414-3.655,3.414-3.685v-5.2Z",
    transform: "translate(2.367 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.88,1980.372h-4.1l-4.108-4.433-4.113,4.433h-10.63l-3.4,3.685-3.414-3.685H568.3v1.851h4.1l4.123,4.463,4.107-4.462h10.626l3.408-3.655,3.4,3.655h4.81Z",
    transform: "translate(-459.437 -1668.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.053,1786.518v-4.426l4.122-4.432-4.122-4.463v-11.479l-3.4-3.654,3.4-3.686v-5.2h-1.708v4.425l-4.108,4.463,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-532.043 -1474.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.315,1847.19h4.112l4.113,4.432,4.108-4.433h10.634l3.4-3.664,3.4,3.664h4.81v-1.851h-4.1l-4.108-4.432-4.108,4.432H704.939l-3.4,3.686-3.4-3.686h-4.826Z",
    transform: "translate(-566.305 -1553.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.348,1884.2v4.425l-4.109,4.463,4.108,4.433V1909l3.409,3.685-3.41,3.686v5.2h1.709v-4.457l4.124-4.433-4.124-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-638.904 -1590.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.868,1980.379h-4.1l-4.108-4.432-4.123,4.432h-10.62l-3.414,3.685-3.4-3.685h-4.81v1.852h4.1l4.108,4.462,4.123-4.463h10.62l3.414-3.654,3.4,3.654h4.81Z",
    transform: "translate(-245.709 -1668.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04,1786.52v-4.426l4.108-4.432-4.108-4.463V1761.72l-3.4-3.655,3.4-3.686v-5.2h-1.707v4.425l-4.108,4.463,4.108,4.432v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-318.315 -1474.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3,1847.195h4.1l4.123,4.433,4.108-4.433h10.62l3.415-3.664,3.4,3.664h4.81v-1.853h-4.1l-4.108-4.432-4.123,4.432H454.925l-3.4,3.685-3.414-3.685H443.3Z",
    transform: "translate(-352.575 -1553.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.34,1884.211v4.425l-4.107,4.462,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.48l-3.4-3.685,3.4-3.685v-5.2Z",
    transform: "translate(-425.18 -1590.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.856,1980.38h-4.1l-4.123-4.432-4.107,4.432H79.889l-3.4,3.685-3.4-3.685H68.28v1.852h4.1l4.108,4.463,4.109-4.463H91.232l3.4-3.654,3.414,3.654h4.811Z",
    transform: "translate(-31.981 -1668.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.936,1786.525V1782.1l4.109-4.433-4.108-4.462v-11.479l-3.4-3.656,3.4-3.685v-5.2h-1.708v4.425l-4.123,4.462,4.124,4.432v11.48l3.4,3.686-3.4,3.686v5.172Z",
    transform: "translate(-104.495 -1474.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.286,1847.2h4.1l4.108,4.433,4.123-4.433h10.619l3.4-3.665,3.415,3.665h4.81v-1.851h-4.1l-4.124-4.432-4.108,4.432H204.91l-3.414,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-138.845 -1553.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1884.214v4.425l-4.113,4.462,4.113,4.433v11.48l3.4,3.685-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.479l-3.4-3.685,3.4-3.685v-5.2Z",
    transform: "translate(-211.422 -1590.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.247,1980.375h-4.116l-4.108-4.433-4.108,4.433h-10.634l-3.4,3.686-3.4-3.685h-4.825l0,1.851h4.114l4.108,4.463,4.108-4.463h10.634l3.4-3.656,3.4,3.655h4.825Z",
    transform: "translate(181.838 -1668.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.728,1847.195h4.1l4.108,4.433,4.109-4.434h10.634l3.4-3.66,3.4,3.66h4.825v-1.851h-4.116l-4.108-4.432-4.108,4.432H-45.12l-3.4,3.686-3.4-3.686h-4.811Z",
    transform: "translate(74.885 -1553.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,1884.211v4.425L28.1,1893.1l4.124,4.432v11.479l3.4,3.686-3.4,3.685v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.479l-3.415-3.686,3.414-3.685v-5.2Z",
    transform: "translate(2.371 -1590.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.015,89.581h-4.086l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.67-3.4-3.67h-4.811v1.836h4.086l4.124,4.447,4.123-4.447h10.619l3.4-3.67,3.4,3.67h4.811Z",
    transform: "translate(-887.001 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.724v4.437l-4.093,4.436,4.093,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-959.606 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461-43.616h4.117l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086l-4.123-4.432-4.093,4.433h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-993.866 63.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.487-6.6v4.441L1278.4,2.274l4.092,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.724v-4.44l4.123-4.433-4.123-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1066.473 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,89.581h-4.113l-4.124-4.448-4.092,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.837h4.117l4.093,4.448,4.123-4.447h10.619l3.4-3.67,3.4,3.67h4.838Z",
    transform: "translate(-1100.729 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.214-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.724v4.437l-4.092,4.436,4.093,4.448v11.479l3.43,3.67-3.43,3.686v5.2Z",
    transform: "translate(-1173.335 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473-43.615h4.117l4.093,4.448,4.124-4.447h10.619l3.4-3.67,3.4,3.67h4.841v-1.852h-4.117l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.594 63.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525-6.6v4.441l-4.12,4.432,4.12,4.448,0,11.479,3.4,3.686-3.4,3.67,0,5.2h1.694v-4.44l4.124-4.432-4.124-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1280.2 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.07,89.581h-4.117l-4.123-4.448-4.093,4.448h-10.649l-3.4,3.67-3.4-3.67h-4.81v1.837h4.117l4.093,4.448,4.123-4.447h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1314.457 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.227-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.692v4.437l-4.124,4.436,4.124,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-1387.063 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.488-43.617h4.116l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.431,3.67h4.809v-1.852h-4.116l-4.124-4.432-4.092,4.432h-10.619l-3.43,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-1421.324 63.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541-6.6v4.44l-4.124,4.433,4.124,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.693v-4.44l4.124-4.433-4.123-4.447V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1493.928 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,89.581h-4.117l-4.124-4.447-4.093,4.448H1830.13l-3.431,3.671-3.4-3.671h-4.811v1.837h4.116l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1528.185 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.238-104.274v-4.441l4.124-4.448-4.124-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.693v4.437l-4.123,4.436,4.123,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-1600.791 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5-43.618h4.117l4.093,4.448,4.123-4.447h10.619l3.427-3.67,3.4,3.67h4.81V-45.47h-4.117l-4.1-4.432-4.12,4.432h-10.619l-3.429,3.686-3.4-3.686H1943.5Z",
    transform: "translate(-1635.052 63.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.015,359.649h-4.086l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.81V361.5h4.086l4.124,4.433,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.811Z",
    transform: "translate(-887.001 -283.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,165.792v-4.437l4.123-4.435-4.123-4.448V140.992l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.441l-4.093,4.448,4.093,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-959.604 -89.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,226.466h4.116l4.094,4.432,4.123-4.432h10.62l3.4-3.686,3.4,3.685h4.81v-1.852h-4.085l-4.123-4.447-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-993.866 -167.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,263.57V268l-4.093,4.448,4.093,4.435V288.37l3.4,3.67-3.4,3.67v5.2h1.724v-4.425l4.124-4.447-4.124-4.448V276.113l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-1066.467 -204.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,359.647h-4.113l-4.124-4.448-4.093,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.811V361.5h4.116l4.092,4.432,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.729 -283.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.214,165.792v-4.438l4.123-4.435-4.123-4.448V140.992l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.44l-4.092,4.447,4.092,4.433v11.479l3.43,3.686-3.43,3.67v5.2Z",
    transform: "translate(-1173.335 -89.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,226.462h4.117l4.093,4.432,4.124-4.432h10.619l3.4-3.686,3.4,3.685h4.841V224.61h-4.117l-4.123-4.448-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1207.594 -167.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,263.575V268l-4.12,4.448,4.12,4.435v11.491l3.4,3.67-3.4,3.67,0,5.2h1.694v-4.425l4.124-4.447-4.124-4.448V276.118l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-1280.2 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.07,359.647h-4.117l-4.123-4.448-4.093,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.81V361.5h4.117l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.429,3.686h4.811Z",
    transform: "translate(-1314.457 -283.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,165.794v-4.438l4.123-4.435-4.123-4.448V140.994l-3.4-3.67,3.4-3.686v-5.2h-1.692v4.44l-4.123,4.448,4.124,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-1387.06 -89.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.488,226.462h4.116l4.093,4.432,4.123-4.432h10.62l3.4-3.685,3.431,3.686h4.809V224.61h-4.117l-4.123-4.448-4.092,4.448h-10.619l-3.43,3.67-3.4-3.671h-4.809Z",
    transform: "translate(-1421.324 -167.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,263.575V268l-4.123,4.448,4.123,4.435v11.492l3.4,3.67-3.4,3.67v5.2h1.692v-4.425l4.124-4.447-4.124-4.448V276.118l-3.4-3.671,3.4-3.686v-5.187Z",
    transform: "translate(-1493.928 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,359.649h-4.117l-4.124-4.448-4.093,4.448H1830.13l-3.431,3.685-3.4-3.685h-4.811V361.5h4.117l4.092,4.433,4.124-4.432h10.619l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.185 -283.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,165.794v-4.437l4.124-4.435-4.124-4.448V140.994l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.123,4.433v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-1600.788 -89.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,226.466h4.117l4.092,4.432,4.124-4.432h10.619l3.427-3.686,3.4,3.686h4.811v-1.852h-4.117l-4.1-4.448-4.121,4.447h-10.619l-3.429,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1635.05 -167.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.013,629.819h-4.086l-4.123-4.447-4.094,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.838h4.086l4.123,4.448,4.124-4.448H1091.4l3.4-3.67,3.4,3.67h4.811Z",
    transform: "translate(-886.999 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,435.963v-4.44l4.123-4.448-4.123-4.432V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.724v4.425l-4.093,4.448,4.093,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,496.622h4.116l4.094,4.448,4.123-4.448h10.62l3.4-3.67,3.4,3.67h4.809v-1.852h-4.087l-4.123-4.432-4.092,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-993.866 -398.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,533.639v4.44l-4.093,4.432,4.093,4.448v11.479l3.4,3.686-3.4,3.67V571h1.723v-4.441l4.124-4.432-4.124-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1066.467 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,629.819h-4.113l-4.124-4.447-4.092,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.838h4.117l4.092,4.447,4.123-4.448h10.619l3.4-3.67,3.4,3.67h4.838Z",
    transform: "translate(-1100.729 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,435.963v-4.44l4.123-4.448-4.123-4.432V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.724v4.425l-4.093,4.448,4.092,4.448v11.478l3.43,3.671-3.43,3.685v5.2Z",
    transform: "translate(-1173.332 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,496.62h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.4,3.67h4.84v-1.852h-4.116l-4.123-4.432-4.094,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.594 -398.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,533.639v4.44l-4.12,4.432,4.12,4.448v11.479l3.4,3.686-3.4,3.67V571h1.7v-4.441l4.124-4.432-4.124-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1280.2 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,629.819h-4.117l-4.123-4.447-4.093,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.837h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.429,3.67h4.811Z",
    transform: "translate(-1314.454 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,435.963v-4.44l4.123-4.448-4.123-4.433V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.447v11.48l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,496.62h4.117l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.431,3.67h4.809v-1.852h-4.116l-4.124-4.433-4.092,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1421.322 -398.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,533.639v4.44l-4.124,4.432,4.124,4.448v11.479l3.4,3.686-3.4,3.67V571h1.692v-4.44l4.124-4.432-4.123-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1493.928 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,629.819h-4.117l-4.124-4.446-4.093,4.447H1830.13l-3.431,3.671-3.4-3.671h-4.811v1.838h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1528.185 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.238,435.962v-4.439l4.124-4.448-4.124-4.432V411.15l-3.4-3.671,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-1600.791 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,496.622h4.117l4.094,4.448,4.123-4.448h10.619l3.427-3.67,3.4,3.67h4.811v-1.852h-4.117l-4.1-4.432-4.121,4.432h-10.619l-3.429,3.686-3.4-3.686H1943.5Z",
    transform: "translate(-1635.05 -398.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.013,899.887h-4.087l-4.123-4.448-4.094,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.852h4.086l4.123,4.433,4.124-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -744.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,706.029v-4.44l4.123-4.432-4.123-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.44l-4.093,4.448,4.093,4.432V693.47l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-959.604 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,766.7h4.116l4.094,4.438,4.123-4.438h10.619l3.4-3.68,3.4,3.68h4.81v-1.847h-4.086l-4.123-4.448-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-993.866 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,803.774v4.43l-4.093,4.448,4.093,4.432v11.495l3.4,3.67-3.4,3.687v5.2h1.723v-4.456l4.124-4.432L1284.2,827.8V816.322l-3.4-3.67,3.4-3.685v-5.192Z",
    transform: "translate(-1066.467 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,899.888h-4.113l-4.124-4.448-4.092,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.852h4.116l4.093,4.433,4.123-4.433h10.62l3.4-3.685,3.4,3.685h4.837Z",
    transform: "translate(-1100.726 -744.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,706.029v-4.441l4.123-4.432-4.124-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.723v4.44l-4.092,4.448,4.092,4.432v11.479l3.431,3.686-3.431,3.67v5.2Z",
    transform: "translate(-1173.332 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,766.7h4.117l4.092,4.438,4.124-4.437h10.619l3.4-3.68,3.4,3.68h4.84v-1.848h-4.116l-4.123-4.448-4.094,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1207.594 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,803.774v4.43l-4.12,4.448,4.12,4.433v11.495l3.4,3.67-3.4,3.686v5.2h1.7v-4.456l4.124-4.433-4.124-4.447V816.323l-3.4-3.671,3.4-3.685v-5.192Z",
    transform: "translate(-1280.2 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,899.886h-4.117l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.671-3.4-3.67h-4.81v1.852h4.117l4.093,4.432,4.123-4.433h10.618l3.4-3.686,3.429,3.686h4.811Z",
    transform: "translate(-1314.454 -744.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,706.029v-4.441l4.123-4.432-4.123-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.124,4.433v11.479l3.4,3.685-3.4,3.67v5.2Z",
    transform: "translate(-1387.06 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,766.7h4.117l4.092,4.437,4.123-4.437h10.619l3.4-3.68,3.431,3.68h4.809v-1.846h-4.117l-4.123-4.448-4.093,4.448h-10.619l-3.43,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1421.322 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,803.774v4.43l-4.123,4.448,4.123,4.432v11.495l3.4,3.67-3.4,3.686v5.2h1.693v-4.456l4.124-4.433-4.124-4.447V816.322l-3.4-3.67,3.4-3.685v-5.192Z",
    transform: "translate(-1493.928 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,899.886h-4.117l-4.124-4.448-4.093,4.448h-10.618l-3.431,3.67-3.4-3.67h-4.81v1.852h4.117l4.092,4.433,4.124-4.433h10.619l3.4-3.686,3.43,3.686h4.81Z",
    transform: "translate(-1528.183 -744.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,706.029v-4.441l4.124-4.432-4.124-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.123,4.432v11.479l3.4,3.685-3.4,3.671v5.2Z",
    transform: "translate(-1600.788 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,766.7h4.117l4.094,4.438,4.123-4.437h10.618l3.428-3.68,3.4,3.68h4.811v-1.846h-4.117l-4.1-4.448-4.121,4.448h-10.619l-3.43,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1635.05 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1169.97h-4.085l-4.123-4.463-4.094,4.463h-10.649l-3.4,3.655-3.4-3.655h-4.81v1.853h4.086l4.124,4.433,4.122-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,976.2v-4.455l4.123-4.432-4.123-4.432V951.4l-3.4-3.687,3.4-3.67v-5.2h-1.723v4.425l-4.093,4.448,4.093,4.432V963.63l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -782.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,1036.752h4.116l4.094,4.462,4.124-4.462h10.62l3.4-3.656,3.4,3.656h4.81v-1.822h-4.086l-4.123-4.464-4.092,4.464h-10.651l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-993.866 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,1073.775v4.455l-4.093,4.432,4.093,4.433v11.5l3.4,3.66-3.4,3.685v5.2h1.723v-4.425l4.123-4.463-4.123-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1066.467 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1169.971h-4.114l-4.124-4.463-4.092,4.463h-10.651l-3.4,3.655-3.4-3.655h-4.81v1.851h4.117l4.092,4.433,4.124-4.433h10.62l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.726 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,976.2v-4.455l4.123-4.433-4.124-4.432V951.4l-3.4-3.686,3.4-3.671v-5.2h-1.723v4.426l-4.093,4.448,4.093,4.432v11.479l3.43,3.686-3.43,3.686v5.2Z",
    transform: "translate(-1173.332 -782.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,1036.752h4.117l4.092,4.462,4.124-4.462h10.619l3.4-3.656,3.4,3.656h4.841v-1.821h-4.116l-4.123-4.464-4.093,4.464h-10.65l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1207.594 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1073.775v4.455l-4.12,4.432,4.12,4.433v11.5l3.4,3.667-3.4,3.685v5.2h1.7v-4.425l4.124-4.463-4.124-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1280.196 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,1169.967h-4.117l-4.124-4.464-4.093,4.464h-10.65l-3.4,3.655-3.4-3.655h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.685,3.429,3.685h4.811Z",
    transform: "translate(-1314.454 -975.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,976.2v-4.455l4.123-4.433-4.123-4.432V951.4l-3.4-3.686,3.4-3.671v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.433v11.479l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -782.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1036.752h4.116l4.093,4.462,4.123-4.462h10.619l3.4-3.656,3.43,3.656h4.81v-1.821h-4.117l-4.124-4.464-4.092,4.463h-10.62l-3.429,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1421.322 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,1073.775v4.455l-4.123,4.432,4.123,4.433v11.5l3.4,3.66-3.4,3.685v5.2h1.692v-4.425l4.124-4.463-4.124-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1493.928 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1169.97h-4.117l-4.124-4.463-4.093,4.463h-10.618l-3.431,3.655-3.4-3.655h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.62l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.183 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,976.2v-4.456l4.124-4.432-4.124-4.432V951.4l-3.4-3.687,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.447,4.123,4.433V963.63l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-1600.788 -782.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,1036.752h4.116l4.093,4.463,4.124-4.463h10.618l3.428-3.656,3.4,3.656h4.811v-1.821h-4.116l-4.1-4.464-4.121,4.464h-10.619l-3.43,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1635.05 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1440.214h-4.086l-4.123-4.432-4.094,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.086l4.123,4.433,4.124-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1246.358v-4.425l4.123-4.463-4.123-4.432v-11.479l-3.4-3.686,3.4-3.659v-5.2h-1.723v4.425l-4.093,4.432,4.093,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,1307.03h4.116l4.094,4.432,4.123-4.432h10.619l3.4-3.686,3.4,3.686h4.81v-1.852h-4.086l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-993.866 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.48,1344.051v4.425l-4.093,4.432,4.093,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.723v-4.426l4.123-4.462-4.124-4.434v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-1066.467 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1440.214h-4.114l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.685-3.4-3.685h-4.81v1.852h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.684,3.4,3.684h4.833Z",
    transform: "translate(-1100.726 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1246.357v-4.425l4.123-4.463-4.124-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.463v11.479l3.43,3.655-3.43,3.686v5.2Z",
    transform: "translate(-1173.332 -1012.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1307.03h4.118l4.092,4.432,4.124-4.432h10.619l3.4-3.686,3.4,3.686h4.841v-1.852h-4.116l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.589 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1344.051v4.425l-4.12,4.432,4.12,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.7v-4.426l4.124-4.462-4.124-4.434v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-1280.196 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,1440.214h-4.117l-4.124-4.432-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.433,4.124-4.433h10.618l3.4-3.685,3.43,3.685h4.811Z",
    transform: "translate(-1314.454 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,1246.359v-4.425l4.123-4.463-4.124-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.693v4.425l-4.123,4.432,4.123,4.464v11.478l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1307.03h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.43,3.686h4.81v-1.852h-4.116l-4.124-4.433-4.092,4.433h-10.62l-3.429,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1421.322 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,1344.051v4.425l-4.123,4.432,4.123,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.692v-4.426l4.123-4.463-4.123-4.432v-11.479l-3.4-3.686,3.4-3.655v-5.2Z",
    transform: "translate(-1493.928 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1440.219h-4.117l-4.123-4.432-4.093,4.432h-10.618l-3.431,3.686-3.4-3.687h-4.81v1.851h4.117l4.092,4.433,4.123-4.433h10.62l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.183 -1206.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,1246.359v-4.425l4.124-4.463-4.123-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.693v4.425l-4.123,4.432,4.123,4.464v11.478l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-1600.788 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.493,1307.03h4.117l4.093,4.432,4.124-4.432h10.619l3.428-3.685,3.4,3.685h4.81v-1.852h-4.117l-4.095-4.433-4.121,4.433h-10.619l-3.43,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1635.046 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1710.284h-4.086l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.685-3.4-3.685h-4.81v1.852h4.086l4.124,4.433,4.122-4.432H1091.4l3.4-3.684,3.4,3.684h4.81Z",
    transform: "translate(-886.999 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1516.424V1512l4.123-4.432-4.123-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.462v11.479l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-959.604 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.456,1577.1h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.811v-1.851h-4.086l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.809Z",
    transform: "translate(-993.861 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.478,1614.119v4.425l-4.093,4.462,4.093,4.433v11.48l3.4,3.685-3.4,3.655v5.2h1.724v-4.424l4.124-4.433-4.124-4.463v-11.479l-3.4-3.654,3.4-3.686v-5.2Z",
    transform: "translate(-1066.465 -1359.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.046,1710.284h-4.108l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.726 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1516.425V1512l4.124-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.462v11.479l3.43,3.686-3.43,3.655v5.2Z",
    transform: "translate(-1173.332 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1577.1h4.117l4.092,4.432,4.124-4.432h10.619l3.4-3.685,3.4,3.685h4.841v-1.851h-4.116l-4.124-4.433-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-1207.589 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1614.116v4.425L1528.4,1623l4.12,4.433v11.48l3.4,3.685-3.4,3.655v5.2h1.7v-4.425l4.124-4.432-4.123-4.463v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-1280.196 -1359.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.063,1710.285h-4.117l-4.124-4.432-4.093,4.432h-10.649l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.432,4.124-4.432h10.618l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1314.451 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.223,1516.425V1512l4.123-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.693v4.425l-4.123,4.433,4.123,4.463v11.479l3.4,3.685-3.4,3.655v5.2Z",
    transform: "translate(-1387.06 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.48,1577.1h4.117l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.43,3.686h4.81v-1.852h-4.117l-4.123-4.432-4.093,4.432h-10.62l-3.429,3.685-3.4-3.686h-4.81Z",
    transform: "translate(-1421.318 -1322.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,1614.116v4.426l-4.123,4.463,4.123,4.432v11.48l3.4,3.685-3.4,3.655v5.2h1.692v-4.425l4.123-4.433-4.123-4.463v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-1493.928 -1359.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1710.284h-4.118l-4.124-4.432-4.092,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.433,4.123-4.432h10.62l3.4-3.684,3.43,3.684h4.811Z",
    transform: "translate(-1528.183 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,1516.425V1512l4.124-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.692v4.425l-4.123,4.433,4.123,4.463v11.479l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-1600.788 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.494,1577.1h4.116l4.093,4.432,4.124-4.432h10.619l3.428-3.685,3.4,3.685h4.81v-1.851h-4.117l-4.095-4.433-4.122,4.433h-10.618l-3.43,3.685-3.4-3.685h-4.811Z",
    transform: "translate(-1635.046 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1980.35h-4.086l-4.123-4.432-4.093,4.432h-10.649l-3.4,3.685-3.4-3.685h-4.81v1.852h4.086l4.123,4.464,4.124-4.464H1091.4l3.4-3.654,3.4,3.654h4.81Z",
    transform: "translate(-886.999 -1668.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1786.49v-4.425l4.123-4.433-4.123-4.462v-11.48l-3.4-3.656,3.4-3.685v-5.2h-1.723v4.425l-4.092,4.462,4.093,4.433v11.479l3.4,3.685-3.4,3.686v5.171Z",
    transform: "translate(-959.604 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.456,1847.165h4.116l4.093,4.433,4.123-4.433h10.619l3.4-3.683,3.4,3.683h4.811v-1.852h-4.085l-4.123-4.432-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-993.861 -1553.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.48,1884.182v4.425l-4.093,4.462,4.093,4.432v11.48l3.4,3.686-3.4,3.685v5.2h1.723V1917.1l4.123-4.432-4.123-4.433v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-1066.467 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1980.352h-4.114l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.092,4.464,4.123-4.464h10.619l3.4-3.654,3.4,3.654h4.838Z",
    transform: "translate(-1100.726 -1668.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1786.49v-4.425l4.124-4.433-4.123-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.724v4.425l-4.092,4.463,4.092,4.433v11.479l3.43,3.686-3.43,3.685v5.172Z",
    transform: "translate(-1173.332 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1847.166h4.118l4.092,4.432,4.124-4.433h10.619l3.4-3.683,3.4,3.683h4.841v-1.852h-4.116l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-1207.589 -1553.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1884.182v4.425l-4.12,4.463,4.12,4.432v11.48l3.4,3.685-3.4,3.685v5.2h1.7V1917.1l4.124-4.432-4.124-4.433v-11.478l-3.4-3.687,3.4-3.685v-5.2Z",
    transform: "translate(-1280.196 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.063,1980.346h-4.117l-4.123-4.433-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.464,4.124-4.463h10.618l3.4-3.655,3.43,3.655h4.81Z",
    transform: "translate(-1314.451 -1668.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,1786.49v-4.425l4.123-4.433-4.124-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.692v4.425l-4.123,4.463,4.123,4.433v11.479l3.4,3.685-3.4,3.686v5.171Z",
    transform: "translate(-1387.06 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1847.162h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.683,3.43,3.683h4.81v-1.852h-4.117l-4.123-4.433-4.092,4.432h-10.62l-3.429,3.685-3.4-3.685h-4.809Z",
    transform: "translate(-1421.322 -1553.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.535,1884.182v4.425l-4.123,4.462,4.123,4.432v11.48l3.4,3.685-3.4,3.686v5.2h1.692V1917.1l4.123-4.432-4.123-4.433v-11.478l-3.4-3.687,3.4-3.686v-5.2Z",
    transform: "translate(-1493.923 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1980.35h-4.118l-4.123-4.432-4.093,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.464,4.123-4.464h10.619l3.4-3.654,3.431,3.655h4.809Z",
    transform: "translate(-1528.183 -1668.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.23,1786.49v-4.425l4.124-4.433-4.124-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.692v4.425l-4.124,4.463,4.124,4.433v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-1600.784 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.49,1847.168h4.117l4.093,4.433,4.124-4.432h10.619l3.428-3.683,3.4,3.683h4.81v-1.852h-4.117l-4.095-4.432-4.121,4.433H1955.13L1951.7,1849l-3.4-3.685h-4.81Z",
    transform: "translate(-1635.044 -1553.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,89.585h-4.086L844.7,85.138,840.6,89.585H829.962l-3.4,3.671-3.4-3.671h-4.825v1.837h4.117l4.108,4.448,4.108-4.448h10.635l3.4-3.67,3.4,3.67h4.81Z",
    transform: "translate(-673.184 -52.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1-104.271v-4.44l4.108-4.448-4.108-4.432v-11.479l-3.415-3.686,3.415-3.67v-5.2h-1.723v4.438l-4.108,4.434,4.108,4.448v11.479l3.415,3.67-3.415,3.686v5.2Z",
    transform: "translate(-745.786 141.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449-43.615h4.1l4.108,4.448,4.124-4.448H966.4l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086L969.8-49.9l-4.124,4.432H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 63.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.474-6.6v4.441l-4.093,4.432,4.092,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.723v-4.44l4.093-4.432-4.093-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-852.744 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,359.65h-4.086L844.7,355.2,840.6,359.65H829.962l-3.4,3.685-3.4-3.685h-4.826V361.5h4.116l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -283.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,165.795v-4.437l4.108-4.435-4.108-4.448V141l-3.415-3.67,3.415-3.686v-5.2h-1.723v4.44l-4.108,4.448,4.108,4.433v11.479l3.414,3.686-3.415,3.67v5.2Z",
    transform: "translate(-745.786 -89.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,226.467h4.1l4.108,4.432,4.124-4.432H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.086l-4.123-4.448-4.124,4.448H955.058l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-780.137 -167.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.475,263.575V268l-4.092,4.448,4.092,4.435v11.492l3.4,3.67-3.4,3.67v5.2h1.723v-4.425l4.093-4.448L1034.2,287.6V276.118l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-852.745 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,629.823h-4.086l-4.124-4.447-4.108,4.447H829.962l-3.4,3.671-3.4-3.671h-4.825v1.838h4.117l4.108,4.448,4.108-4.448h10.635l3.4-3.67,3.4,3.67h4.81Z",
    transform: "translate(-673.184 -514.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,435.968v-4.44l4.108-4.447-4.108-4.433V411.155l-3.415-3.67,3.415-3.67v-5.2h-1.723v4.425l-4.108,4.448,4.108,4.448v11.479l3.415,3.671-3.414,3.685v5.2Z",
    transform: "translate(-745.786 -320.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,496.625h4.1l4.108,4.448,4.124-4.448H966.4l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086l-4.123-4.432-4.124,4.432H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 -398.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.475,533.643v4.44l-4.092,4.433,4.092,4.448v11.479l3.4,3.686-3.4,3.67V571h1.723v-4.44l4.093-4.432-4.093-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-852.745 -435.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,899.891h-4.086l-4.124-4.448-4.108,4.448H829.962l-3.4,3.67-3.4-3.67h-4.826v1.852h4.117l4.108,4.433,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -744.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,706.033v-4.441l4.108-4.432-4.108-4.448V681.233l-3.415-3.67,3.415-3.686v-5.2h-1.723v4.44l-4.108,4.448L907.376,682v11.479l3.414,3.686-3.415,3.67v5.2Z",
    transform: "translate(-745.788 -551.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,766.7l4.1,0,4.108,4.437,4.124-4.437H966.4l3.4-3.681,3.4,3.681h4.81v-1.846h-4.086l-4.123-4.448-4.124,4.448H955.058l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-780.137 -629.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.474,803.781v4.43l-4.092,4.448,4.093,4.432v11.494l3.4,3.671-3.4,3.686v5.2h1.723v-4.456l4.093-4.432-4.093-4.448V816.329l-3.4-3.67,3.4-3.686v-5.19Z",
    transform: "translate(-852.744 -666.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1169.972h-4.086l-4.124-4.463-4.108,4.463H829.962l-3.4,3.655-3.4-3.655h-4.826v1.853h4.117l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,976.209v-4.456l4.108-4.433-4.108-4.432V951.409l-3.415-3.686,3.415-3.67v-5.2h-1.724v4.425l-4.108,4.448,4.108,4.432v11.479l3.415,3.686-3.414,3.686v5.2Z",
    transform: "translate(-745.786 -782.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.452,1036.763h4.1l4.108,4.463,4.124-4.464H966.4l3.4-3.655,3.4,3.655h4.81v-1.821h-4.086l-4.123-4.463-4.124,4.463H955.06l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-780.14 -860.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1073.782v4.455l-4.092,4.432,4.092,4.433v11.506l3.4,3.658-3.4,3.685v5.2h1.723v-4.425l4.093-4.463-4.093-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-852.744 -897.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1440.22h-4.086l-4.124-4.433-4.108,4.433H829.962l-3.4,3.685-3.4-3.686h-4.826v1.852h4.117l4.108,4.432,4.108-4.432h10.635l3.4-3.686,3.4,3.686,4.81,0Z",
    transform: "translate(-673.184 -1206.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1246.366v-4.424l4.109-4.464-4.108-4.432v-11.479l-3.415-3.685,3.415-3.658v-5.2h-1.723v4.425l-4.108,4.432,4.108,4.463v11.479l3.414,3.655-3.414,3.685v5.2Z",
    transform: "translate(-745.786 -1013.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,1307.037h4.1l4.108,4.432,4.124-4.433H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.085l-4.123-4.433-4.124,4.433H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 -1091.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1344.058v4.424l-4.093,4.432,4.093,4.464v11.478l3.4,3.655-3.4,3.685v5.2h1.724v-4.424l4.093-4.463-4.093-4.433V1356.6l-3.4-3.685,3.4-3.655v-5.2Z",
    transform: "translate(-852.744 -1128.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1710.286h-4.086l-4.124-4.433-4.108,4.431H829.962l-3.4,3.686-3.4-3.686h-4.826v1.852h4.117l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686,4.81,0Z",
    transform: "translate(-673.184 -1437.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1516.435v-4.424l4.108-4.433-4.108-4.463v-11.481l-3.414-3.684,3.414-3.655v-5.2h-1.722v4.425l-4.108,4.432,4.109,4.464v11.479l3.414,3.685-3.414,3.655v5.2Z",
    transform: "translate(-745.788 -1243.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,1577.1h4.1l4.107,4.432,4.124-4.433H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.085l-4.123-4.432-4.124,4.432H955.057l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-780.137 -1322.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1614.119v4.425l-4.092,4.463,4.092,4.433v11.479l3.4,3.685-3.4,3.655v5.2h1.724v-4.425l4.093-4.431-4.093-4.464v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-852.744 -1359.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1980.352h-4.086l-4.124-4.432-4.108,4.432H829.962l-3.4,3.686-3.4-3.686h-4.826v1.851h4.117l4.108,4.464,4.108-4.464h10.635l3.4-3.655,3.4,3.655h4.81Z",
    transform: "translate(-673.184 -1668.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1786.5v-4.425l4.108-4.433-4.108-4.464V1761.7l-3.414-3.655,3.414-3.685v-5.2h-1.723v4.424l-4.108,4.463,4.108,4.433v11.479l3.415,3.687-3.414,3.686v5.171Z",
    transform: "translate(-745.786 -1474.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.444,1847.169h4.1l4.107,4.432,4.124-4.432H966.4l3.4-3.684,3.4,3.683H978v-1.852H973.92l-4.123-4.433-4.124,4.433H955.054l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-780.133 -1553.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.469,1884.189v4.424l-4.093,4.463,4.093,4.433v11.479l3.4,3.685-3.4,3.686v5.2h1.723v-4.456l4.093-4.432-4.093-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-852.739 -1590.184)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873.578 0.161)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.161 -0.162)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.228 -20.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.9,89.588h-4.1l-4.108-4.448-4.111,4.448H579.944l-3.4,3.67-3.414-3.67H568.32v1.837h4.1l4.124,4.447,4.108-4.447h10.634l3.4-3.67,3.4,3.671h4.81Z",
    transform: "translate(-459.451 -52.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.066-104.269v-4.44l4.123-4.448-4.123-4.433v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.439l-4.108,4.434,4.108,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-532.055 141.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.328-43.61h4.113l4.112,4.448,4.108-4.448H716.3l3.4-3.67,3.4,3.67h4.81v-1.852h-4.1l-4.108-4.432-4.108,4.432H704.952l-3.4,3.685-3.4-3.685h-4.826Z",
    transform: "translate(-566.316 63.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.367-6.593v4.44L778.259,2.28l4.108,4.448V18.206l3.41,3.686-3.411,3.671v5.2h1.708v-4.44l4.123-4.432-4.123-4.448V5.966l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-638.921 26.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.883,89.59h-4.1l-4.108-4.447L340.55,89.59H329.931l-3.414,3.67-3.4-3.67h-4.81v1.837h4.1l4.108,4.447,4.124-4.447h10.619l3.415-3.67,3.4,3.67h4.81Z",
    transform: "translate(-245.722 -52.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.054-104.267v-4.44l4.108-4.448-4.108-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.438l-4.108,4.434,4.108,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-318.327 141.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.315-43.608h4.1l4.123,4.447,4.108-4.448h10.619l3.415-3.67,3.4,3.67h4.81V-45.46h-4.1l-4.108-4.432-4.124,4.432H454.939l-3.4,3.685-3.414-3.685h-4.81Z",
    transform: "translate(-352.587 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.355-6.593v4.44L528.247,2.28l4.108,4.448V18.206l3.4,3.686-3.4,3.67v5.2h1.708v-4.44l4.108-4.432-4.108-4.448V5.965l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-425.193 26.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.871,89.591h-4.1l-4.124-4.447-4.108,4.447H79.9l-3.4,3.67-3.4-3.671H68.3v1.837h4.1L76.5,95.876l4.108-4.448H91.247l3.4-3.67,3.414,3.67h4.81Z",
    transform: "translate(-31.994 -52.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.949-104.267v-4.44l4.108-4.448-4.108-4.433v-11.479l-3.4-3.685,3.4-3.67v-5.2h-1.708v4.438l-4.124,4.434,4.124,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-104.506 141.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3-43.608h4.1l4.108,4.448,4.123-4.448h10.619l3.4-3.67,3.414,3.67h4.811V-45.46h-4.1l-4.124-4.432-4.108,4.432H204.925l-3.414,3.686-3.4-3.686H193.3Z",
    transform: "translate(-138.858 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.337-6.592v4.44l-4.109,4.433,4.109,4.448V18.207l3.4,3.686-3.4,3.67v5.2h1.708v-4.44l4.108-4.432-4.108-4.448V5.966l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-211.46 26.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.222,89.591h-4.117l-4.108-4.447-4.108,4.447h-10.634l-3.4,3.671-3.4-3.67h-4.823v1.837h4.114l4.108,4.448,4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.826Z",
    transform: "translate(181.815 -52.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.715-43.608h4.1L-48.5-39.16l4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.826V-45.46h-4.117l-4.108-4.432-4.108,4.432H-45.106l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(74.874 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.237-6.591v4.44L28.113,2.282,32.236,6.73V18.209l3.4,3.686-3.4,3.67v5.2h1.708V26.326l4.108-4.432-4.108-4.448V5.968L30.53,2.282l3.415-3.67v-5.2Z",
    transform: "translate(2.357 26.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.9,359.657h-4.1l-4.108-4.447-4.111,4.447H579.943l-3.4,3.686-3.415-3.686h-4.81v1.852h4.1l4.124,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.45 -283.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.065,165.8v-4.436l4.123-4.437-4.123-4.448V141l-3.4-3.67,3.4-3.685v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-532.054 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.327,226.474h4.113l4.112,4.433,4.108-4.433h10.635l3.4-3.686,3.4,3.686h4.81v-1.852h-4.1l-4.108-4.448-4.108,4.448H704.951l-3.4,3.67-3.4-3.67h-4.825Z",
    transform: "translate(-566.315 -167.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.367,263.582v4.425l-4.108,4.448,4.108,4.437v11.49l3.411,3.671-3.411,3.67v5.2h1.708V296.5l4.123-4.448-4.124-4.448V276.125l-3.4-3.67,3.4-3.685v-5.187Z",
    transform: "translate(-638.921 -204.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.882,359.657h-4.1l-4.108-4.447-4.124,4.447H329.93l-3.414,3.686-3.4-3.686h-4.81v1.853h4.1l4.108,4.433,4.123-4.432h10.619l3.415-3.686,3.4,3.686h4.81Z",
    transform: "translate(-245.721 -283.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.053,165.8v-4.436l4.108-4.437-4.108-4.448V141l-3.4-3.67,3.4-3.686v-5.2h-1.707v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.685-3.4,3.67v5.2Z",
    transform: "translate(-318.326 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.313,226.477h4.1l4.124,4.433,4.108-4.433h10.619l3.415-3.686,3.4,3.686h4.81v-1.852h-4.1l-4.108-4.447-4.124,4.447H454.937l-3.4,3.67-3.414-3.67h-4.81Z",
    transform: "translate(-352.586 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.352,263.582v4.425l-4.108,4.448,4.108,4.437v11.49l3.4,3.671-3.4,3.671v5.2h1.708V296.5l4.108-4.448L534.06,287.6V276.125l-3.4-3.671,3.4-3.685v-5.187Z",
    transform: "translate(-425.191 -204.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,359.659h-4.1l-4.124-4.448-4.108,4.447H79.9l-3.4,3.686-3.4-3.685h-4.81v1.852h4.1l4.108,4.433,4.108-4.433H91.246l3.4-3.686,3.415,3.686h4.81Z",
    transform: "translate(-31.993 -283.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.947,165.8v-4.436l4.108-4.437-4.108-4.448V141l-3.4-3.67,3.4-3.686v-5.2H157.24v4.441l-4.123,4.447,4.124,4.432v11.479l3.4,3.685-3.4,3.671v5.2Z",
    transform: "translate(-104.505 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,226.477h4.1l4.108,4.432,4.124-4.433H216.25l3.4-3.686,3.414,3.686h4.81v-1.852h-4.1l-4.123-4.447-4.108,4.447H204.922l-3.415,3.67-3.4-3.67H193.3Z",
    transform: "translate(-138.854 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.334,263.584v4.425l-4.109,4.448,4.109,4.437v11.49l3.4,3.671-3.4,3.671v5.2h1.708V296.5l4.108-4.448-4.108-4.448V276.127l-3.4-3.67,3.4-3.685v-5.187Z",
    transform: "translate(-211.457 -204.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.224,359.661h-4.116l-4.108-4.447-4.108,4.448h-10.634l-3.4,3.686-3.4-3.686h-4.823v1.851h4.114l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.826Z",
    transform: "translate(181.817 -283.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.715,226.477h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825v-1.852h-4.116l-4.108-4.448-4.108,4.447H-45.106l-3.4,3.671-3.4-3.67h-4.81Z",
    transform: "translate(74.874 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.232,263.584v4.425l-4.124,4.448,4.124,4.437v11.49l3.4,3.67-3.4,3.67v5.2H33.94V296.5l4.108-4.447-4.108-4.447v-11.48l-3.414-3.67,3.415-3.686v-5.187Z",
    transform: "translate(2.361 -204.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.893,629.831h-4.1l-4.108-4.447-4.114,4.447H579.941l-3.4,3.671-3.415-3.671h-4.81v1.837h4.1l4.124,4.448,4.107-4.447h10.635l3.4-3.671,3.4,3.671h4.81Z",
    transform: "translate(-459.448 -514.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.065,435.976v-4.44l4.123-4.448-4.124-4.433V411.162l-3.4-3.67,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-532.054 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.325,496.633h4.113l4.112,4.447,4.108-4.447h10.635l3.4-3.671,3.4,3.671h4.81V494.78h-4.1l-4.108-4.432-4.108,4.432H704.949l-3.4,3.686-3.4-3.685h-4.825Z",
    transform: "translate(-566.314 -398.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.364,533.65v4.44l-4.108,4.433,4.108,4.448v11.479l3.411,3.686-3.411,3.671v5.2h1.707v-4.44l4.124-4.433-4.124-4.448V546.208l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-638.919 -435.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.879,629.831h-4.1l-4.108-4.447-4.124,4.447H329.927l-3.414,3.671-3.4-3.671H318.3v1.838h4.1l4.108,4.448,4.123-4.448h10.619L344.67,628l3.4,3.67h4.81Z",
    transform: "translate(-245.718 -514.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.051,435.976v-4.44l4.108-4.448-4.108-4.433V411.162l-3.4-3.671,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.447v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-318.324 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,496.634h4.1l4.124,4.448,4.108-4.447h10.619l3.415-3.67,3.4,3.67h4.81v-1.852h-4.1l-4.108-4.432-4.123,4.432H454.934l-3.4,3.685-3.415-3.685h-4.81Z",
    transform: "translate(-352.583 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.352,533.65v4.441l-4.108,4.432,4.108,4.448v11.479l3.4,3.686-3.4,3.671v5.2h1.708v-4.441l4.108-4.433-4.108-4.448V546.208l-3.4-3.685,3.4-3.671v-5.2Z",
    transform: "translate(-425.191 -435.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.865,629.833h-4.1l-4.123-4.447-4.108,4.447H79.9L76.5,633.5l-3.4-3.671h-4.81v1.837h4.1l4.108,4.448,4.108-4.448H91.241l3.4-3.67,3.415,3.671h4.811Z",
    transform: "translate(-31.988 -514.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.946,435.977v-4.44l4.108-4.448-4.108-4.433V411.162l-3.4-3.67,3.4-3.671v-5.2h-1.708v4.425l-4.123,4.447,4.124,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-104.504 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,496.635h4.1l4.108,4.448,4.124-4.448h10.619l3.4-3.67,3.415,3.671h4.81v-1.852h-4.1l-4.123-4.432-4.108,4.432H204.92l-3.415,3.686-3.4-3.685H193.3Z",
    transform: "translate(-138.853 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.328,533.653v4.44l-4.11,4.433,4.11,4.448v11.479l3.4,3.686-3.4,3.669v5.2h1.709v-4.439l4.109-4.433-4.108-4.448V546.211l-3.4-3.686,3.4-3.671v-5.2Z",
    transform: "translate(-211.451 -435.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.224,629.833h-4.116l-4.108-4.447-4.108,4.447h-10.635l-3.4,3.672-3.4-3.671h-4.823v1.837h4.114l4.108,4.448,4.108-4.448h10.634l3.4-3.671,3.4,3.67h4.825Z",
    transform: "translate(181.817 -514.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.716,496.634h4.1l4.108,4.448,4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.825v-1.852h-4.116l-4.108-4.432-4.108,4.433H-45.107l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(74.875 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.232,533.653v4.44l-4.124,4.432,4.124,4.448v11.479l3.4,3.686-3.4,3.671v5.2h1.707V566.57l4.108-4.432-4.108-4.448V546.211l-3.415-3.685,3.414-3.67v-5.2Z",
    transform: "translate(2.361 -435.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.891,899.9h-4.1l-4.108-4.448-4.114,4.448H579.939l-3.4,3.67-3.414-3.67h-4.811v1.852h4.1l4.123,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.81Z",
    transform: "translate(-459.446 -744.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.063,706.044V701.6l4.123-4.432-4.123-4.448V681.244l-3.4-3.67,3.4-3.686v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.433v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-532.052 -551.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.322,766.713h4.113l4.112,4.436,4.108-4.434h10.634l3.4-3.683,3.4,3.683H727.9v-1.849h-4.1l-4.108-4.448-4.108,4.448H704.946l-3.4,3.671-3.4-3.671h-4.825Z",
    transform: "translate(-566.311 -629.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.362,803.8v4.428l-4.108,4.448,4.108,4.432v11.494l3.41,3.67-3.41,3.686v5.2h1.707v-4.457l4.123-4.432-4.123-4.448V816.349l-3.4-3.67,3.4-3.686V803.8Z",
    transform: "translate(-638.917 -666.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.877,899.9h-4.1l-4.108-4.448-4.124,4.448H329.925l-3.414,3.67-3.4-3.67H318.3v1.852h4.1l4.108,4.432,4.123-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.716 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.047,706.044V701.6l4.108-4.433-4.108-4.448V681.245l-3.4-3.67,3.4-3.686v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-318.321 -551.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.309,766.714h4.1l4.124,4.434,4.108-4.436h10.619l3.414-3.683,3.4,3.683h4.81v-1.85h-4.1l-4.108-4.448-4.123,4.448H454.933l-3.4,3.671-3.415-3.671h-4.81Z",
    transform: "translate(-352.582 -629.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.349,803.8v4.429l-4.108,4.448,4.108,4.432v11.495l3.4,3.671-3.4,3.686v5.2h1.708v-4.456l4.109-4.432-4.108-4.448V816.35l-3.4-3.671,3.4-3.686V803.8Z",
    transform: "translate(-425.188 -666.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.865,899.905h-4.1l-4.124-4.447-4.108,4.447H79.9l-3.4,3.67-3.4-3.67h-4.81v1.852h4.1L76.5,906.19l4.108-4.433H91.241l3.4-3.685,3.415,3.685h4.811Z",
    transform: "translate(-31.988 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.946,706.048v-4.44l4.108-4.433-4.108-4.448V681.248l-3.4-3.671,3.4-3.685v-5.2h-1.707v4.44l-4.123,4.447,4.123,4.432v11.479l3.4,3.686-3.4,3.671v5.2Z",
    transform: "translate(-104.504 -551.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.293,766.718h4.1l4.108,4.434,4.124-4.434h10.619l3.4-3.683,3.414,3.683h4.811v-1.849h-4.1l-4.124-4.448-4.108,4.447h-10.62l-3.414,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-138.851 -629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.327,803.812v4.427l-4.11,4.448,4.11,4.432v11.495l3.4,3.67-3.4,3.685v5.2h1.708v-4.456l4.108-4.432-4.108-4.448V816.357l-3.4-3.67,3.4-3.685v-5.189Z",
    transform: "translate(-211.451 -666.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.231,899.9h-4.116l-4.108-4.448-4.108,4.448H-170.2l-3.4,3.671-3.4-3.67h-4.824v1.853h4.115l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.823 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.719,766.719h4.1l4.108,4.435,4.108-4.435h10.634l3.4-3.684,3.4,3.683h4.825v-1.85h-4.117l-4.108-4.447-4.108,4.447H-45.11l-3.4,3.671-3.4-3.67h-4.81Z",
    transform: "translate(74.877 -629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.23,803.812v4.427l-4.124,4.448,4.123,4.432v11.494l3.4,3.67-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.448V816.358l-3.415-3.671L33.937,809v-5.189Z",
    transform: "translate(2.363 -666.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.888,1169.981h-4.1l-4.108-4.464-4.113,4.464h-10.63l-3.4,3.654-3.414-3.654h-4.811v1.851h4.1l4.123,4.432,4.108-4.431h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.443 -975.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.061,976.216V971.76l4.123-4.433L659.06,962.9V951.417l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.433v11.48l3.4,3.684-3.4,3.686v5.2Z",
    transform: "translate(-532.05 -782.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.321,1036.77h4.111l4.114,4.463,4.108-4.463h10.635l3.4-3.656,3.4,3.654H727.9v-1.82h-4.1l-4.108-4.463-4.108,4.463H704.945l-3.4,3.656-3.4-3.655h-4.826Z",
    transform: "translate(-566.31 -860.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.36,1073.782v4.457l-4.108,4.433,4.108,4.433v11.505l3.41,3.659-3.41,3.686v5.2h1.708v-4.425l4.124-4.463-4.124-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-638.915 -897.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.875,1169.988h-4.1l-4.109-4.463-4.123,4.463H329.923l-3.414,3.654-3.4-3.654H318.3v1.852h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.686,3.4,3.686h4.81Z",
    transform: "translate(-245.715 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.047,976.221v-4.457l4.108-4.433-4.108-4.432V951.422l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.2Z",
    transform: "translate(-318.321 -782.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.309,1036.773h4.1l4.124,4.464,4.108-4.464h10.619l3.414-3.655,3.4,3.655h4.81v-1.821h-4.1l-4.108-4.463-4.124,4.463H454.933l-3.4,3.654-3.414-3.654h-4.81Z",
    transform: "translate(-352.582 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.349,1073.789v4.456l-4.108,4.431,4.108,4.432v11.506l3.4,3.659-3.4,3.686v5.2h1.708v-4.425l4.108-4.463-4.108-4.432v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-425.188 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.863,1169.989h-4.1l-4.123-4.463-4.108,4.463H79.9l-3.4,3.654-3.4-3.654h-4.81v1.852h4.1l4.108,4.432,4.108-4.432H91.239l3.4-3.686,3.415,3.686h4.81Z",
    transform: "translate(-31.987 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.941,976.222v-4.456l4.108-4.433-4.108-4.432V951.421l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.123,4.447,4.124,4.433v11.479l3.4,3.685-3.4,3.686v5.2Z",
    transform: "translate(-104.499 -782.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,1036.773h4.1l4.108,4.464,4.123-4.464h10.619l3.4-3.655,3.414,3.655h4.811v-1.821h-4.1l-4.123-4.463-4.107,4.463h-10.62l-3.414,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-138.848 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.31,1073.789v4.456l-4.112,4.432,4.112,4.433v11.508l3.4,3.657-3.4,3.685v5.2h1.708v-4.425l4.108-4.463-4.108-4.433v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-211.434 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.234,1169.989h-4.116l-4.108-4.463-4.108,4.463H-170.2l-3.4,3.655-3.4-3.654h-4.823v1.851h4.115l4.108,4.432,4.108-4.431h10.634l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.826 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.721,1036.773h4.1l4.108,4.463,4.108-4.463h10.634l3.4-3.655,3.4,3.655h4.824v-1.821h-4.116l-4.108-4.463-4.108,4.463H-45.112l-3.4,3.656-3.4-3.656h-4.81Z",
    transform: "translate(74.879 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.227,1073.789v4.456l-4.124,4.432,4.124,4.433v11.508l3.4,3.657-3.4,3.685v5.2h1.708v-4.425l4.108-4.463-4.108-4.432v-11.479l-3.415-3.686,3.415-3.685v-5.2Z",
    transform: "translate(2.365 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.887,1440.236h-4.1l-4.108-4.432-4.113,4.432h-10.63l-3.4,3.685-3.414-3.685h-4.81v1.852h4.1l4.123,4.432,4.108-4.432h10.631l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.443 -1206.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.059,1246.38v-4.425l4.123-4.463-4.123-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2H657.35v4.424l-4.108,4.432,4.108,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-532.048 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.32,1307.051h4.111l4.114,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81V1305.2h-4.1l-4.108-4.433-4.109,4.433H704.943l-3.4,3.685-3.4-3.685H693.32Z",
    transform: "translate(-566.309 -1091.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.357,1344.068v4.425l-4.108,4.432,4.108,4.464v11.479l3.409,3.655-3.41,3.686v5.2h1.708v-4.426l4.124-4.463-4.124-4.433v-11.478l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-638.913 -1128.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.872,1440.236h-4.1l-4.108-4.432-4.124,4.432H329.92l-3.414,3.686-3.4-3.685H318.3v1.853h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.712 -1206.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.043,1246.381v-4.426l4.108-4.464-4.108-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2h-1.707v4.425l-4.108,4.433,4.108,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-318.317 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.306,1307.052h4.1l4.124,4.432,4.108-4.432h10.619l3.415-3.685,3.4,3.685h4.81V1305.2h-4.1l-4.108-4.433-4.124,4.433H454.93l-3.4,3.686-3.414-3.685h-4.81Z",
    transform: "translate(-352.58 -1091.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.342,1344.068v4.426l-4.108,4.432,4.108,4.464v11.479l3.4,3.655-3.4,3.686v5.2h1.708v-4.426l4.108-4.463-4.108-4.432v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-425.182 -1128.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,1440.24h-4.1l-4.123-4.432-4.108,4.432H79.892l-3.4,3.685-3.4-3.685H68.284v1.851h4.1l4.108,4.432,4.108-4.432H91.236l3.4-3.686,3.414,3.686h4.81Z",
    transform: "translate(-31.984 -1206.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,1246.381v-4.426l4.108-4.464-4.108-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2h-1.708v4.426l-4.123,4.432,4.123,4.463v11.479l3.4,3.654-3.4,3.686v5.2Z",
    transform: "translate(-104.499 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,1307.058h4.1l4.108,4.432,4.124-4.433h10.619l3.4-3.686,3.415,3.686h4.81v-1.851h-4.1l-4.123-4.432-4.108,4.432h-10.62l-3.415,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-138.848 -1091.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1344.073v4.425l-4.113,4.433,4.113,4.463v11.479l3.4,3.656-3.4,3.684v5.2h1.709v-4.425l4.109-4.462-4.108-4.433v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-211.425 -1128.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.235,1440.241h-4.116l-4.108-4.433-4.108,4.432H-170.2l-3.4,3.685-3.4-3.685h-4.823v1.852h4.115l4.108,4.432,4.108-4.432h10.635l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.826 -1206.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.724,1307.056h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825V1305.2h-4.116l-4.108-4.432-4.108,4.433H-45.115l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(74.882 -1091.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.227,1344.073v4.425l-4.123,4.432,4.124,4.463v11.479l3.4,3.655-3.4,3.685v5.2h1.708v-4.425l4.107-4.462-4.108-4.432v-11.479l-3.414-3.686,3.414-3.655v-5.2Z",
    transform: "translate(2.365 -1128.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.884,1710.3h-4.1l-4.109-4.433-4.113,4.433h-10.63l-3.4,3.685-3.415-3.685h-4.811v1.852h4.1l4.123,4.431,4.108-4.432h10.626l3.409-3.686,3.4,3.685h4.81Z",
    transform: "translate(-459.44 -1437.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.055,1516.452v-4.426l4.123-4.432-4.123-4.463v-11.479l-3.4-3.685,3.4-3.656v-5.2h-1.708v4.424l-4.108,4.433,4.108,4.462v11.48l3.4,3.685-3.4,3.654v5.2Z",
    transform: "translate(-532.045 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.317,1577.122h4.112l4.113,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.81v-1.851h-4.1l-4.108-4.433-4.108,4.433H704.941l-3.4,3.685-3.4-3.685h-4.826Z",
    transform: "translate(-566.307 -1322.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.353,1614.138v4.425l-4.108,4.463,4.109,4.433v11.479l3.409,3.685-3.41,3.655v5.2h1.708v-4.425l4.123-4.432-4.123-4.464v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-638.909 -1359.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.872,1710.307h-4.1l-4.109-4.432-4.123,4.433H329.92l-3.415,3.685-3.4-3.685H318.3v1.852h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.712 -1437.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04,1516.452v-4.425l4.108-4.433-4.108-4.463v-11.479l-3.4-3.685,3.4-3.656v-5.2h-1.708v4.424l-4.108,4.433,4.108,4.463v11.478l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-318.315 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.306,1577.124h4.1l4.124,4.433,4.109-4.433h10.619l3.414-3.686,3.4,3.686h4.81v-1.851h-4.1l-4.108-4.432-4.123,4.432H454.93l-3.4,3.685-3.414-3.685h-4.81Z",
    transform: "translate(-352.58 -1322.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.34,1614.141v4.425l-4.108,4.463,4.108,4.432v11.479l3.4,3.686-3.4,3.655v5.2h1.708v-4.425l4.108-4.432-4.108-4.464v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-425.18 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.857,1710.309h-4.1l-4.123-4.433-4.107,4.432H79.889l-3.4,3.685-3.4-3.685h-4.81v1.852h4.1l4.108,4.432,4.108-4.432H91.233l3.4-3.686,3.414,3.686h4.81Z",
    transform: "translate(-31.982 -1437.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,1516.452v-4.425l4.108-4.433-4.108-4.463v-11.479l-3.4-3.685,3.4-3.655v-5.2h-1.707v4.425l-4.123,4.432,4.123,4.462v11.48l3.4,3.685-3.4,3.655v5.2Z",
    transform: "translate(-104.499 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.288,1577.124h4.1l4.108,4.433,4.123-4.433H216.24l3.4-3.685,3.415,3.685h4.81v-1.852h-4.1l-4.124-4.432-4.108,4.432h-10.62l-3.414,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-138.846 -1322.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1614.141v4.425l-4.113,4.463,4.113,4.433v11.479l3.4,3.686-3.4,3.655v5.2h1.709v-4.425l4.108-4.432-4.108-4.463v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-211.425 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.238,1710.31h-4.116l-4.108-4.432-4.109,4.433H-170.2l-3.4,3.686-3.4-3.686h-4.824v1.852h4.115l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.826Z",
    transform: "translate(181.829 -1437.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.724,1577.128h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825v-1.852h-4.117l-4.108-4.432-4.108,4.432H-45.115l-3.4,3.686-3.4-3.685h-4.81Z",
    transform: "translate(74.882 -1322.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.224,1614.141v4.426l-4.123,4.463,4.123,4.432v11.48l3.4,3.685-3.4,3.655v5.2h1.708v-4.426l4.108-4.432-4.108-4.463v-11.479l-3.414-3.655,3.414-3.685v-5.2Z",
    transform: "translate(2.367 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.88,1980.372h-4.1l-4.108-4.433-4.113,4.433h-10.63l-3.4,3.685-3.414-3.685H568.3v1.851h4.1l4.123,4.463,4.107-4.462h10.626l3.408-3.655,3.4,3.655h4.81Z",
    transform: "translate(-459.437 -1668.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.053,1786.518v-4.426l4.122-4.432-4.122-4.463v-11.479l-3.4-3.654,3.4-3.686v-5.2h-1.708v4.425l-4.108,4.463,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-532.043 -1474.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.315,1847.19h4.112l4.113,4.432,4.108-4.433h10.634l3.4-3.664,3.4,3.664h4.81v-1.851h-4.1l-4.108-4.432-4.108,4.432H704.939l-3.4,3.686-3.4-3.686h-4.826Z",
    transform: "translate(-566.305 -1553.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.348,1884.2v4.425l-4.109,4.463,4.108,4.433V1909l3.409,3.685-3.41,3.686v5.2h1.709v-4.457l4.124-4.433-4.124-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-638.904 -1590.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.868,1980.379h-4.1l-4.108-4.432-4.123,4.432h-10.62l-3.414,3.685-3.4-3.685h-4.81v1.852h4.1l4.108,4.462,4.123-4.463h10.62l3.414-3.654,3.4,3.654h4.81Z",
    transform: "translate(-245.709 -1668.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04,1786.52v-4.426l4.108-4.432-4.108-4.463V1761.72l-3.4-3.655,3.4-3.686v-5.2h-1.707v4.425l-4.108,4.463,4.108,4.432v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-318.315 -1474.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3,1847.195h4.1l4.123,4.433,4.108-4.433h10.62l3.415-3.664,3.4,3.664h4.81v-1.853h-4.1l-4.108-4.432-4.123,4.432H454.925l-3.4,3.685-3.414-3.685H443.3Z",
    transform: "translate(-352.575 -1553.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.34,1884.211v4.425l-4.107,4.462,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.48l-3.4-3.685,3.4-3.685v-5.2Z",
    transform: "translate(-425.18 -1590.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.856,1980.38h-4.1l-4.123-4.432-4.107,4.432H79.889l-3.4,3.685-3.4-3.685H68.28v1.852h4.1l4.108,4.463,4.109-4.463H91.232l3.4-3.654,3.414,3.654h4.811Z",
    transform: "translate(-31.981 -1668.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.936,1786.525V1782.1l4.109-4.433-4.108-4.462v-11.479l-3.4-3.656,3.4-3.685v-5.2h-1.708v4.425l-4.123,4.462,4.124,4.432v11.48l3.4,3.686-3.4,3.686v5.172Z",
    transform: "translate(-104.495 -1474.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.286,1847.2h4.1l4.108,4.433,4.123-4.433h10.619l3.4-3.665,3.415,3.665h4.81v-1.851h-4.1l-4.124-4.432-4.108,4.432H204.91l-3.414,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-138.845 -1553.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1884.214v4.425l-4.113,4.462,4.113,4.433v11.48l3.4,3.685-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.479l-3.4-3.685,3.4-3.685v-5.2Z",
    transform: "translate(-211.422 -1590.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.247,1980.375h-4.116l-4.108-4.433-4.108,4.433h-10.634l-3.4,3.686-3.4-3.685h-4.825l0,1.851h4.114l4.108,4.463,4.108-4.463h10.634l3.4-3.656,3.4,3.655h4.825Z",
    transform: "translate(181.838 -1668.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.728,1847.195h4.1l4.108,4.433,4.109-4.434h10.634l3.4-3.66,3.4,3.66h4.825v-1.851h-4.116l-4.108-4.432-4.108,4.432H-45.12l-3.4,3.686-3.4-3.686h-4.811Z",
    transform: "translate(74.885 -1553.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,1884.211v4.425L28.1,1893.1l4.124,4.432v11.479l3.4,3.686-3.4,3.685v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.479l-3.415-3.686,3.414-3.685v-5.2Z",
    transform: "translate(2.371 -1590.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.015,89.581h-4.086l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.67-3.4-3.67h-4.811v1.836h4.086l4.124,4.447,4.123-4.447h10.619l3.4-3.67,3.4,3.67h4.811Z",
    transform: "translate(-887.001 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.724v4.437l-4.093,4.436,4.093,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-959.606 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461-43.616h4.117l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086l-4.123-4.432-4.093,4.433h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-993.866 63.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.487-6.6v4.441L1278.4,2.274l4.092,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.724v-4.44l4.123-4.433-4.123-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1066.473 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,89.581h-4.113l-4.124-4.448-4.092,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.837h4.117l4.093,4.448,4.123-4.447h10.619l3.4-3.67,3.4,3.67h4.838Z",
    transform: "translate(-1100.729 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.214-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.724v4.437l-4.092,4.436,4.093,4.448v11.479l3.43,3.67-3.43,3.686v5.2Z",
    transform: "translate(-1173.335 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473-43.615h4.117l4.093,4.448,4.124-4.447h10.619l3.4-3.67,3.4,3.67h4.841v-1.852h-4.117l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.594 63.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525-6.6v4.441l-4.12,4.432,4.12,4.448,0,11.479,3.4,3.686-3.4,3.67,0,5.2h1.694v-4.44l4.124-4.432-4.124-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1280.2 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.07,89.581h-4.117l-4.123-4.448-4.093,4.448h-10.649l-3.4,3.67-3.4-3.67h-4.81v1.837h4.117l4.093,4.448,4.123-4.447h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1314.457 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.227-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.692v4.437l-4.124,4.436,4.124,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-1387.063 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.488-43.617h4.116l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.431,3.67h4.809v-1.852h-4.116l-4.124-4.432-4.092,4.432h-10.619l-3.43,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-1421.324 63.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541-6.6v4.44l-4.124,4.433,4.124,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.693v-4.44l4.124-4.433-4.123-4.447V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1493.928 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,89.581h-4.117l-4.124-4.447-4.093,4.448H1830.13l-3.431,3.671-3.4-3.671h-4.811v1.837h4.116l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1528.185 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.238-104.274v-4.441l4.124-4.448-4.124-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.693v4.437l-4.123,4.436,4.123,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-1600.791 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5-43.618h4.117l4.093,4.448,4.123-4.447h10.619l3.427-3.67,3.4,3.67h4.81V-45.47h-4.117l-4.1-4.432-4.12,4.432h-10.619l-3.429,3.686-3.4-3.686H1943.5Z",
    transform: "translate(-1635.052 63.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.015,359.649h-4.086l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.81V361.5h4.086l4.124,4.433,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.811Z",
    transform: "translate(-887.001 -283.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,165.792v-4.437l4.123-4.435-4.123-4.448V140.992l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.441l-4.093,4.448,4.093,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-959.604 -89.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,226.466h4.116l4.094,4.432,4.123-4.432h10.62l3.4-3.686,3.4,3.685h4.81v-1.852h-4.085l-4.123-4.447-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-993.866 -167.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,263.57V268l-4.093,4.448,4.093,4.435V288.37l3.4,3.67-3.4,3.67v5.2h1.724v-4.425l4.124-4.447-4.124-4.448V276.113l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-1066.467 -204.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,359.647h-4.113l-4.124-4.448-4.093,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.811V361.5h4.116l4.092,4.432,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.729 -283.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.214,165.792v-4.438l4.123-4.435-4.123-4.448V140.992l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.44l-4.092,4.447,4.092,4.433v11.479l3.43,3.686-3.43,3.67v5.2Z",
    transform: "translate(-1173.335 -89.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,226.462h4.117l4.093,4.432,4.124-4.432h10.619l3.4-3.686,3.4,3.685h4.841V224.61h-4.117l-4.123-4.448-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1207.594 -167.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,263.575V268l-4.12,4.448,4.12,4.435v11.491l3.4,3.67-3.4,3.67,0,5.2h1.694v-4.425l4.124-4.447-4.124-4.448V276.118l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-1280.2 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.07,359.647h-4.117l-4.123-4.448-4.093,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.81V361.5h4.117l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.429,3.686h4.811Z",
    transform: "translate(-1314.457 -283.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,165.794v-4.438l4.123-4.435-4.123-4.448V140.994l-3.4-3.67,3.4-3.686v-5.2h-1.692v4.44l-4.123,4.448,4.124,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-1387.06 -89.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.488,226.462h4.116l4.093,4.432,4.123-4.432h10.62l3.4-3.685,3.431,3.686h4.809V224.61h-4.117l-4.123-4.448-4.092,4.448h-10.619l-3.43,3.67-3.4-3.671h-4.809Z",
    transform: "translate(-1421.324 -167.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,263.575V268l-4.123,4.448,4.123,4.435v11.492l3.4,3.67-3.4,3.67v5.2h1.692v-4.425l4.124-4.447-4.124-4.448V276.118l-3.4-3.671,3.4-3.686v-5.187Z",
    transform: "translate(-1493.928 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,359.649h-4.117l-4.124-4.448-4.093,4.448H1830.13l-3.431,3.685-3.4-3.685h-4.811V361.5h4.117l4.092,4.433,4.124-4.432h10.619l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.185 -283.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,165.794v-4.437l4.124-4.435-4.124-4.448V140.994l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.123,4.433v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-1600.788 -89.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,226.466h4.117l4.092,4.432,4.124-4.432h10.619l3.427-3.686,3.4,3.686h4.811v-1.852h-4.117l-4.1-4.448-4.121,4.447h-10.619l-3.429,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1635.05 -167.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.013,629.819h-4.086l-4.123-4.447-4.094,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.838h4.086l4.123,4.448,4.124-4.448H1091.4l3.4-3.67,3.4,3.67h4.811Z",
    transform: "translate(-886.999 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,435.963v-4.44l4.123-4.448-4.123-4.432V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.724v4.425l-4.093,4.448,4.093,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,496.622h4.116l4.094,4.448,4.123-4.448h10.62l3.4-3.67,3.4,3.67h4.809v-1.852h-4.087l-4.123-4.432-4.092,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-993.866 -398.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,533.639v4.44l-4.093,4.432,4.093,4.448v11.479l3.4,3.686-3.4,3.67V571h1.723v-4.441l4.124-4.432-4.124-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1066.467 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,629.819h-4.113l-4.124-4.447-4.092,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.838h4.117l4.092,4.447,4.123-4.448h10.619l3.4-3.67,3.4,3.67h4.838Z",
    transform: "translate(-1100.729 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,435.963v-4.44l4.123-4.448-4.123-4.432V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.724v4.425l-4.093,4.448,4.092,4.448v11.478l3.43,3.671-3.43,3.685v5.2Z",
    transform: "translate(-1173.332 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,496.62h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.4,3.67h4.84v-1.852h-4.116l-4.123-4.432-4.094,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.594 -398.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,533.639v4.44l-4.12,4.432,4.12,4.448v11.479l3.4,3.686-3.4,3.67V571h1.7v-4.441l4.124-4.432-4.124-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1280.2 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,629.819h-4.117l-4.123-4.447-4.093,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.837h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.429,3.67h4.811Z",
    transform: "translate(-1314.454 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,435.963v-4.44l4.123-4.448-4.123-4.433V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.447v11.48l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,496.62h4.117l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.431,3.67h4.809v-1.852h-4.116l-4.124-4.433-4.092,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1421.322 -398.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,533.639v4.44l-4.124,4.432,4.124,4.448v11.479l3.4,3.686-3.4,3.67V571h1.692v-4.44l4.124-4.432-4.123-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1493.928 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,629.819h-4.117l-4.124-4.446-4.093,4.447H1830.13l-3.431,3.671-3.4-3.671h-4.811v1.838h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1528.185 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.238,435.962v-4.439l4.124-4.448-4.124-4.432V411.15l-3.4-3.671,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-1600.791 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,496.622h4.117l4.094,4.448,4.123-4.448h10.619l3.427-3.67,3.4,3.67h4.811v-1.852h-4.117l-4.1-4.432-4.121,4.432h-10.619l-3.429,3.686-3.4-3.686H1943.5Z",
    transform: "translate(-1635.05 -398.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.013,899.887h-4.087l-4.123-4.448-4.094,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.852h4.086l4.123,4.433,4.124-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -744.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,706.029v-4.44l4.123-4.432-4.123-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.44l-4.093,4.448,4.093,4.432V693.47l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-959.604 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,766.7h4.116l4.094,4.438,4.123-4.438h10.619l3.4-3.68,3.4,3.68h4.81v-1.847h-4.086l-4.123-4.448-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-993.866 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,803.774v4.43l-4.093,4.448,4.093,4.432v11.495l3.4,3.67-3.4,3.687v5.2h1.723v-4.456l4.124-4.432L1284.2,827.8V816.322l-3.4-3.67,3.4-3.685v-5.192Z",
    transform: "translate(-1066.467 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,899.888h-4.113l-4.124-4.448-4.092,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.852h4.116l4.093,4.433,4.123-4.433h10.62l3.4-3.685,3.4,3.685h4.837Z",
    transform: "translate(-1100.726 -744.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,706.029v-4.441l4.123-4.432-4.124-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.723v4.44l-4.092,4.448,4.092,4.432v11.479l3.431,3.686-3.431,3.67v5.2Z",
    transform: "translate(-1173.332 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,766.7h4.117l4.092,4.438,4.124-4.437h10.619l3.4-3.68,3.4,3.68h4.84v-1.848h-4.116l-4.123-4.448-4.094,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1207.594 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,803.774v4.43l-4.12,4.448,4.12,4.433v11.495l3.4,3.67-3.4,3.686v5.2h1.7v-4.456l4.124-4.433-4.124-4.447V816.323l-3.4-3.671,3.4-3.685v-5.192Z",
    transform: "translate(-1280.2 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,899.886h-4.117l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.671-3.4-3.67h-4.81v1.852h4.117l4.093,4.432,4.123-4.433h10.618l3.4-3.686,3.429,3.686h4.811Z",
    transform: "translate(-1314.454 -744.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,706.029v-4.441l4.123-4.432-4.123-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.124,4.433v11.479l3.4,3.685-3.4,3.67v5.2Z",
    transform: "translate(-1387.06 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,766.7h4.117l4.092,4.437,4.123-4.437h10.619l3.4-3.68,3.431,3.68h4.809v-1.846h-4.117l-4.123-4.448-4.093,4.448h-10.619l-3.43,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1421.322 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,803.774v4.43l-4.123,4.448,4.123,4.432v11.495l3.4,3.67-3.4,3.686v5.2h1.693v-4.456l4.124-4.433-4.124-4.447V816.322l-3.4-3.67,3.4-3.685v-5.192Z",
    transform: "translate(-1493.928 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,899.886h-4.117l-4.124-4.448-4.093,4.448h-10.618l-3.431,3.67-3.4-3.67h-4.81v1.852h4.117l4.092,4.433,4.124-4.433h10.619l3.4-3.686,3.43,3.686h4.81Z",
    transform: "translate(-1528.183 -744.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,706.029v-4.441l4.124-4.432-4.124-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.123,4.432v11.479l3.4,3.685-3.4,3.671v5.2Z",
    transform: "translate(-1600.788 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,766.7h4.117l4.094,4.438,4.123-4.437h10.618l3.428-3.68,3.4,3.68h4.811v-1.846h-4.117l-4.1-4.448-4.121,4.448h-10.619l-3.43,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1635.05 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1169.97h-4.085l-4.123-4.463-4.094,4.463h-10.649l-3.4,3.655-3.4-3.655h-4.81v1.853h4.086l4.124,4.433,4.122-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,976.2v-4.455l4.123-4.432-4.123-4.432V951.4l-3.4-3.687,3.4-3.67v-5.2h-1.723v4.425l-4.093,4.448,4.093,4.432V963.63l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -782.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,1036.752h4.116l4.094,4.462,4.124-4.462h10.62l3.4-3.656,3.4,3.656h4.81v-1.822h-4.086l-4.123-4.464-4.092,4.464h-10.651l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-993.866 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,1073.775v4.455l-4.093,4.432,4.093,4.433v11.5l3.4,3.66-3.4,3.685v5.2h1.723v-4.425l4.123-4.463-4.123-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1066.467 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1169.971h-4.114l-4.124-4.463-4.092,4.463h-10.651l-3.4,3.655-3.4-3.655h-4.81v1.851h4.117l4.092,4.433,4.124-4.433h10.62l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.726 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,976.2v-4.455l4.123-4.433-4.124-4.432V951.4l-3.4-3.686,3.4-3.671v-5.2h-1.723v4.426l-4.093,4.448,4.093,4.432v11.479l3.43,3.686-3.43,3.686v5.2Z",
    transform: "translate(-1173.332 -782.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,1036.752h4.117l4.092,4.462,4.124-4.462h10.619l3.4-3.656,3.4,3.656h4.841v-1.821h-4.116l-4.123-4.464-4.093,4.464h-10.65l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1207.594 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1073.775v4.455l-4.12,4.432,4.12,4.433v11.5l3.4,3.667-3.4,3.685v5.2h1.7v-4.425l4.124-4.463-4.124-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1280.196 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,1169.967h-4.117l-4.124-4.464-4.093,4.464h-10.65l-3.4,3.655-3.4-3.655h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.685,3.429,3.685h4.811Z",
    transform: "translate(-1314.454 -975.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,976.2v-4.455l4.123-4.433-4.123-4.432V951.4l-3.4-3.686,3.4-3.671v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.433v11.479l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -782.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1036.752h4.116l4.093,4.462,4.123-4.462h10.619l3.4-3.656,3.43,3.656h4.81v-1.821h-4.117l-4.124-4.464-4.092,4.463h-10.62l-3.429,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1421.322 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,1073.775v4.455l-4.123,4.432,4.123,4.433v11.5l3.4,3.66-3.4,3.685v5.2h1.692v-4.425l4.124-4.463-4.124-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1493.928 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1169.97h-4.117l-4.124-4.463-4.093,4.463h-10.618l-3.431,3.655-3.4-3.655h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.62l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.183 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,976.2v-4.456l4.124-4.432-4.124-4.432V951.4l-3.4-3.687,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.447,4.123,4.433V963.63l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-1600.788 -782.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,1036.752h4.116l4.093,4.463,4.124-4.463h10.618l3.428-3.656,3.4,3.656h4.811v-1.821h-4.116l-4.1-4.464-4.121,4.464h-10.619l-3.43,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1635.05 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1440.214h-4.086l-4.123-4.432-4.094,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.086l4.123,4.433,4.124-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1246.358v-4.425l4.123-4.463-4.123-4.432v-11.479l-3.4-3.686,3.4-3.659v-5.2h-1.723v4.425l-4.093,4.432,4.093,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,1307.03h4.116l4.094,4.432,4.123-4.432h10.619l3.4-3.686,3.4,3.686h4.81v-1.852h-4.086l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-993.866 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.48,1344.051v4.425l-4.093,4.432,4.093,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.723v-4.426l4.123-4.462-4.124-4.434v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-1066.467 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1440.214h-4.114l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.685-3.4-3.685h-4.81v1.852h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.684,3.4,3.684h4.833Z",
    transform: "translate(-1100.726 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1246.357v-4.425l4.123-4.463-4.124-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.463v11.479l3.43,3.655-3.43,3.686v5.2Z",
    transform: "translate(-1173.332 -1012.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1307.03h4.118l4.092,4.432,4.124-4.432h10.619l3.4-3.686,3.4,3.686h4.841v-1.852h-4.116l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.589 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1344.051v4.425l-4.12,4.432,4.12,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.7v-4.426l4.124-4.462-4.124-4.434v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-1280.196 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,1440.214h-4.117l-4.124-4.432-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.433,4.124-4.433h10.618l3.4-3.685,3.43,3.685h4.811Z",
    transform: "translate(-1314.454 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,1246.359v-4.425l4.123-4.463-4.124-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.693v4.425l-4.123,4.432,4.123,4.464v11.478l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1307.03h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.43,3.686h4.81v-1.852h-4.116l-4.124-4.433-4.092,4.433h-10.62l-3.429,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1421.322 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,1344.051v4.425l-4.123,4.432,4.123,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.692v-4.426l4.123-4.463-4.123-4.432v-11.479l-3.4-3.686,3.4-3.655v-5.2Z",
    transform: "translate(-1493.928 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1440.219h-4.117l-4.123-4.432-4.093,4.432h-10.618l-3.431,3.686-3.4-3.687h-4.81v1.851h4.117l4.092,4.433,4.123-4.433h10.62l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.183 -1206.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,1246.359v-4.425l4.124-4.463-4.123-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.693v4.425l-4.123,4.432,4.123,4.464v11.478l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-1600.788 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.493,1307.03h4.117l4.093,4.432,4.124-4.432h10.619l3.428-3.685,3.4,3.685h4.81v-1.852h-4.117l-4.095-4.433-4.121,4.433h-10.619l-3.43,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1635.046 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1710.284h-4.086l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.685-3.4-3.685h-4.81v1.852h4.086l4.124,4.433,4.122-4.432H1091.4l3.4-3.684,3.4,3.684h4.81Z",
    transform: "translate(-886.999 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1516.424V1512l4.123-4.432-4.123-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.462v11.479l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-959.604 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.456,1577.1h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.811v-1.851h-4.086l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.809Z",
    transform: "translate(-993.861 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.478,1614.119v4.425l-4.093,4.462,4.093,4.433v11.48l3.4,3.685-3.4,3.655v5.2h1.724v-4.424l4.124-4.433-4.124-4.463v-11.479l-3.4-3.654,3.4-3.686v-5.2Z",
    transform: "translate(-1066.465 -1359.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.046,1710.284h-4.108l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.726 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1516.425V1512l4.124-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.462v11.479l3.43,3.686-3.43,3.655v5.2Z",
    transform: "translate(-1173.332 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1577.1h4.117l4.092,4.432,4.124-4.432h10.619l3.4-3.685,3.4,3.685h4.841v-1.851h-4.116l-4.124-4.433-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-1207.589 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1614.116v4.425L1528.4,1623l4.12,4.433v11.48l3.4,3.685-3.4,3.655v5.2h1.7v-4.425l4.124-4.432-4.123-4.463v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-1280.196 -1359.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.063,1710.285h-4.117l-4.124-4.432-4.093,4.432h-10.649l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.432,4.124-4.432h10.618l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1314.451 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.223,1516.425V1512l4.123-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.693v4.425l-4.123,4.433,4.123,4.463v11.479l3.4,3.685-3.4,3.655v5.2Z",
    transform: "translate(-1387.06 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.48,1577.1h4.117l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.43,3.686h4.81v-1.852h-4.117l-4.123-4.432-4.093,4.432h-10.62l-3.429,3.685-3.4-3.686h-4.81Z",
    transform: "translate(-1421.318 -1322.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,1614.116v4.426l-4.123,4.463,4.123,4.432v11.48l3.4,3.685-3.4,3.655v5.2h1.692v-4.425l4.123-4.433-4.123-4.463v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-1493.928 -1359.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1710.284h-4.118l-4.124-4.432-4.092,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.433,4.123-4.432h10.62l3.4-3.684,3.43,3.684h4.811Z",
    transform: "translate(-1528.183 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,1516.425V1512l4.124-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.692v4.425l-4.123,4.433,4.123,4.463v11.479l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-1600.788 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.494,1577.1h4.116l4.093,4.432,4.124-4.432h10.619l3.428-3.685,3.4,3.685h4.81v-1.851h-4.117l-4.095-4.433-4.122,4.433h-10.618l-3.43,3.685-3.4-3.685h-4.811Z",
    transform: "translate(-1635.046 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1980.35h-4.086l-4.123-4.432-4.093,4.432h-10.649l-3.4,3.685-3.4-3.685h-4.81v1.852h4.086l4.123,4.464,4.124-4.464H1091.4l3.4-3.654,3.4,3.654h4.81Z",
    transform: "translate(-886.999 -1668.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1786.49v-4.425l4.123-4.433-4.123-4.462v-11.48l-3.4-3.656,3.4-3.685v-5.2h-1.723v4.425l-4.092,4.462,4.093,4.433v11.479l3.4,3.685-3.4,3.686v5.171Z",
    transform: "translate(-959.604 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.456,1847.165h4.116l4.093,4.433,4.123-4.433h10.619l3.4-3.683,3.4,3.683h4.811v-1.852h-4.085l-4.123-4.432-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-993.861 -1553.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.48,1884.182v4.425l-4.093,4.462,4.093,4.432v11.48l3.4,3.686-3.4,3.685v5.2h1.723V1917.1l4.123-4.432-4.123-4.433v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-1066.467 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1980.352h-4.114l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.092,4.464,4.123-4.464h10.619l3.4-3.654,3.4,3.654h4.838Z",
    transform: "translate(-1100.726 -1668.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1786.49v-4.425l4.124-4.433-4.123-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.724v4.425l-4.092,4.463,4.092,4.433v11.479l3.43,3.686-3.43,3.685v5.172Z",
    transform: "translate(-1173.332 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1847.166h4.118l4.092,4.432,4.124-4.433h10.619l3.4-3.683,3.4,3.683h4.841v-1.852h-4.116l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-1207.589 -1553.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1884.182v4.425l-4.12,4.463,4.12,4.432v11.48l3.4,3.685-3.4,3.685v5.2h1.7V1917.1l4.124-4.432-4.124-4.433v-11.478l-3.4-3.687,3.4-3.685v-5.2Z",
    transform: "translate(-1280.196 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.063,1980.346h-4.117l-4.123-4.433-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.464,4.124-4.463h10.618l3.4-3.655,3.43,3.655h4.81Z",
    transform: "translate(-1314.451 -1668.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,1786.49v-4.425l4.123-4.433-4.124-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.692v4.425l-4.123,4.463,4.123,4.433v11.479l3.4,3.685-3.4,3.686v5.171Z",
    transform: "translate(-1387.06 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1847.162h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.683,3.43,3.683h4.81v-1.852h-4.117l-4.123-4.433-4.092,4.432h-10.62l-3.429,3.685-3.4-3.685h-4.809Z",
    transform: "translate(-1421.322 -1553.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.535,1884.182v4.425l-4.123,4.462,4.123,4.432v11.48l3.4,3.685-3.4,3.686v5.2h1.692V1917.1l4.123-4.432-4.123-4.433v-11.478l-3.4-3.687,3.4-3.686v-5.2Z",
    transform: "translate(-1493.923 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1980.35h-4.118l-4.123-4.432-4.093,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.464,4.123-4.464h10.619l3.4-3.654,3.431,3.655h4.809Z",
    transform: "translate(-1528.183 -1668.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.23,1786.49v-4.425l4.124-4.433-4.124-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.692v4.425l-4.124,4.463,4.124,4.433v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-1600.784 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.49,1847.168h4.117l4.093,4.433,4.124-4.432h10.619l3.428-3.683,3.4,3.683h4.81v-1.852h-4.117l-4.095-4.432-4.121,4.433H1955.13L1951.7,1849l-3.4-3.685h-4.81Z",
    transform: "translate(-1635.044 -1553.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,89.585h-4.086L844.7,85.138,840.6,89.585H829.962l-3.4,3.671-3.4-3.671h-4.825v1.837h4.117l4.108,4.448,4.108-4.448h10.635l3.4-3.67,3.4,3.67h4.81Z",
    transform: "translate(-673.184 -52.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1-104.271v-4.44l4.108-4.448-4.108-4.432v-11.479l-3.415-3.686,3.415-3.67v-5.2h-1.723v4.438l-4.108,4.434,4.108,4.448v11.479l3.415,3.67-3.415,3.686v5.2Z",
    transform: "translate(-745.786 141.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449-43.615h4.1l4.108,4.448,4.124-4.448H966.4l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086L969.8-49.9l-4.124,4.432H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 63.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.474-6.6v4.441l-4.093,4.432,4.092,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.723v-4.44l4.093-4.432-4.093-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-852.744 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,359.65h-4.086L844.7,355.2,840.6,359.65H829.962l-3.4,3.685-3.4-3.685h-4.826V361.5h4.116l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -283.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,165.795v-4.437l4.108-4.435-4.108-4.448V141l-3.415-3.67,3.415-3.686v-5.2h-1.723v4.44l-4.108,4.448,4.108,4.433v11.479l3.414,3.686-3.415,3.67v5.2Z",
    transform: "translate(-745.786 -89.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,226.467h4.1l4.108,4.432,4.124-4.432H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.086l-4.123-4.448-4.124,4.448H955.058l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-780.137 -167.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.475,263.575V268l-4.092,4.448,4.092,4.435v11.492l3.4,3.67-3.4,3.67v5.2h1.723v-4.425l4.093-4.448L1034.2,287.6V276.118l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-852.745 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,629.823h-4.086l-4.124-4.447-4.108,4.447H829.962l-3.4,3.671-3.4-3.671h-4.825v1.838h4.117l4.108,4.448,4.108-4.448h10.635l3.4-3.67,3.4,3.67h4.81Z",
    transform: "translate(-673.184 -514.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,435.968v-4.44l4.108-4.447-4.108-4.433V411.155l-3.415-3.67,3.415-3.67v-5.2h-1.723v4.425l-4.108,4.448,4.108,4.448v11.479l3.415,3.671-3.414,3.685v5.2Z",
    transform: "translate(-745.786 -320.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,496.625h4.1l4.108,4.448,4.124-4.448H966.4l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086l-4.123-4.432-4.124,4.432H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 -398.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.475,533.643v4.44l-4.092,4.433,4.092,4.448v11.479l3.4,3.686-3.4,3.67V571h1.723v-4.44l4.093-4.432-4.093-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-852.745 -435.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,899.891h-4.086l-4.124-4.448-4.108,4.448H829.962l-3.4,3.67-3.4-3.67h-4.826v1.852h4.117l4.108,4.433,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -744.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,706.033v-4.441l4.108-4.432-4.108-4.448V681.233l-3.415-3.67,3.415-3.686v-5.2h-1.723v4.44l-4.108,4.448L907.376,682v11.479l3.414,3.686-3.415,3.67v5.2Z",
    transform: "translate(-745.788 -551.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,766.7l4.1,0,4.108,4.437,4.124-4.437H966.4l3.4-3.681,3.4,3.681h4.81v-1.846h-4.086l-4.123-4.448-4.124,4.448H955.058l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-780.137 -629.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.474,803.781v4.43l-4.092,4.448,4.093,4.432v11.494l3.4,3.671-3.4,3.686v5.2h1.723v-4.456l4.093-4.432-4.093-4.448V816.329l-3.4-3.67,3.4-3.686v-5.19Z",
    transform: "translate(-852.744 -666.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1169.972h-4.086l-4.124-4.463-4.108,4.463H829.962l-3.4,3.655-3.4-3.655h-4.826v1.853h4.117l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,976.209v-4.456l4.108-4.433-4.108-4.432V951.409l-3.415-3.686,3.415-3.67v-5.2h-1.724v4.425l-4.108,4.448,4.108,4.432v11.479l3.415,3.686-3.414,3.686v5.2Z",
    transform: "translate(-745.786 -782.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.452,1036.763h4.1l4.108,4.463,4.124-4.464H966.4l3.4-3.655,3.4,3.655h4.81v-1.821h-4.086l-4.123-4.463-4.124,4.463H955.06l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-780.14 -860.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1073.782v4.455l-4.092,4.432,4.092,4.433v11.506l3.4,3.658-3.4,3.685v5.2h1.723v-4.425l4.093-4.463-4.093-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-852.744 -897.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1440.22h-4.086l-4.124-4.433-4.108,4.433H829.962l-3.4,3.685-3.4-3.686h-4.826v1.852h4.117l4.108,4.432,4.108-4.432h10.635l3.4-3.686,3.4,3.686,4.81,0Z",
    transform: "translate(-673.184 -1206.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1246.366v-4.424l4.109-4.464-4.108-4.432v-11.479l-3.415-3.685,3.415-3.658v-5.2h-1.723v4.425l-4.108,4.432,4.108,4.463v11.479l3.414,3.655-3.414,3.685v5.2Z",
    transform: "translate(-745.786 -1013.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,1307.037h4.1l4.108,4.432,4.124-4.433H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.085l-4.123-4.433-4.124,4.433H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 -1091.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1344.058v4.424l-4.093,4.432,4.093,4.464v11.478l3.4,3.655-3.4,3.685v5.2h1.724v-4.424l4.093-4.463-4.093-4.433V1356.6l-3.4-3.685,3.4-3.655v-5.2Z",
    transform: "translate(-852.744 -1128.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1710.286h-4.086l-4.124-4.433-4.108,4.431H829.962l-3.4,3.686-3.4-3.686h-4.826v1.852h4.117l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686,4.81,0Z",
    transform: "translate(-673.184 -1437.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1516.435v-4.424l4.108-4.433-4.108-4.463v-11.481l-3.414-3.684,3.414-3.655v-5.2h-1.722v4.425l-4.108,4.432,4.109,4.464v11.479l3.414,3.685-3.414,3.655v5.2Z",
    transform: "translate(-745.788 -1243.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,1577.1h4.1l4.107,4.432,4.124-4.433H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.085l-4.123-4.432-4.124,4.432H955.057l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-780.137 -1322.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1614.119v4.425l-4.092,4.463,4.092,4.433v11.479l3.4,3.685-3.4,3.655v5.2h1.724v-4.425l4.093-4.431-4.093-4.464v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-852.744 -1359.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1980.352h-4.086l-4.124-4.432-4.108,4.432H829.962l-3.4,3.686-3.4-3.686h-4.826v1.851h4.117l4.108,4.464,4.108-4.464h10.635l3.4-3.655,3.4,3.655h4.81Z",
    transform: "translate(-673.184 -1668.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1786.5v-4.425l4.108-4.433-4.108-4.464V1761.7l-3.414-3.655,3.414-3.685v-5.2h-1.723v4.424l-4.108,4.463,4.108,4.433v11.479l3.415,3.687-3.414,3.686v5.171Z",
    transform: "translate(-745.786 -1474.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.444,1847.169h4.1l4.107,4.432,4.124-4.432H966.4l3.4-3.684,3.4,3.683H978v-1.852H973.92l-4.123-4.433-4.124,4.433H955.054l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-780.133 -1553.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.469,1884.189v4.424l-4.093,4.463,4.093,4.433v11.479l3.4,3.685-3.4,3.686v5.2h1.723v-4.456l4.093-4.432-4.093-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-852.739 -1590.184)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164.578 0.161)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.161 -0.162)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.228 -20.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.9,89.588h-4.1l-4.108-4.448-4.111,4.448H579.944l-3.4,3.67-3.414-3.67H568.32v1.837h4.1l4.124,4.447,4.108-4.447h10.634l3.4-3.67,3.4,3.671h4.81Z",
    transform: "translate(-459.451 -52.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.066-104.269v-4.44l4.123-4.448-4.123-4.433v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.439l-4.108,4.434,4.108,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-532.055 141.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.328-43.61h4.113l4.112,4.448,4.108-4.448H716.3l3.4-3.67,3.4,3.67h4.81v-1.852h-4.1l-4.108-4.432-4.108,4.432H704.952l-3.4,3.685-3.4-3.685h-4.826Z",
    transform: "translate(-566.316 63.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.367-6.593v4.44L778.259,2.28l4.108,4.448V18.206l3.41,3.686-3.411,3.671v5.2h1.708v-4.44l4.123-4.432-4.123-4.448V5.966l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-638.921 26.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.883,89.59h-4.1l-4.108-4.447L340.55,89.59H329.931l-3.414,3.67-3.4-3.67h-4.81v1.837h4.1l4.108,4.447,4.124-4.447h10.619l3.415-3.67,3.4,3.67h4.81Z",
    transform: "translate(-245.722 -52.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.054-104.267v-4.44l4.108-4.448-4.108-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.438l-4.108,4.434,4.108,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-318.327 141.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.315-43.608h4.1l4.123,4.447,4.108-4.448h10.619l3.415-3.67,3.4,3.67h4.81V-45.46h-4.1l-4.108-4.432-4.124,4.432H454.939l-3.4,3.685-3.414-3.685h-4.81Z",
    transform: "translate(-352.587 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.355-6.593v4.44L528.247,2.28l4.108,4.448V18.206l3.4,3.686-3.4,3.67v5.2h1.708v-4.44l4.108-4.432-4.108-4.448V5.965l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-425.193 26.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.871,89.591h-4.1l-4.124-4.447-4.108,4.447H79.9l-3.4,3.67-3.4-3.671H68.3v1.837h4.1L76.5,95.876l4.108-4.448H91.247l3.4-3.67,3.414,3.67h4.81Z",
    transform: "translate(-31.994 -52.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.949-104.267v-4.44l4.108-4.448-4.108-4.433v-11.479l-3.4-3.685,3.4-3.67v-5.2h-1.708v4.438l-4.124,4.434,4.124,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-104.506 141.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3-43.608h4.1l4.108,4.448,4.123-4.448h10.619l3.4-3.67,3.414,3.67h4.811V-45.46h-4.1l-4.124-4.432-4.108,4.432H204.925l-3.414,3.686-3.4-3.686H193.3Z",
    transform: "translate(-138.858 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.337-6.592v4.44l-4.109,4.433,4.109,4.448V18.207l3.4,3.686-3.4,3.67v5.2h1.708v-4.44l4.108-4.432-4.108-4.448V5.966l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-211.46 26.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.222,89.591h-4.117l-4.108-4.447-4.108,4.447h-10.634l-3.4,3.671-3.4-3.67h-4.823v1.837h4.114l4.108,4.448,4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.826Z",
    transform: "translate(181.815 -52.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.715-43.608h4.1L-48.5-39.16l4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.826V-45.46h-4.117l-4.108-4.432-4.108,4.432H-45.106l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(74.874 63.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.237-6.591v4.44L28.113,2.282,32.236,6.73V18.209l3.4,3.686-3.4,3.67v5.2h1.708V26.326l4.108-4.432-4.108-4.448V5.968L30.53,2.282l3.415-3.67v-5.2Z",
    transform: "translate(2.357 26.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.9,359.657h-4.1l-4.108-4.447-4.111,4.447H579.943l-3.4,3.686-3.415-3.686h-4.81v1.852h4.1l4.124,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.45 -283.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.065,165.8v-4.436l4.123-4.437-4.123-4.448V141l-3.4-3.67,3.4-3.685v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-532.054 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.327,226.474h4.113l4.112,4.433,4.108-4.433h10.635l3.4-3.686,3.4,3.686h4.81v-1.852h-4.1l-4.108-4.448-4.108,4.448H704.951l-3.4,3.67-3.4-3.67h-4.825Z",
    transform: "translate(-566.315 -167.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.367,263.582v4.425l-4.108,4.448,4.108,4.437v11.49l3.411,3.671-3.411,3.67v5.2h1.708V296.5l4.123-4.448-4.124-4.448V276.125l-3.4-3.67,3.4-3.685v-5.187Z",
    transform: "translate(-638.921 -204.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.882,359.657h-4.1l-4.108-4.447-4.124,4.447H329.93l-3.414,3.686-3.4-3.686h-4.81v1.853h4.1l4.108,4.433,4.123-4.432h10.619l3.415-3.686,3.4,3.686h4.81Z",
    transform: "translate(-245.721 -283.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.053,165.8v-4.436l4.108-4.437-4.108-4.448V141l-3.4-3.67,3.4-3.686v-5.2h-1.707v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.685-3.4,3.67v5.2Z",
    transform: "translate(-318.326 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.313,226.477h4.1l4.124,4.433,4.108-4.433h10.619l3.415-3.686,3.4,3.686h4.81v-1.852h-4.1l-4.108-4.447-4.124,4.447H454.937l-3.4,3.67-3.414-3.67h-4.81Z",
    transform: "translate(-352.586 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.352,263.582v4.425l-4.108,4.448,4.108,4.437v11.49l3.4,3.671-3.4,3.671v5.2h1.708V296.5l4.108-4.448L534.06,287.6V276.125l-3.4-3.671,3.4-3.685v-5.187Z",
    transform: "translate(-425.191 -204.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,359.659h-4.1l-4.124-4.448-4.108,4.447H79.9l-3.4,3.686-3.4-3.685h-4.81v1.852h4.1l4.108,4.433,4.108-4.433H91.246l3.4-3.686,3.415,3.686h4.81Z",
    transform: "translate(-31.993 -283.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.947,165.8v-4.436l4.108-4.437-4.108-4.448V141l-3.4-3.67,3.4-3.686v-5.2H157.24v4.441l-4.123,4.447,4.124,4.432v11.479l3.4,3.685-3.4,3.671v5.2Z",
    transform: "translate(-104.505 -89.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,226.477h4.1l4.108,4.432,4.124-4.433H216.25l3.4-3.686,3.414,3.686h4.81v-1.852h-4.1l-4.123-4.447-4.108,4.447H204.922l-3.415,3.67-3.4-3.67H193.3Z",
    transform: "translate(-138.854 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.334,263.584v4.425l-4.109,4.448,4.109,4.437v11.49l3.4,3.671-3.4,3.671v5.2h1.708V296.5l4.108-4.448-4.108-4.448V276.127l-3.4-3.67,3.4-3.685v-5.187Z",
    transform: "translate(-211.457 -204.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.224,359.661h-4.116l-4.108-4.447-4.108,4.448h-10.634l-3.4,3.686-3.4-3.686h-4.823v1.851h4.114l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.826Z",
    transform: "translate(181.817 -283.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.715,226.477h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825v-1.852h-4.116l-4.108-4.448-4.108,4.447H-45.106l-3.4,3.671-3.4-3.67h-4.81Z",
    transform: "translate(74.874 -167.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.232,263.584v4.425l-4.124,4.448,4.124,4.437v11.49l3.4,3.67-3.4,3.67v5.2H33.94V296.5l4.108-4.447-4.108-4.447v-11.48l-3.414-3.67,3.415-3.686v-5.187Z",
    transform: "translate(2.361 -204.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.893,629.831h-4.1l-4.108-4.447-4.114,4.447H579.941l-3.4,3.671-3.415-3.671h-4.81v1.837h4.1l4.124,4.448,4.107-4.447h10.635l3.4-3.671,3.4,3.671h4.81Z",
    transform: "translate(-459.448 -514.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.065,435.976v-4.44l4.123-4.448-4.124-4.433V411.162l-3.4-3.67,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-532.054 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.325,496.633h4.113l4.112,4.447,4.108-4.447h10.635l3.4-3.671,3.4,3.671h4.81V494.78h-4.1l-4.108-4.432-4.108,4.432H704.949l-3.4,3.686-3.4-3.685h-4.825Z",
    transform: "translate(-566.314 -398.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.364,533.65v4.44l-4.108,4.433,4.108,4.448v11.479l3.411,3.686-3.411,3.671v5.2h1.707v-4.44l4.124-4.433-4.124-4.448V546.208l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-638.919 -435.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.879,629.831h-4.1l-4.108-4.447-4.124,4.447H329.927l-3.414,3.671-3.4-3.671H318.3v1.838h4.1l4.108,4.448,4.123-4.448h10.619L344.67,628l3.4,3.67h4.81Z",
    transform: "translate(-245.718 -514.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.051,435.976v-4.44l4.108-4.448-4.108-4.433V411.162l-3.4-3.671,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.447v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-318.324 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,496.634h4.1l4.124,4.448,4.108-4.447h10.619l3.415-3.67,3.4,3.67h4.81v-1.852h-4.1l-4.108-4.432-4.123,4.432H454.934l-3.4,3.685-3.415-3.685h-4.81Z",
    transform: "translate(-352.583 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.352,533.65v4.441l-4.108,4.432,4.108,4.448v11.479l3.4,3.686-3.4,3.671v5.2h1.708v-4.441l4.108-4.433-4.108-4.448V546.208l-3.4-3.685,3.4-3.671v-5.2Z",
    transform: "translate(-425.191 -435.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.865,629.833h-4.1l-4.123-4.447-4.108,4.447H79.9L76.5,633.5l-3.4-3.671h-4.81v1.837h4.1l4.108,4.448,4.108-4.448H91.241l3.4-3.67,3.415,3.671h4.811Z",
    transform: "translate(-31.988 -514.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.946,435.977v-4.44l4.108-4.448-4.108-4.433V411.162l-3.4-3.67,3.4-3.671v-5.2h-1.708v4.425l-4.123,4.447,4.124,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-104.504 -320.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,496.635h4.1l4.108,4.448,4.124-4.448h10.619l3.4-3.67,3.415,3.671h4.81v-1.852h-4.1l-4.123-4.432-4.108,4.432H204.92l-3.415,3.686-3.4-3.685H193.3Z",
    transform: "translate(-138.853 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.328,533.653v4.44l-4.11,4.433,4.11,4.448v11.479l3.4,3.686-3.4,3.669v5.2h1.709v-4.439l4.109-4.433-4.108-4.448V546.211l-3.4-3.686,3.4-3.671v-5.2Z",
    transform: "translate(-211.451 -435.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.224,629.833h-4.116l-4.108-4.447-4.108,4.447h-10.635l-3.4,3.672-3.4-3.671h-4.823v1.837h4.114l4.108,4.448,4.108-4.448h10.634l3.4-3.671,3.4,3.67h4.825Z",
    transform: "translate(181.817 -514.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.716,496.634h4.1l4.108,4.448,4.108-4.448h10.634l3.4-3.67,3.4,3.67h4.825v-1.852h-4.116l-4.108-4.432-4.108,4.433H-45.107l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(74.875 -398.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.232,533.653v4.44l-4.124,4.432,4.124,4.448v11.479l3.4,3.686-3.4,3.671v5.2h1.707V566.57l4.108-4.432-4.108-4.448V546.211l-3.415-3.685,3.414-3.67v-5.2Z",
    transform: "translate(2.361 -435.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.891,899.9h-4.1l-4.108-4.448-4.114,4.448H579.939l-3.4,3.67-3.414-3.67h-4.811v1.852h4.1l4.123,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.81Z",
    transform: "translate(-459.446 -744.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.063,706.044V701.6l4.123-4.432-4.123-4.448V681.244l-3.4-3.67,3.4-3.686v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.433v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-532.052 -551.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.322,766.713h4.113l4.112,4.436,4.108-4.434h10.634l3.4-3.683,3.4,3.683H727.9v-1.849h-4.1l-4.108-4.448-4.108,4.448H704.946l-3.4,3.671-3.4-3.671h-4.825Z",
    transform: "translate(-566.311 -629.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.362,803.8v4.428l-4.108,4.448,4.108,4.432v11.494l3.41,3.67-3.41,3.686v5.2h1.707v-4.457l4.123-4.432-4.123-4.448V816.349l-3.4-3.67,3.4-3.686V803.8Z",
    transform: "translate(-638.917 -666.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.877,899.9h-4.1l-4.108-4.448-4.124,4.448H329.925l-3.414,3.67-3.4-3.67H318.3v1.852h4.1l4.108,4.432,4.123-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.716 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.047,706.044V701.6l4.108-4.433-4.108-4.448V681.245l-3.4-3.67,3.4-3.686v-5.2h-1.708v4.44l-4.108,4.448,4.108,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-318.321 -551.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.309,766.714h4.1l4.124,4.434,4.108-4.436h10.619l3.414-3.683,3.4,3.683h4.81v-1.85h-4.1l-4.108-4.448-4.123,4.448H454.933l-3.4,3.671-3.415-3.671h-4.81Z",
    transform: "translate(-352.582 -629.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.349,803.8v4.429l-4.108,4.448,4.108,4.432v11.495l3.4,3.671-3.4,3.686v5.2h1.708v-4.456l4.109-4.432-4.108-4.448V816.35l-3.4-3.671,3.4-3.686V803.8Z",
    transform: "translate(-425.188 -666.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.865,899.905h-4.1l-4.124-4.447-4.108,4.447H79.9l-3.4,3.67-3.4-3.67h-4.81v1.852h4.1L76.5,906.19l4.108-4.433H91.241l3.4-3.685,3.415,3.685h4.811Z",
    transform: "translate(-31.988 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.946,706.048v-4.44l4.108-4.433-4.108-4.448V681.248l-3.4-3.671,3.4-3.685v-5.2h-1.707v4.44l-4.123,4.447,4.123,4.432v11.479l3.4,3.686-3.4,3.671v5.2Z",
    transform: "translate(-104.504 -551.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.293,766.718h4.1l4.108,4.434,4.124-4.434h10.619l3.4-3.683,3.414,3.683h4.811v-1.849h-4.1l-4.124-4.448-4.108,4.447h-10.62l-3.414,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-138.851 -629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.327,803.812v4.427l-4.11,4.448,4.11,4.432v11.495l3.4,3.67-3.4,3.685v5.2h1.708v-4.456l4.108-4.432-4.108-4.448V816.357l-3.4-3.67,3.4-3.685v-5.189Z",
    transform: "translate(-211.451 -666.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.231,899.9h-4.116l-4.108-4.448-4.108,4.448H-170.2l-3.4,3.671-3.4-3.67h-4.824v1.853h4.115l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.823 -744.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.719,766.719h4.1l4.108,4.435,4.108-4.435h10.634l3.4-3.684,3.4,3.683h4.825v-1.85h-4.117l-4.108-4.447-4.108,4.447H-45.11l-3.4,3.671-3.4-3.67h-4.81Z",
    transform: "translate(74.877 -629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.23,803.812v4.427l-4.124,4.448,4.123,4.432v11.494l3.4,3.67-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.448V816.358l-3.415-3.671L33.937,809v-5.189Z",
    transform: "translate(2.363 -666.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.888,1169.981h-4.1l-4.108-4.464-4.113,4.464h-10.63l-3.4,3.654-3.414-3.654h-4.811v1.851h4.1l4.123,4.432,4.108-4.431h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.443 -975.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.061,976.216V971.76l4.123-4.433L659.06,962.9V951.417l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.433v11.48l3.4,3.684-3.4,3.686v5.2Z",
    transform: "translate(-532.05 -782.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.321,1036.77h4.111l4.114,4.463,4.108-4.463h10.635l3.4-3.656,3.4,3.654H727.9v-1.82h-4.1l-4.108-4.463-4.108,4.463H704.945l-3.4,3.656-3.4-3.655h-4.826Z",
    transform: "translate(-566.31 -860.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.36,1073.782v4.457l-4.108,4.433,4.108,4.433v11.505l3.41,3.659-3.41,3.686v5.2h1.708v-4.425l4.124-4.463-4.124-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-638.915 -897.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.875,1169.988h-4.1l-4.109-4.463-4.123,4.463H329.923l-3.414,3.654-3.4-3.654H318.3v1.852h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.686,3.4,3.686h4.81Z",
    transform: "translate(-245.715 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.047,976.221v-4.457l4.108-4.433-4.108-4.432V951.422l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.108,4.448,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.2Z",
    transform: "translate(-318.321 -782.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.309,1036.773h4.1l4.124,4.464,4.108-4.464h10.619l3.414-3.655,3.4,3.655h4.81v-1.821h-4.1l-4.108-4.463-4.124,4.463H454.933l-3.4,3.654-3.414-3.654h-4.81Z",
    transform: "translate(-352.582 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.349,1073.789v4.456l-4.108,4.431,4.108,4.432v11.506l3.4,3.659-3.4,3.686v5.2h1.708v-4.425l4.108-4.463-4.108-4.432v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-425.188 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.863,1169.989h-4.1l-4.123-4.463-4.108,4.463H79.9l-3.4,3.654-3.4-3.654h-4.81v1.852h4.1l4.108,4.432,4.108-4.432H91.239l3.4-3.686,3.415,3.686h4.81Z",
    transform: "translate(-31.987 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.941,976.222v-4.456l4.108-4.433-4.108-4.432V951.421l-3.4-3.686,3.4-3.67v-5.2h-1.708v4.425l-4.123,4.447,4.124,4.433v11.479l3.4,3.685-3.4,3.686v5.2Z",
    transform: "translate(-104.499 -782.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,1036.773h4.1l4.108,4.464,4.123-4.464h10.619l3.4-3.655,3.414,3.655h4.811v-1.821h-4.1l-4.123-4.463-4.107,4.463h-10.62l-3.414,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-138.848 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.31,1073.789v4.456l-4.112,4.432,4.112,4.433v11.508l3.4,3.657-3.4,3.685v5.2h1.708v-4.425l4.108-4.463-4.108-4.433v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-211.434 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.234,1169.989h-4.116l-4.108-4.463-4.108,4.463H-170.2l-3.4,3.655-3.4-3.654h-4.823v1.851h4.115l4.108,4.432,4.108-4.431h10.634l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.826 -975.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.721,1036.773h4.1l4.108,4.463,4.108-4.463h10.634l3.4-3.655,3.4,3.655h4.824v-1.821h-4.116l-4.108-4.463-4.108,4.463H-45.112l-3.4,3.656-3.4-3.656h-4.81Z",
    transform: "translate(74.879 -860.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.227,1073.789v4.456l-4.124,4.432,4.124,4.433v11.508l3.4,3.657-3.4,3.685v5.2h1.708v-4.425l4.108-4.463-4.108-4.432v-11.479l-3.415-3.686,3.415-3.685v-5.2Z",
    transform: "translate(2.365 -897.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.887,1440.236h-4.1l-4.108-4.432-4.113,4.432h-10.63l-3.4,3.685-3.414-3.685h-4.81v1.852h4.1l4.123,4.432,4.108-4.432h10.631l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-459.443 -1206.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.059,1246.38v-4.425l4.123-4.463-4.123-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2H657.35v4.424l-4.108,4.432,4.108,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-532.048 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.32,1307.051h4.111l4.114,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81V1305.2h-4.1l-4.108-4.433-4.109,4.433H704.943l-3.4,3.685-3.4-3.685H693.32Z",
    transform: "translate(-566.309 -1091.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.357,1344.068v4.425l-4.108,4.432,4.108,4.464v11.479l3.409,3.655-3.41,3.686v5.2h1.708v-4.426l4.124-4.463-4.124-4.433v-11.478l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-638.913 -1128.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.872,1440.236h-4.1l-4.108-4.432-4.124,4.432H329.92l-3.414,3.686-3.4-3.685H318.3v1.853h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.712 -1206.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.043,1246.381v-4.426l4.108-4.464-4.108-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2h-1.707v4.425l-4.108,4.433,4.108,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-318.317 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.306,1307.052h4.1l4.124,4.432,4.108-4.432h10.619l3.415-3.685,3.4,3.685h4.81V1305.2h-4.1l-4.108-4.433-4.124,4.433H454.93l-3.4,3.686-3.414-3.685h-4.81Z",
    transform: "translate(-352.58 -1091.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.342,1344.068v4.426l-4.108,4.432,4.108,4.464v11.479l3.4,3.655-3.4,3.686v5.2h1.708v-4.426l4.108-4.463-4.108-4.432v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-425.182 -1128.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,1440.24h-4.1l-4.123-4.432-4.108,4.432H79.892l-3.4,3.685-3.4-3.685H68.284v1.851h4.1l4.108,4.432,4.108-4.432H91.236l3.4-3.686,3.414,3.686h4.81Z",
    transform: "translate(-31.984 -1206.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,1246.381v-4.426l4.108-4.464-4.108-4.432v-11.479l-3.4-3.685,3.4-3.657v-5.2h-1.708v4.426l-4.123,4.432,4.123,4.463v11.479l3.4,3.654-3.4,3.686v5.2Z",
    transform: "translate(-104.499 -1013.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,1307.058h4.1l4.108,4.432,4.124-4.433h10.619l3.4-3.686,3.415,3.686h4.81v-1.851h-4.1l-4.123-4.432-4.108,4.432h-10.62l-3.415,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-138.848 -1091.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1344.073v4.425l-4.113,4.433,4.113,4.463v11.479l3.4,3.656-3.4,3.684v5.2h1.709v-4.425l4.109-4.462-4.108-4.433v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-211.425 -1128.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.235,1440.241h-4.116l-4.108-4.433-4.108,4.432H-170.2l-3.4,3.685-3.4-3.685h-4.823v1.852h4.115l4.108,4.432,4.108-4.432h10.635l3.4-3.686,3.4,3.686h4.825Z",
    transform: "translate(181.826 -1206.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.724,1307.056h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825V1305.2h-4.116l-4.108-4.432-4.108,4.433H-45.115l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(74.882 -1091.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.227,1344.073v4.425l-4.123,4.432,4.124,4.463v11.479l3.4,3.655-3.4,3.685v5.2h1.708v-4.425l4.107-4.462-4.108-4.432v-11.479l-3.414-3.686,3.414-3.655v-5.2Z",
    transform: "translate(2.365 -1128.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.884,1710.3h-4.1l-4.109-4.433-4.113,4.433h-10.63l-3.4,3.685-3.415-3.685h-4.811v1.852h4.1l4.123,4.431,4.108-4.432h10.626l3.409-3.686,3.4,3.685h4.81Z",
    transform: "translate(-459.44 -1437.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.055,1516.452v-4.426l4.123-4.432-4.123-4.463v-11.479l-3.4-3.685,3.4-3.656v-5.2h-1.708v4.424l-4.108,4.433,4.108,4.462v11.48l3.4,3.685-3.4,3.654v5.2Z",
    transform: "translate(-532.045 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.317,1577.122h4.112l4.113,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.81v-1.851h-4.1l-4.108-4.433-4.108,4.433H704.941l-3.4,3.685-3.4-3.685h-4.826Z",
    transform: "translate(-566.307 -1322.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.353,1614.138v4.425l-4.108,4.463,4.109,4.433v11.479l3.409,3.685-3.41,3.655v5.2h1.708v-4.425l4.123-4.432-4.123-4.464v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-638.909 -1359.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.872,1710.307h-4.1l-4.109-4.432-4.123,4.433H329.92l-3.415,3.685-3.4-3.685H318.3v1.852h4.1l4.108,4.432,4.124-4.432h10.619l3.414-3.685,3.4,3.686h4.81Z",
    transform: "translate(-245.712 -1437.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04,1516.452v-4.425l4.108-4.433-4.108-4.463v-11.479l-3.4-3.685,3.4-3.656v-5.2h-1.708v4.424l-4.108,4.433,4.108,4.463v11.478l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-318.315 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.306,1577.124h4.1l4.124,4.433,4.109-4.433h10.619l3.414-3.686,3.4,3.686h4.81v-1.851h-4.1l-4.108-4.432-4.123,4.432H454.93l-3.4,3.685-3.414-3.685h-4.81Z",
    transform: "translate(-352.58 -1322.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.34,1614.141v4.425l-4.108,4.463,4.108,4.432v11.479l3.4,3.686-3.4,3.655v5.2h1.708v-4.425l4.108-4.432-4.108-4.464v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-425.18 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.857,1710.309h-4.1l-4.123-4.433-4.107,4.432H79.889l-3.4,3.685-3.4-3.685h-4.81v1.852h4.1l4.108,4.432,4.108-4.432H91.233l3.4-3.686,3.414,3.686h4.81Z",
    transform: "translate(-31.982 -1437.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,1516.452v-4.425l4.108-4.433-4.108-4.463v-11.479l-3.4-3.685,3.4-3.655v-5.2h-1.707v4.425l-4.123,4.432,4.123,4.462v11.48l3.4,3.685-3.4,3.655v5.2Z",
    transform: "translate(-104.499 -1243.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.288,1577.124h4.1l4.108,4.433,4.123-4.433H216.24l3.4-3.685,3.415,3.685h4.81v-1.852h-4.1l-4.124-4.432-4.108,4.432h-10.62l-3.414,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-138.846 -1322.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1614.141v4.425l-4.113,4.463,4.113,4.433v11.479l3.4,3.686-3.4,3.655v5.2h1.709v-4.425l4.108-4.432-4.108-4.463v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-211.425 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.238,1710.31h-4.116l-4.108-4.432-4.109,4.433H-170.2l-3.4,3.686-3.4-3.686h-4.824v1.852h4.115l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.685h4.826Z",
    transform: "translate(181.829 -1437.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.724,1577.128h4.1l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.825v-1.852h-4.117l-4.108-4.432-4.108,4.432H-45.115l-3.4,3.686-3.4-3.685h-4.81Z",
    transform: "translate(74.882 -1322.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.224,1614.141v4.426l-4.123,4.463,4.123,4.432v11.48l3.4,3.685-3.4,3.655v5.2h1.708v-4.426l4.108-4.432-4.108-4.463v-11.479l-3.414-3.655,3.414-3.685v-5.2Z",
    transform: "translate(2.367 -1359.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.88,1980.372h-4.1l-4.108-4.433-4.113,4.433h-10.63l-3.4,3.685-3.414-3.685H568.3v1.851h4.1l4.123,4.463,4.107-4.462h10.626l3.408-3.655,3.4,3.655h4.81Z",
    transform: "translate(-459.437 -1668.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.053,1786.518v-4.426l4.122-4.432-4.122-4.463v-11.479l-3.4-3.654,3.4-3.686v-5.2h-1.708v4.425l-4.108,4.463,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-532.043 -1474.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.315,1847.19h4.112l4.113,4.432,4.108-4.433h10.634l3.4-3.664,3.4,3.664h4.81v-1.851h-4.1l-4.108-4.432-4.108,4.432H704.939l-3.4,3.686-3.4-3.686h-4.826Z",
    transform: "translate(-566.305 -1553.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.348,1884.2v4.425l-4.109,4.463,4.108,4.433V1909l3.409,3.685-3.41,3.686v5.2h1.709v-4.457l4.124-4.433-4.124-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-638.904 -1590.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.868,1980.379h-4.1l-4.108-4.432-4.123,4.432h-10.62l-3.414,3.685-3.4-3.685h-4.81v1.852h4.1l4.108,4.462,4.123-4.463h10.62l3.414-3.654,3.4,3.654h4.81Z",
    transform: "translate(-245.709 -1668.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04,1786.52v-4.426l4.108-4.432-4.108-4.463V1761.72l-3.4-3.655,3.4-3.686v-5.2h-1.707v4.425l-4.108,4.463,4.108,4.432v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-318.315 -1474.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3,1847.195h4.1l4.123,4.433,4.108-4.433h10.62l3.415-3.664,3.4,3.664h4.81v-1.853h-4.1l-4.108-4.432-4.123,4.432H454.925l-3.4,3.685-3.414-3.685H443.3Z",
    transform: "translate(-352.575 -1553.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.34,1884.211v4.425l-4.107,4.462,4.108,4.433v11.479l3.4,3.685-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.48l-3.4-3.685,3.4-3.685v-5.2Z",
    transform: "translate(-425.18 -1590.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.856,1980.38h-4.1l-4.123-4.432-4.107,4.432H79.889l-3.4,3.685-3.4-3.685H68.28v1.852h4.1l4.108,4.463,4.109-4.463H91.232l3.4-3.654,3.414,3.654h4.811Z",
    transform: "translate(-31.981 -1668.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.936,1786.525V1782.1l4.109-4.433-4.108-4.462v-11.479l-3.4-3.656,3.4-3.685v-5.2h-1.708v4.425l-4.123,4.462,4.124,4.432v11.48l3.4,3.686-3.4,3.686v5.172Z",
    transform: "translate(-104.495 -1474.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.286,1847.2h4.1l4.108,4.433,4.123-4.433h10.619l3.4-3.665,3.415,3.665h4.81v-1.851h-4.1l-4.124-4.432-4.108,4.432H204.91l-3.414,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-138.845 -1553.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.3,1884.214v4.425l-4.113,4.462,4.113,4.433v11.48l3.4,3.685-3.4,3.686v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.479l-3.4-3.685,3.4-3.685v-5.2Z",
    transform: "translate(-211.422 -1590.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.247,1980.375h-4.116l-4.108-4.433-4.108,4.433h-10.634l-3.4,3.686-3.4-3.685h-4.825l0,1.851h4.114l4.108,4.463,4.108-4.463h10.634l3.4-3.656,3.4,3.655h4.825Z",
    transform: "translate(181.838 -1668.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.728,1847.195h4.1l4.108,4.433,4.109-4.434h10.634l3.4-3.66,3.4,3.66h4.825v-1.851h-4.116l-4.108-4.432-4.108,4.432H-45.12l-3.4,3.686-3.4-3.686h-4.811Z",
    transform: "translate(74.885 -1553.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,1884.211v4.425L28.1,1893.1l4.124,4.432v11.479l3.4,3.686-3.4,3.685v5.2h1.708v-4.456l4.108-4.432-4.108-4.433v-11.479l-3.415-3.686,3.414-3.685v-5.2Z",
    transform: "translate(2.371 -1590.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.015,89.581h-4.086l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.67-3.4-3.67h-4.811v1.836h4.086l4.124,4.447,4.123-4.447h10.619l3.4-3.67,3.4,3.67h4.811Z",
    transform: "translate(-887.001 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.724v4.437l-4.093,4.436,4.093,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-959.606 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461-43.616h4.117l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086l-4.123-4.432-4.093,4.433h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-993.866 63.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.487-6.6v4.441L1278.4,2.274l4.092,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.724v-4.44l4.123-4.433-4.123-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1066.473 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,89.581h-4.113l-4.124-4.448-4.092,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.837h4.117l4.093,4.448,4.123-4.447h10.619l3.4-3.67,3.4,3.67h4.838Z",
    transform: "translate(-1100.729 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.214-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.724v4.437l-4.092,4.436,4.093,4.448v11.479l3.43,3.67-3.43,3.686v5.2Z",
    transform: "translate(-1173.335 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473-43.615h4.117l4.093,4.448,4.124-4.447h10.619l3.4-3.67,3.4,3.67h4.841v-1.852h-4.117l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.594 63.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525-6.6v4.441l-4.12,4.432,4.12,4.448,0,11.479,3.4,3.686-3.4,3.67,0,5.2h1.694v-4.44l4.124-4.432-4.124-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1280.2 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.07,89.581h-4.117l-4.123-4.448-4.093,4.448h-10.649l-3.4,3.67-3.4-3.67h-4.81v1.837h4.117l4.093,4.448,4.123-4.447h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1314.457 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.227-104.274v-4.441l4.123-4.448-4.123-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.692v4.437l-4.124,4.436,4.124,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-1387.063 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.488-43.617h4.116l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.431,3.67h4.809v-1.852h-4.116l-4.124-4.432-4.092,4.432h-10.619l-3.43,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-1421.324 63.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541-6.6v4.44l-4.124,4.433,4.124,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.693v-4.44l4.124-4.433-4.123-4.447V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-1493.928 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,89.581h-4.117l-4.124-4.447-4.093,4.448H1830.13l-3.431,3.671-3.4-3.671h-4.811v1.837h4.116l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1528.185 -52.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.238-104.274v-4.441l4.124-4.448-4.124-4.432v-11.479l-3.4-3.686,3.4-3.67v-5.2h-1.693v4.437l-4.123,4.436,4.123,4.448v11.479l3.4,3.67-3.4,3.685v5.2Z",
    transform: "translate(-1600.791 141.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5-43.618h4.117l4.093,4.448,4.123-4.447h10.619l3.427-3.67,3.4,3.67h4.81V-45.47h-4.117l-4.1-4.432-4.12,4.432h-10.619l-3.429,3.686-3.4-3.686H1943.5Z",
    transform: "translate(-1635.052 63.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.015,359.649h-4.086l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.81V361.5h4.086l4.124,4.433,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.811Z",
    transform: "translate(-887.001 -283.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,165.792v-4.437l4.123-4.435-4.123-4.448V140.992l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.441l-4.093,4.448,4.093,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-959.604 -89.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,226.466h4.116l4.094,4.432,4.123-4.432h10.62l3.4-3.686,3.4,3.685h4.81v-1.852h-4.085l-4.123-4.447-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-993.866 -167.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,263.57V268l-4.093,4.448,4.093,4.435V288.37l3.4,3.67-3.4,3.67v5.2h1.724v-4.425l4.124-4.447-4.124-4.448V276.113l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-1066.467 -204.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,359.647h-4.113l-4.124-4.448-4.093,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.811V361.5h4.116l4.092,4.432,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.729 -283.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.214,165.792v-4.438l4.123-4.435-4.123-4.448V140.992l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.44l-4.092,4.447,4.092,4.433v11.479l3.43,3.686-3.43,3.67v5.2Z",
    transform: "translate(-1173.335 -89.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,226.462h4.117l4.093,4.432,4.124-4.432h10.619l3.4-3.686,3.4,3.685h4.841V224.61h-4.117l-4.123-4.448-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1207.594 -167.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,263.575V268l-4.12,4.448,4.12,4.435v11.491l3.4,3.67-3.4,3.67,0,5.2h1.694v-4.425l4.124-4.447-4.124-4.448V276.118l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-1280.2 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.07,359.647h-4.117l-4.123-4.448-4.093,4.448h-10.649l-3.4,3.685-3.4-3.685h-4.81V361.5h4.117l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.429,3.686h4.811Z",
    transform: "translate(-1314.457 -283.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,165.794v-4.438l4.123-4.435-4.123-4.448V140.994l-3.4-3.67,3.4-3.686v-5.2h-1.692v4.44l-4.123,4.448,4.124,4.432v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-1387.06 -89.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.488,226.462h4.116l4.093,4.432,4.123-4.432h10.62l3.4-3.685,3.431,3.686h4.809V224.61h-4.117l-4.123-4.448-4.092,4.448h-10.619l-3.43,3.67-3.4-3.671h-4.809Z",
    transform: "translate(-1421.324 -167.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,263.575V268l-4.123,4.448,4.123,4.435v11.492l3.4,3.67-3.4,3.67v5.2h1.692v-4.425l4.124-4.447-4.124-4.448V276.118l-3.4-3.671,3.4-3.686v-5.187Z",
    transform: "translate(-1493.928 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,359.649h-4.117l-4.124-4.448-4.093,4.448H1830.13l-3.431,3.685-3.4-3.685h-4.811V361.5h4.117l4.092,4.433,4.124-4.432h10.619l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.185 -283.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,165.794v-4.437l4.124-4.435-4.124-4.448V140.994l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.123,4.433v11.479l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-1600.788 -89.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,226.466h4.117l4.092,4.432,4.124-4.432h10.619l3.427-3.686,3.4,3.686h4.811v-1.852h-4.117l-4.1-4.448-4.121,4.447h-10.619l-3.429,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1635.05 -167.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.013,629.819h-4.086l-4.123-4.447-4.094,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.838h4.086l4.123,4.448,4.124-4.448H1091.4l3.4-3.67,3.4,3.67h4.811Z",
    transform: "translate(-886.999 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,435.963v-4.44l4.123-4.448-4.123-4.432V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.724v4.425l-4.093,4.448,4.093,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,496.622h4.116l4.094,4.448,4.123-4.448h10.62l3.4-3.67,3.4,3.67h4.809v-1.852h-4.087l-4.123-4.432-4.092,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-993.866 -398.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,533.639v4.44l-4.093,4.432,4.093,4.448v11.479l3.4,3.686-3.4,3.67V571h1.723v-4.441l4.124-4.432-4.124-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1066.467 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.054,629.819h-4.113l-4.124-4.447-4.092,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.838h4.117l4.092,4.447,4.123-4.448h10.619l3.4-3.67,3.4,3.67h4.838Z",
    transform: "translate(-1100.729 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,435.963v-4.44l4.123-4.448-4.123-4.432V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.724v4.425l-4.093,4.448,4.092,4.448v11.478l3.43,3.671-3.43,3.685v5.2Z",
    transform: "translate(-1173.332 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,496.62h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.4,3.67h4.84v-1.852h-4.116l-4.123-4.432-4.094,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.594 -398.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,533.639v4.44l-4.12,4.432,4.12,4.448v11.479l3.4,3.686-3.4,3.67V571h1.7v-4.441l4.124-4.432-4.124-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1280.2 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,629.819h-4.117l-4.123-4.447-4.093,4.447h-10.65l-3.4,3.671-3.4-3.671h-4.81v1.837h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.429,3.67h4.811Z",
    transform: "translate(-1314.454 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,435.963v-4.44l4.123-4.448-4.123-4.433V411.149l-3.4-3.67,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.447v11.48l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,496.62h4.117l4.093,4.448,4.123-4.448h10.62l3.4-3.67,3.431,3.67h4.809v-1.852h-4.116l-4.124-4.433-4.092,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1421.322 -398.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,533.639v4.44l-4.124,4.432,4.124,4.448v11.479l3.4,3.686-3.4,3.67V571h1.692v-4.44l4.124-4.432-4.123-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-1493.928 -435.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.082,629.819h-4.117l-4.124-4.446-4.093,4.447H1830.13l-3.431,3.671-3.4-3.671h-4.811v1.838h4.117l4.092,4.448,4.124-4.448h10.619l3.4-3.67,3.43,3.67h4.81Z",
    transform: "translate(-1528.185 -514.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.238,435.962v-4.439l4.124-4.448-4.124-4.432V411.15l-3.4-3.671,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.448v11.479l3.4,3.67-3.4,3.686v5.2Z",
    transform: "translate(-1600.791 -320.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,496.622h4.117l4.094,4.448,4.123-4.448h10.619l3.427-3.67,3.4,3.67h4.811v-1.852h-4.117l-4.1-4.432-4.121,4.432h-10.619l-3.429,3.686-3.4-3.686H1943.5Z",
    transform: "translate(-1635.05 -398.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.013,899.887h-4.087l-4.123-4.448-4.094,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.852h4.086l4.123,4.433,4.124-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -744.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,706.029v-4.44l4.123-4.432-4.123-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.724v4.44l-4.093,4.448,4.093,4.432V693.47l3.4,3.686-3.4,3.67v5.2Z",
    transform: "translate(-959.604 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,766.7h4.116l4.094,4.438,4.123-4.438h10.619l3.4-3.68,3.4,3.68h4.81v-1.847h-4.086l-4.123-4.448-4.093,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-993.866 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,803.774v4.43l-4.093,4.448,4.093,4.432v11.495l3.4,3.67-3.4,3.687v5.2h1.723v-4.456l4.124-4.432L1284.2,827.8V816.322l-3.4-3.67,3.4-3.685v-5.192Z",
    transform: "translate(-1066.467 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,899.888h-4.113l-4.124-4.448-4.092,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81v1.852h4.116l4.093,4.433,4.123-4.433h10.62l3.4-3.685,3.4,3.685h4.837Z",
    transform: "translate(-1100.726 -744.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,706.029v-4.441l4.123-4.432-4.124-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.723v4.44l-4.092,4.448,4.092,4.432v11.479l3.431,3.686-3.431,3.67v5.2Z",
    transform: "translate(-1173.332 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,766.7h4.117l4.092,4.438,4.124-4.437h10.619l3.4-3.68,3.4,3.68h4.84v-1.848h-4.116l-4.123-4.448-4.094,4.448h-10.65l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1207.594 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.525,803.774v4.43l-4.12,4.448,4.12,4.433v11.495l3.4,3.67-3.4,3.686v5.2h1.7v-4.456l4.124-4.433-4.124-4.447V816.323l-3.4-3.671,3.4-3.685v-5.192Z",
    transform: "translate(-1280.2 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,899.886h-4.117l-4.123-4.448-4.094,4.448h-10.649l-3.4,3.671-3.4-3.67h-4.81v1.852h4.117l4.093,4.432,4.123-4.433h10.618l3.4-3.686,3.429,3.686h4.811Z",
    transform: "translate(-1314.454 -744.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,706.029v-4.441l4.123-4.432-4.123-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.124,4.433v11.479l3.4,3.685-3.4,3.67v5.2Z",
    transform: "translate(-1387.06 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,766.7h4.117l4.092,4.437,4.123-4.437h10.619l3.4-3.68,3.431,3.68h4.809v-1.846h-4.117l-4.123-4.448-4.093,4.448h-10.619l-3.43,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1421.322 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,803.774v4.43l-4.123,4.448,4.123,4.432v11.495l3.4,3.67-3.4,3.686v5.2h1.693v-4.456l4.124-4.433-4.124-4.447V816.322l-3.4-3.67,3.4-3.685v-5.192Z",
    transform: "translate(-1493.928 -666.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,899.886h-4.117l-4.124-4.448-4.093,4.448h-10.618l-3.431,3.67-3.4-3.67h-4.81v1.852h4.117l4.092,4.433,4.124-4.433h10.619l3.4-3.686,3.43,3.686h4.81Z",
    transform: "translate(-1528.183 -744.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,706.029v-4.441l4.124-4.432-4.124-4.448V681.23l-3.4-3.67,3.4-3.686v-5.2h-1.693v4.44l-4.123,4.448,4.123,4.432v11.479l3.4,3.685-3.4,3.671v5.2Z",
    transform: "translate(-1600.788 -551.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,766.7h4.117l4.094,4.438,4.123-4.437h10.618l3.428-3.68,3.4,3.68h4.811v-1.846h-4.117l-4.1-4.448-4.121,4.448h-10.619l-3.43,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-1635.05 -629.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1169.97h-4.085l-4.123-4.463-4.094,4.463h-10.649l-3.4,3.655-3.4-3.655h-4.81v1.853h4.086l4.124,4.433,4.122-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,976.2v-4.455l4.123-4.432-4.123-4.432V951.4l-3.4-3.687,3.4-3.67v-5.2h-1.723v4.425l-4.093,4.448,4.093,4.432V963.63l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -782.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,1036.752h4.116l4.094,4.462,4.124-4.462h10.62l3.4-3.656,3.4,3.656h4.81v-1.822h-4.086l-4.123-4.464-4.092,4.464h-10.651l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-993.866 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.481,1073.775v4.455l-4.093,4.432,4.093,4.433v11.5l3.4,3.66-3.4,3.685v5.2h1.723v-4.425l4.123-4.463-4.123-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1066.467 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1169.971h-4.114l-4.124-4.463-4.092,4.463h-10.651l-3.4,3.655-3.4-3.655h-4.81v1.851h4.117l4.092,4.433,4.124-4.433h10.62l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.726 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,976.2v-4.455l4.123-4.433-4.124-4.432V951.4l-3.4-3.686,3.4-3.671v-5.2h-1.723v4.426l-4.093,4.448,4.093,4.432v11.479l3.43,3.686-3.43,3.686v5.2Z",
    transform: "translate(-1173.332 -782.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.473,1036.752h4.117l4.092,4.462,4.124-4.462h10.619l3.4-3.656,3.4,3.656h4.841v-1.821h-4.116l-4.123-4.464-4.093,4.464h-10.65l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1207.594 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1073.775v4.455l-4.12,4.432,4.12,4.433v11.5l3.4,3.667-3.4,3.685v5.2h1.7v-4.425l4.124-4.463-4.124-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1280.196 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,1169.967h-4.117l-4.124-4.464-4.093,4.464h-10.65l-3.4,3.655-3.4-3.655h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.685,3.429,3.685h4.811Z",
    transform: "translate(-1314.454 -975.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,976.2v-4.455l4.123-4.433-4.123-4.432V951.4l-3.4-3.686,3.4-3.671v-5.2h-1.693v4.425l-4.123,4.448,4.123,4.433v11.479l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -782.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1036.752h4.116l4.093,4.462,4.123-4.462h10.619l3.4-3.656,3.43,3.656h4.81v-1.821h-4.117l-4.124-4.464-4.092,4.463h-10.62l-3.429,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1421.322 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.541,1073.775v4.455l-4.123,4.432,4.123,4.433v11.5l3.4,3.66-3.4,3.685v5.2h1.692v-4.425l4.124-4.463-4.124-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-1493.928 -897.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1169.97h-4.117l-4.124-4.463-4.093,4.463h-10.618l-3.431,3.655-3.4-3.655h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.62l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.183 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,976.2v-4.456l4.124-4.432-4.124-4.432V951.4l-3.4-3.687,3.4-3.67v-5.2h-1.693v4.425l-4.123,4.447,4.123,4.433V963.63l3.4,3.686-3.4,3.686v5.2Z",
    transform: "translate(-1600.788 -782.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.5,1036.752h4.116l4.093,4.463,4.124-4.463h10.618l3.428-3.656,3.4,3.656h4.811v-1.821h-4.116l-4.1-4.464-4.121,4.464h-10.619l-3.43,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-1635.05 -860.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1440.214h-4.086l-4.123-4.432-4.094,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.086l4.123,4.433,4.124-4.433H1091.4l3.4-3.685,3.4,3.685h4.81Z",
    transform: "translate(-886.999 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1246.358v-4.425l4.123-4.463-4.123-4.432v-11.479l-3.4-3.686,3.4-3.659v-5.2h-1.723v4.425l-4.093,4.432,4.093,4.463v11.479l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-959.604 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.461,1307.03h4.116l4.094,4.432,4.123-4.432h10.619l3.4-3.686,3.4,3.686h4.81v-1.852h-4.086l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.686-3.4-3.685h-4.81Z",
    transform: "translate(-993.866 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.48,1344.051v4.425l-4.093,4.432,4.093,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.723v-4.426l4.123-4.462-4.124-4.434v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-1066.467 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1440.214h-4.114l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.685-3.4-3.685h-4.81v1.852h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.684,3.4,3.684h4.833Z",
    transform: "translate(-1100.726 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1246.357v-4.425l4.123-4.463-4.124-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.463v11.479l3.43,3.655-3.43,3.686v5.2Z",
    transform: "translate(-1173.332 -1012.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1307.03h4.118l4.092,4.432,4.124-4.432h10.619l3.4-3.686,3.4,3.686h4.841v-1.852h-4.116l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1207.589 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1344.051v4.425l-4.12,4.432,4.12,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.7v-4.426l4.124-4.462-4.124-4.434v-11.479l-3.4-3.686,3.4-3.654v-5.2Z",
    transform: "translate(-1280.196 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.067,1440.214h-4.117l-4.124-4.432-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.433,4.124-4.433h10.618l3.4-3.685,3.43,3.685h4.811Z",
    transform: "translate(-1314.454 -1206.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,1246.359v-4.425l4.123-4.463-4.124-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.693v4.425l-4.123,4.432,4.123,4.464v11.478l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-1387.06 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1307.03h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.43,3.686h4.81v-1.852h-4.116l-4.124-4.433-4.092,4.433h-10.62l-3.429,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1421.322 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,1344.051v4.425l-4.123,4.432,4.123,4.463v11.479l3.4,3.656-3.4,3.685v5.2h1.692v-4.426l4.123-4.463-4.123-4.432v-11.479l-3.4-3.686,3.4-3.655v-5.2Z",
    transform: "translate(-1493.928 -1128.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1440.219h-4.117l-4.123-4.432-4.093,4.432h-10.618l-3.431,3.686-3.4-3.687h-4.81v1.851h4.117l4.092,4.433,4.123-4.433h10.62l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1528.183 -1206.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,1246.359v-4.425l4.124-4.463-4.123-4.432v-11.479l-3.4-3.685,3.4-3.66v-5.2h-1.693v4.425l-4.123,4.432,4.123,4.464v11.478l3.4,3.655-3.4,3.686v5.2Z",
    transform: "translate(-1600.788 -1012.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.493,1307.03h4.117l4.093,4.432,4.124-4.432h10.619l3.428-3.685,3.4,3.685h4.81v-1.852h-4.117l-4.095-4.433-4.121,4.433h-10.619l-3.43,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-1635.046 -1091.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1710.284h-4.086l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.685-3.4-3.685h-4.81v1.852h4.086l4.124,4.433,4.122-4.432H1091.4l3.4-3.684,3.4,3.684h4.81Z",
    transform: "translate(-886.999 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1516.424V1512l4.123-4.432-4.123-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.462v11.479l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-959.604 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.456,1577.1h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.685,3.4,3.685h4.811v-1.851h-4.086l-4.123-4.433-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.809Z",
    transform: "translate(-993.861 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.478,1614.119v4.425l-4.093,4.462,4.093,4.433v11.48l3.4,3.685-3.4,3.655v5.2h1.724v-4.424l4.124-4.433-4.124-4.463v-11.479l-3.4-3.654,3.4-3.686v-5.2Z",
    transform: "translate(-1066.465 -1359.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.046,1710.284h-4.108l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.433,4.123-4.433h10.619l3.4-3.685,3.4,3.685h4.838Z",
    transform: "translate(-1100.726 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1516.425V1512l4.124-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.723v4.425l-4.092,4.433,4.092,4.462v11.479l3.43,3.686-3.43,3.655v5.2Z",
    transform: "translate(-1173.332 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1577.1h4.117l4.092,4.432,4.124-4.432h10.619l3.4-3.685,3.4,3.685h4.841v-1.851h-4.116l-4.124-4.433-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-1207.589 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1614.116v4.425L1528.4,1623l4.12,4.433v11.48l3.4,3.685-3.4,3.655v5.2h1.7v-4.425l4.124-4.432-4.123-4.463v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-1280.196 -1359.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.063,1710.285h-4.117l-4.124-4.432-4.093,4.432h-10.649l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.432,4.124-4.432h10.618l3.4-3.685,3.43,3.685h4.81Z",
    transform: "translate(-1314.451 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.223,1516.425V1512l4.123-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.693v4.425l-4.123,4.433,4.123,4.463v11.479l3.4,3.685-3.4,3.655v5.2Z",
    transform: "translate(-1387.06 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.48,1577.1h4.117l4.093,4.432,4.123-4.432h10.619l3.4-3.686,3.43,3.686h4.81v-1.852h-4.117l-4.123-4.432-4.093,4.432h-10.62l-3.429,3.685-3.4-3.686h-4.81Z",
    transform: "translate(-1421.318 -1322.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.54,1614.116v4.426l-4.123,4.463,4.123,4.432v11.48l3.4,3.685-3.4,3.655v5.2h1.692v-4.425l4.123-4.433-4.123-4.463v-11.479l-3.4-3.655,3.4-3.686v-5.2Z",
    transform: "translate(-1493.928 -1359.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1710.284h-4.118l-4.124-4.432-4.092,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.433,4.123-4.432h10.62l3.4-3.684,3.43,3.684h4.811Z",
    transform: "translate(-1528.183 -1437.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.235,1516.425V1512l4.124-4.432-4.124-4.463v-11.48l-3.4-3.685,3.4-3.656v-5.2h-1.692v4.425l-4.123,4.433,4.123,4.463v11.479l3.4,3.686-3.4,3.655v5.2Z",
    transform: "translate(-1600.788 -1243.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.494,1577.1h4.116l4.093,4.432,4.124-4.432h10.619l3.428-3.685,3.4,3.685h4.81v-1.851h-4.117l-4.095-4.433-4.122,4.433h-10.618l-3.43,3.685-3.4-3.685h-4.811Z",
    transform: "translate(-1635.046 -1322.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.012,1980.35h-4.086l-4.123-4.432-4.093,4.432h-10.649l-3.4,3.685-3.4-3.685h-4.81v1.852h4.086l4.123,4.464,4.124-4.464H1091.4l3.4-3.654,3.4,3.654h4.81Z",
    transform: "translate(-886.999 -1668.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2,1786.49v-4.425l4.123-4.433-4.123-4.462v-11.48l-3.4-3.656,3.4-3.685v-5.2h-1.723v4.425l-4.092,4.462,4.093,4.433v11.479l3.4,3.685-3.4,3.686v5.171Z",
    transform: "translate(-959.604 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.456,1847.165h4.116l4.093,4.433,4.123-4.433h10.619l3.4-3.683,3.4,3.683h4.811v-1.852h-4.085l-4.123-4.432-4.093,4.433h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-993.861 -1553.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.48,1884.182v4.425l-4.093,4.462,4.093,4.432v11.48l3.4,3.686-3.4,3.685v5.2h1.723V1917.1l4.123-4.432-4.123-4.433v-11.479l-3.4-3.686,3.4-3.685v-5.2Z",
    transform: "translate(-1066.467 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.052,1980.352h-4.114l-4.124-4.432-4.092,4.432h-10.651l-3.4,3.686-3.4-3.686h-4.81v1.851h4.117l4.092,4.464,4.123-4.464h10.619l3.4-3.654,3.4,3.654h4.838Z",
    transform: "translate(-1100.726 -1668.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.211,1786.49v-4.425l4.124-4.433-4.123-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.724v4.425l-4.092,4.463,4.092,4.433v11.479l3.43,3.686-3.43,3.685v5.172Z",
    transform: "translate(-1173.332 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.468,1847.166h4.118l4.092,4.432,4.124-4.433h10.619l3.4-3.683,3.4,3.683h4.841v-1.852h-4.116l-4.123-4.432-4.093,4.432h-10.65l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-1207.589 -1553.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.521,1884.182v4.425l-4.12,4.463,4.12,4.432v11.48l3.4,3.685-3.4,3.685v5.2h1.7V1917.1l4.124-4.432-4.124-4.433v-11.478l-3.4-3.687,3.4-3.685v-5.2Z",
    transform: "translate(-1280.196 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.063,1980.346h-4.117l-4.123-4.433-4.093,4.432h-10.65l-3.4,3.686-3.4-3.686h-4.81v1.852h4.117l4.093,4.464,4.124-4.463h10.618l3.4-3.655,3.43,3.655h4.81Z",
    transform: "translate(-1314.451 -1668.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.224,1786.49v-4.425l4.123-4.433-4.124-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.692v4.425l-4.123,4.463,4.123,4.433v11.479l3.4,3.685-3.4,3.686v5.171Z",
    transform: "translate(-1387.06 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.485,1847.162h4.116l4.093,4.432,4.123-4.432h10.619l3.4-3.683,3.43,3.683h4.81v-1.852h-4.117l-4.123-4.433-4.092,4.432h-10.62l-3.429,3.685-3.4-3.685h-4.809Z",
    transform: "translate(-1421.322 -1553.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.535,1884.182v4.425l-4.123,4.462,4.123,4.432v11.48l3.4,3.685-3.4,3.686v5.2h1.692V1917.1l4.123-4.432-4.123-4.433v-11.478l-3.4-3.687,3.4-3.686v-5.2Z",
    transform: "translate(-1493.923 -1590.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853.08,1980.35h-4.118l-4.123-4.432-4.093,4.432h-10.619l-3.43,3.686-3.4-3.686h-4.81v1.851h4.117l4.093,4.464,4.123-4.464h10.619l3.4-3.654,3.431,3.655h4.809Z",
    transform: "translate(-1528.183 -1668.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1909.23,1786.49v-4.425l4.124-4.433-4.124-4.462v-11.48l-3.4-3.655,3.4-3.686v-5.2h-1.692v4.425l-4.124,4.463,4.124,4.433v11.479l3.4,3.685-3.4,3.686v5.172Z",
    transform: "translate(-1600.784 -1474.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.49,1847.168h4.117l4.093,4.433,4.124-4.432h10.619l3.428-3.683,3.4,3.683h4.81v-1.852h-4.117l-4.095-4.432-4.121,4.433H1955.13L1951.7,1849l-3.4-3.685h-4.81Z",
    transform: "translate(-1635.044 -1553.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,89.585h-4.086L844.7,85.138,840.6,89.585H829.962l-3.4,3.671-3.4-3.671h-4.825v1.837h4.117l4.108,4.448,4.108-4.448h10.635l3.4-3.67,3.4,3.67h4.81Z",
    transform: "translate(-673.184 -52.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1-104.271v-4.44l4.108-4.448-4.108-4.432v-11.479l-3.415-3.686,3.415-3.67v-5.2h-1.723v4.438l-4.108,4.434,4.108,4.448v11.479l3.415,3.67-3.415,3.686v5.2Z",
    transform: "translate(-745.786 141.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449-43.615h4.1l4.108,4.448,4.124-4.448H966.4l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086L969.8-49.9l-4.124,4.432H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 63.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.474-6.6v4.441l-4.093,4.432,4.092,4.448V18.2l3.4,3.686-3.4,3.67v5.2h1.723v-4.44l4.093-4.432-4.093-4.448V5.96l-3.4-3.686,3.4-3.67V-6.6Z",
    transform: "translate(-852.744 26.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,359.65h-4.086L844.7,355.2,840.6,359.65H829.962l-3.4,3.685-3.4-3.685h-4.826V361.5h4.116l4.108,4.433,4.108-4.433h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -283.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,165.795v-4.437l4.108-4.435-4.108-4.448V141l-3.415-3.67,3.415-3.686v-5.2h-1.723v4.44l-4.108,4.448,4.108,4.433v11.479l3.414,3.686-3.415,3.67v5.2Z",
    transform: "translate(-745.786 -89.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,226.467h4.1l4.108,4.432,4.124-4.432H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.086l-4.123-4.448-4.124,4.448H955.058l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-780.137 -167.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.475,263.575V268l-4.092,4.448,4.092,4.435v11.492l3.4,3.67-3.4,3.67v5.2h1.723v-4.425l4.093-4.448L1034.2,287.6V276.118l-3.4-3.67,3.4-3.686v-5.187Z",
    transform: "translate(-852.745 -204.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,629.823h-4.086l-4.124-4.447-4.108,4.447H829.962l-3.4,3.671-3.4-3.671h-4.825v1.838h4.117l4.108,4.448,4.108-4.448h10.635l3.4-3.67,3.4,3.67h4.81Z",
    transform: "translate(-673.184 -514.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,435.968v-4.44l4.108-4.447-4.108-4.433V411.155l-3.415-3.67,3.415-3.67v-5.2h-1.723v4.425l-4.108,4.448,4.108,4.448v11.479l3.415,3.671-3.414,3.685v5.2Z",
    transform: "translate(-745.786 -320.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,496.625h4.1l4.108,4.448,4.124-4.448H966.4l3.4-3.67,3.4,3.67h4.81v-1.852h-4.086l-4.123-4.432-4.124,4.432H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 -398.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.475,533.643v4.44l-4.092,4.433,4.092,4.448v11.479l3.4,3.686-3.4,3.67V571h1.723v-4.44l4.093-4.432-4.093-4.448V546.2l-3.4-3.686,3.4-3.67v-5.2Z",
    transform: "translate(-852.745 -435.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,899.891h-4.086l-4.124-4.448-4.108,4.448H829.962l-3.4,3.67-3.4-3.67h-4.826v1.852h4.117l4.108,4.433,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -744.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,706.033v-4.441l4.108-4.432-4.108-4.448V681.233l-3.415-3.67,3.415-3.686v-5.2h-1.723v4.44l-4.108,4.448L907.376,682v11.479l3.414,3.686-3.415,3.67v5.2Z",
    transform: "translate(-745.788 -551.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,766.7l4.1,0,4.108,4.437,4.124-4.437H966.4l3.4-3.681,3.4,3.681h4.81v-1.846h-4.086l-4.123-4.448-4.124,4.448H955.058l-3.4,3.67-3.4-3.67h-4.81Z",
    transform: "translate(-780.137 -629.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.474,803.781v4.43l-4.092,4.448,4.093,4.432v11.494l3.4,3.671-3.4,3.686v5.2h1.723v-4.456l4.093-4.432-4.093-4.448V816.329l-3.4-3.67,3.4-3.686v-5.19Z",
    transform: "translate(-852.744 -666.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1169.972h-4.086l-4.124-4.463-4.108,4.463H829.962l-3.4,3.655-3.4-3.655h-4.826v1.853h4.117l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686h4.81Z",
    transform: "translate(-673.184 -975.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,976.209v-4.456l4.108-4.433-4.108-4.432V951.409l-3.415-3.686,3.415-3.67v-5.2h-1.724v4.425l-4.108,4.448,4.108,4.432v11.479l3.415,3.686-3.414,3.686v5.2Z",
    transform: "translate(-745.786 -782.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.452,1036.763h4.1l4.108,4.463,4.124-4.464H966.4l3.4-3.655,3.4,3.655h4.81v-1.821h-4.086l-4.123-4.463-4.124,4.463H955.06l-3.4,3.655-3.4-3.655h-4.81Z",
    transform: "translate(-780.14 -860.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1073.782v4.455l-4.092,4.432,4.092,4.433v11.506l3.4,3.658-3.4,3.685v5.2h1.723v-4.425l4.093-4.463-4.093-4.433v-11.479l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-852.744 -897.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1440.22h-4.086l-4.124-4.433-4.108,4.433H829.962l-3.4,3.685-3.4-3.686h-4.826v1.852h4.117l4.108,4.432,4.108-4.432h10.635l3.4-3.686,3.4,3.686,4.81,0Z",
    transform: "translate(-673.184 -1206.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1246.366v-4.424l4.109-4.464-4.108-4.432v-11.479l-3.415-3.685,3.415-3.658v-5.2h-1.723v4.425l-4.108,4.432,4.108,4.463v11.479l3.414,3.655-3.414,3.685v5.2Z",
    transform: "translate(-745.786 -1013.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,1307.037h4.1l4.108,4.432,4.124-4.433H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.085l-4.123-4.433-4.124,4.433H955.058l-3.4,3.686-3.4-3.686h-4.81Z",
    transform: "translate(-780.137 -1091.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1344.058v4.424l-4.093,4.432,4.093,4.464v11.478l3.4,3.655-3.4,3.685v5.2h1.724v-4.424l4.093-4.463-4.093-4.433V1356.6l-3.4-3.685,3.4-3.655v-5.2Z",
    transform: "translate(-852.744 -1128.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1710.286h-4.086l-4.124-4.433-4.108,4.431H829.962l-3.4,3.686-3.4-3.686h-4.826v1.852h4.117l4.108,4.432,4.108-4.432h10.634l3.4-3.686,3.4,3.686,4.81,0Z",
    transform: "translate(-673.184 -1437.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1516.435v-4.424l4.108-4.433-4.108-4.463v-11.481l-3.414-3.684,3.414-3.655v-5.2h-1.722v4.425l-4.108,4.432,4.109,4.464v11.479l3.414,3.685-3.414,3.655v5.2Z",
    transform: "translate(-745.788 -1243.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.449,1577.1h4.1l4.107,4.432,4.124-4.433H966.4l3.4-3.686,3.4,3.686h4.81v-1.852h-4.085l-4.123-4.432-4.124,4.432H955.057l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-780.137 -1322.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.473,1614.119v4.425l-4.092,4.463,4.092,4.433v11.479l3.4,3.685-3.4,3.655v5.2h1.724v-4.425l4.093-4.431-4.093-4.464v-11.479l-3.4-3.655,3.4-3.685v-5.2Z",
    transform: "translate(-852.744 -1359.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.914,1980.352h-4.086l-4.124-4.432-4.108,4.432H829.962l-3.4,3.686-3.4-3.686h-4.826v1.851h4.117l4.108,4.464,4.108-4.464h10.635l3.4-3.655,3.4,3.655h4.81Z",
    transform: "translate(-673.184 -1668.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.1,1786.5v-4.425l4.108-4.433-4.108-4.464V1761.7l-3.414-3.655,3.414-3.685v-5.2h-1.723v4.424l-4.108,4.463,4.108,4.433v11.479l3.415,3.687-3.414,3.686v5.171Z",
    transform: "translate(-745.786 -1474.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.444,1847.169h4.1l4.107,4.432,4.124-4.432H966.4l3.4-3.684,3.4,3.683H978v-1.852H973.92l-4.123-4.433-4.124,4.433H955.054l-3.4,3.685-3.4-3.685h-4.81Z",
    transform: "translate(-780.133 -1553.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.469,1884.189v4.424l-4.093,4.463,4.093,4.433v11.479l3.4,3.685-3.4,3.686v5.2h1.723v-4.456l4.093-4.432-4.093-4.433v-11.478l-3.4-3.686,3.4-3.686v-5.2Z",
    transform: "translate(-852.739 -1590.184)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/Pattern.82ba4f2c867da9d2710c6854d93f11fb.svg";
export { ForwardRef as ReactComponent };